import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CardInfoTooltip from '../components/CardInfoTooltip';
import api from '../api';
import axios from 'axios';
import { LMS_BASE_URL, DEFAULT_TENANT_ID, LMS_JWT_TOKEN } from '../constants/lms';
import { jsPDF } from 'jspdf';
import './AdminDashboard.css';
import MultiSelectDropdown from '../components/MultiSelectDropdown';
import LMSCourseManager from '../components/admin/LMSCourseManager';
import CategoryManagement from '../components/CategoryManagement';
import LicensingManagement from '../components/admin/LicensingManagement';
import InstitutionFeaturePanel from '../components/InstitutionFeaturePanel';
import AdminServiceDesk from '../components/admin/AdminServiceDesk';
import AuditLogsPanel from '../components/admin/AuditLogsPanel';
import LMSQuestionBuilder from '../components/admin/LMSQuestionBuilder';
import LMSFeedbackAnalytics from '../components/admin/LMSFeedbackAnalytics';
import PlatformFeedbackTab from '../components/admin/PlatformFeedbackTab';
import AiCosting from '../components/AiCosting';
import UserInspectDrawer from '../components/admin/UserInspectDrawer';
import FeatureUsageTracker from '../components/admin/FeatureUsageTracker';
import { downloadRawFeedbackPdf } from '../utils/rawFeedbackPdfExport';
import { downloadRawFeedbackExcel } from '../utils/rawFeedbackExcelExport';
import RawFeedbackDownloadDropdown from '../components/admin/RawFeedbackDownloadDropdown';
import {
  Users,
  Building2,
  GraduationCap,
  MessageSquare,
  FileText,
  ShieldCheck,
  AlertTriangle,
  ChevronRight,
  ChevronLeft,
  Search,
  CheckCircle,
  XCircle,
  Flag,
  AlertCircle,
  Briefcase,
  FolderOpen,
  Calendar,
  Trash2,
  Ban,
  Mail,
  BookOpen,
  Cpu,
  LayoutDashboard,
  Activity,
  DollarSign,
  TrendingUp,
  Clock,
  PieChart,
  BarChart3,
  RefreshCw,
  Layers,
  Send,
  Info,
  Headset,
  Settings,
  X,
  Download,
  ClipboardList
} from 'lucide-react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showActiveUsersCard, setShowActiveUsersCard] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [directoryUsers, setDirectoryUsers] = useState([]);
  const [studentDirectory, setStudentDirectory] = useState([]);
  const [categorization, setCategorization] = useState({});
  const [dashboardOverview, setDashboardOverview] = useState(null);
  const [loadingOverview, setLoadingOverview] = useState(false);

  // Drill-Down State for Professors
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedYears, setSelectedYears] = useState(null);
  const [popSearchTerm, setPopSearchTerm] = useState('');
  const [approvalFilter, setApprovalFilter] = useState('ALL');

  // Modal State
  const [selectedUser, setSelectedUser] = useState(null);
  const [inspectUser, setInspectUser] = useState(null);

  const [accountsTab, setAccountsTab] = useState('requests'); // 'requests', 'all_pop', 'all_uni', 'all_student'
  const [deactivationRequests, setDeactivationRequests] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  // Feedback State
  const [feedbackList, setFeedbackList] = useState([]);
  const [feedbackTab, setFeedbackTab] = useState('lms');
  const [lmsFeedbacks, setLmsFeedbacks] = useState([]);
  const [lmsFeedbackOptions, setLmsFeedbackOptions] = useState({ universities: [], courses: [] });
  const [lmsSchema, setLmsSchema] = useState(null);
  const [lmsSchemaEditor, setLmsSchemaEditor] = useState('');
  const [lmsViewMode, setLmsViewMode] = useState('analytics');
  const [selectedLmsFeedback, setSelectedLmsFeedback] = useState(null);
  const [lmsSelectedCourse, setLmsSelectedCourse] = useState('All');
  const [lmsSelectedUniversity, setLmsSelectedUniversity] = useState('All');
  const [downloadingRawLms, setDownloadingRawLms] = useState(false);
  const [downloadingRawLmsExcel, setDownloadingRawLmsExcel] = useState(false);
  const [platformForms, setPlatformForms] = useState([]);
  const [editingPlatformForm, setEditingPlatformForm] = useState(null);
  const [showAddFormModal, setShowAddFormModal] = useState(false);
  const [newFormTitle, setNewFormTitle] = useState('');
  const [deleteFormTarget, setDeleteFormTarget] = useState(null);
  const [renameFormTarget, setRenameFormTarget] = useState(null);
  const [renameFormTitle, setRenameFormTitle] = useState('');
  const [newFormTargetUniversities, setNewFormTargetUniversities] = useState(['All Universities']);
  const [renameFormTargetUniversities, setRenameFormTargetUniversities] = useState(['All Universities']);
  const [courseForms, setCourseForms] = useState([]);
  const [editingCourseForm, setEditingCourseForm] = useState(null);
  const [showAddCourseFormModal, setShowAddCourseFormModal] = useState(false);
  const [newCourseFormTitle, setNewCourseFormTitle] = useState('');
  const [newCourseTargetUniversities, setNewCourseTargetUniversities] = useState(['All Universities']);
  const [deleteCourseFormTarget, setDeleteCourseFormTarget] = useState(null);
  const [renameCourseFormTarget, setRenameCourseFormTarget] = useState(null);
  const [renameCourseFormTitle, setRenameCourseFormTitle] = useState('');
  const [renameCourseTargetUniversities, setRenameCourseTargetUniversities] = useState(['All Universities']);

  // Moderation State
  const [moderationLogs, setModerationLogs] = useState([]);
  const [contentReports, setContentReports] = useState([]);
  const [moderationSubTab, setModerationSubTab] = useState('user_reports');

  // AI Analytics State
  const [aiAnalytics, setAiAnalytics] = useState(null);
  const [aiSearch, setAiSearch] = useState('');
  const [aiActiveTab, setAiActiveTab] = useState('minutes'); // 'minutes', 'tokens', 'settings'
  const [aiTokenViewTab, setAiTokenViewTab] = useState('students'); // 'students', 'universities'
  const [aiMinutesViewTab, setAiMinutesViewTab] = useState('students'); // 'students', 'universities'
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);

  // Toast notification state
  const [toasts, setToasts] = useState([]);

  // Settings State
  const [systemSettings, setSystemSettings] = useState({});
  const [isSavingSettings, setIsSavingSettings] = useState(false);

  // Confirmation modal state
  const [confirmModal, setConfirmModal] = useState({ show: false, id: null, type: 'user', contentType: null, contentId: null });
  const [rejectModal, setRejectModal] = useState({ show: false, requestId: null });
  const [rejectReason, setRejectReason] = useState("");

  // Broadcast Email State
  const [broadcastForm, setBroadcastForm] = useState({ roles: [], specific_emails: [], subject: '', message: '' });
  const [isSendingBroadcast, setIsSendingBroadcast] = useState(false);
  const [broadcastUserSearchTerm, setBroadcastUserSearchTerm] = useState('');

  // Email Logs State
  const [emailLogs, setEmailLogs] = useState([]);
  const [loadingEmailLogs, setLoadingEmailLogs] = useState(false);
  const [emailLogsPage, setEmailLogsPage] = useState(1);
  const [emailLogsSearch, setEmailLogsSearch] = useState('');

  const [showAddTokensModal, setShowAddTokensModal] = useState({ show: false, studentId: null, currentTokens: 0, extraTokens: 0, targetName: '' });
  const [addonTokensValue, setAddonTokensValue] = useState("");

  // Per-entity AI token limit (university-wise / student-wise) editor
  const [showTokenLimitModal, setShowTokenLimitModal] = useState({ show: false, targetId: null, targetName: '', currentLimit: null });
  const [tokenLimitValue, setTokenLimitValue] = useState("");
  const [clearTokenLimit, setClearTokenLimit] = useState(false);

  // Per-entity AI Agent (Beyond Presence) minute allocation editor
  const [showMinutesModal, setShowMinutesModal] = useState({ show: false, targetId: null, targetName: '', currentLimit: null, isUniversity: false });
  const [minutesLimitValue, setMinutesLimitValue] = useState("");
  const [clearMinutesLimit, setClearMinutesLimit] = useState(false);
  const [showAddMinutesModal, setShowAddMinutesModal] = useState({ show: false, targetId: null, targetName: '', currentExtra: 0, isUniversity: false });
  const [addonMinutesValue, setAddonMinutesValue] = useState("");

  // User Creation State
  const [createdUsers, setCreatedUsers] = useState([]);
  const [universitiesList, setUniversitiesList] = useState([]);
  const [newUserForm, setNewUserForm] = useState({
    full_name: '',
    email: '',
    password: '',
    role: 'support',
    department: '',
    university_ids: [],
    admin_dashboard_access: []
  });
  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [popSortConfig, setPopSortConfig] = useState({ key: null, direction: 'asc' });

  const navigate = useNavigate();

  // Toast notification helper
  const showToast = (message, type = 'success') => {
    let finalMessage = message;
    if (typeof message === 'object' && message !== null) {
      if (Array.isArray(message) && message.length > 0 && message[0].msg) {
        finalMessage = message.map(err => err.msg).join(', ');
      } else {
        try {
          finalMessage = JSON.stringify(message);
        } catch (e) {
          finalMessage = 'An error occurred';
        }
      }
    }
    const id = Date.now();
    setToasts(prev => [...prev, { id, message: String(finalMessage), type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 4000);
  };

  const [unreadChatCount, setUnreadChatCount] = useState(0);
  const [unreadTicketCount, setUnreadTicketCount] = useState(0);

  const fetchUnreadChatCount = async () => {
    try {
      const res = await api.get('/chat/unread-count');
      setUnreadChatCount(res.data.count || 0);
    } catch (err) {
      // silent catch
    }
  };

  const fetchUnreadTicketCount = async () => {
    try {
      const res = await api.get('/tickets/unread-count');
      setUnreadTicketCount(res.data.count || 0);
    } catch (err) {
      // silent catch
    }
  };

  const fetchDashboardOverview = async (isSilent = false) => {
    if (!isSilent) setLoadingOverview(true);
    try {
      const res = await api.get('/admin/dashboard-overview');
      setDashboardOverview(res.data);
    } catch (err) {
      console.error("Error fetching dashboard overview:", err);
    } finally {
      if (!isSilent) setLoadingOverview(false);
    }
  };

  useEffect(() => {
    // Initial fetch for sidebar counts & overview
    fetchPendingUsers();
    fetchModerationLogs();
    fetchDashboardOverview(false);
    fetchUnreadChatCount();
    fetchUnreadTicketCount();
    fetchUniversitiesList();

    const handleChatUpdate = () => fetchUnreadChatCount();
    window.addEventListener('chat_count_updated', handleChatUpdate);

    // Poll unread chat count every 60 seconds for live updates
    const chatInterval = setInterval(() => {
      fetchUnreadChatCount();
      fetchUnreadTicketCount();
    fetchUniversitiesList();
    }, 60000);

    return () => {
      window.removeEventListener('chat_count_updated', handleChatUpdate);
      clearInterval(chatInterval);
    };
  }, []);

  useEffect(() => {
    const loadTabData = (isSilent = false) => {
      if (activeTab === 'dashboard') fetchDashboardOverview(isSilent);
      else if (activeTab === 'pending') fetchPendingUsers();
      else if (activeTab === 'feedback') fetchFeedback();
      else if (activeTab === 'moderation') fetchModerationLogs();
      else if (activeTab === 'aianalytics') fetchAiAnalytics();
      else if (activeTab === 'email_logs') fetchEmailLogs();
      else if (activeTab === 'accounts' || activeTab === 'broadcast') fetchAccountData();
      else if (activeTab === 'students') fetchStudentDirectory();
      else if (activeTab === 'settings') fetchSettings();
      else if (['licensing', 'institution-features', 'service-desk', 'audit_logs', 'lms', 'feature-usage'].includes(activeTab)) {
        // Self-managed component tabs
      }
      else fetchDirectory();
    };

    loadTabData(false);

    // Live synchronization (polls every 60 seconds silently)
    const intervalId = setInterval(() => loadTabData(true), 60000);

    setSelectedDomain(null);
    setSelectedYears(null);
    setSelectedUser(null);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  useEffect(() => {
    if (aiActiveTab === 'settings') {
      fetchSettings();
    }
  }, [aiActiveTab]);

  const fetchAccountData = async () => {
    try {
      const [requestsRes, usersRes] = await Promise.all([
        api.get('/accounts/deactivation-requests?status=PENDING'),
        api.get('/accounts/all-users')
      ]);
      setDeactivationRequests(requestsRes.data);
      setAllUsers(usersRes.data);
    } catch (err) {
      // console.error('Failed to fetch account data:', err);
    }
  };

  // Fetch created users and universities list
  const fetchCreatedUsers = async () => {
    try {
      const res = await api.get('/admin/created-users');
      setCreatedUsers(res.data || []);
    } catch (err) {
      console.error('Failed to fetch created users:', err);
    }
  };

  const fetchUniversitiesList = async () => {
    try {
      const res = await api.get('/admin/universities/list');
      setUniversitiesList(res.data || []);
    } catch (err) {
      console.error('Failed to fetch universities list:', err);
    }
  };

  // Handle creating a new user
  const handleCreateUser = async () => {
    const nameVal = newUserForm.full_name.trim();
    if (!nameVal) {
      showToast('Please enter a name', 'error');
      return;
    }
    const nameRegex = /^[A-Za-z\s\-'.]+$/;
    if (!nameRegex.test(nameVal)) {
      showToast('Full name can only contain letters, spaces, dots, hyphens, and apostrophes', 'error');
      return;
    }
    if (!newUserForm.email.trim()) {
      showToast('Please enter an email', 'error');
      return;
    }
    if (!editingUserId && (!newUserForm.password || newUserForm.password.length < 8)) {
      showToast('Password must be at least 8 characters', 'error');
      return;
    }

    setIsCreatingUser(true);
    try {
      if (editingUserId) {
        const res = await api.put(`/admin/created-users/${editingUserId}/update`, newUserForm);
        showToast(res.data.message || 'User updated successfully!', 'success');
      } else {
        const res = await api.post('/admin/create-user', newUserForm);
        showToast(res.data.message || 'User created successfully!', 'success');
      }
      setNewUserForm({ full_name: '', email: '', password: '', role: 'support', department: '', university_ids: [], admin_dashboard_access: [] });
      setEditingUserId(null);
      fetchCreatedUsers();
    } catch (err) {
      showToast(err.response?.data?.detail || (editingUserId ? 'Failed to update user' : 'Failed to create user'), 'error');
    } finally {
      setIsCreatingUser(false);
    }
  };

  const handleEditClick = (user) => {
    setEditingUserId(user.id);
    setNewUserForm({
      full_name: user.name,
      email: user.email,
      password: '',
      role: user.role,
      department: user.department || '',
      university_ids: user.university_ids || [],
      admin_dashboard_access: user.admin_dashboard_access || []
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelEdit = () => {
    setEditingUserId(null);
    setNewUserForm({ full_name: '', email: '', password: '', role: 'support', department: '', university_ids: [], admin_dashboard_access: [] });
  };

  // Handle toggling user status
  const handleToggleCreatedUserStatus = async (userId) => {
    try {
      await api.put(`/admin/created-users/${userId}/toggle-status`);
      showToast('User status updated', 'success');
      fetchCreatedUsers();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to update status', 'error');
    }
  };

  // Handle deleting a created user
  const handleDeleteCreatedUser = async (userId) => {
    setConfirmModal({ show: true, id: userId, type: 'createdUser' });
  };

  const fetchEmailLogs = async () => {
    setLoadingEmailLogs(true);
    try {
      const response = await api.get('/admin/email-logs?limit=500');
      setEmailLogs(response.data || []);
      setEmailLogsPage(1);
    } catch (err) {
      showToast('Error fetching email logs', 'error');
    } finally {
      setLoadingEmailLogs(false);
    }
  };

  // Toggle university selection
  const toggleUniversity = (uniId) => {
    setNewUserForm(prev => {
      const currentIds = prev.university_ids || [];
      const newIds = currentIds.includes(uniId)
        ? currentIds.filter(id => id !== uniId)
        : [...currentIds, uniId];
      return { ...prev, university_ids: newIds };
    });
  };

  // Toggle admin dashboard access
  const toggleDashboardAccess = (tabId) => {
    setNewUserForm(prev => {
      const currentAccess = prev.admin_dashboard_access || [];
      const newAccess = currentAccess.includes(tabId)
        ? currentAccess.filter(id => id !== tabId)
        : [...currentAccess, tabId];
      return { ...prev, admin_dashboard_access: newAccess };
    });
  };

  // Generate random password
  const generatePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%';
    let password = '';
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setNewUserForm(prev => ({ ...prev, password }));
    setShowPassword(true);
    showToast('Random password generated', 'info');
  };

  const fetchSettings = async () => {
    try {
      const res = await api.get('/admin/settings');
      setSystemSettings(res.data);
    } catch (err) {
      console.error('Failed to fetch settings:', err);
    }
  };

  const handleSaveSetting = async (key, value) => {
    setIsSavingSettings(true);
    try {
      await api.post('/admin/settings', { setting_key: key, setting_value: value.toString() });
      showToast('Settings saved successfully', 'success');
      fetchSettings();
    } catch (err) {
      showToast('Failed to save settings', 'error');
    } finally {
      setIsSavingSettings(false);
    }
  };

  // Handle deactivation decision
  const handleDeactivationDecision = async (requestId, decision, notes = '') => {
    try {
      await api.put(`/accounts/deactivation-request/${requestId}/decide`, {
        decision,
        admin_notes: notes
      });
      showToast(`Request ${decision.toLowerCase()} successfully`, 'success');
      fetchAccountData();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to process request', 'error');
    }
  };

  const handleToggleStatus = async (userId) => {
    try {
      await api.put(`/accounts/user/${userId}/toggle-status`, { user_id: userId });
      showToast('User status updated successfully', 'success');
      fetchAccountData();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to toggle status', 'error');
    }
  };

  const handleDeactivateUniversity = async (userId) => {
    try {
      await api.put(`/admin/university/${userId}/deactivate`);
      showToast('University deactivated successfully', 'success');
      fetchAccountData();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to deactivate university', 'error');
    }
  };

  const handleReactivateUniversity = async (userId) => {
    try {
      await api.put(`/admin/university/${userId}/reactivate`);
      showToast('University reactivated successfully', 'success');
      fetchAccountData();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to reactivate university', 'error');
    }
  };

  const fetchPendingUsers = async () => {
    try {
      const res = await api.get('/admin/pending-details');
      setPendingUsers(res.data);
      const initialCats = {};
      res.data.forEach(u => {
        if (u.role === 'pop') {
          initialCats[u.id] = { domain: u.selected_domain || "", years: u.selected_seniority || 0 };
        }
      });
      setCategorization(initialCats);
    } catch (err) { /* silent error */ }
  };

  const fetchDirectory = async () => {
    try {
      const res = await api.get('/admin/directory');
      setDirectoryUsers(res.data);
    } catch (err) { /* silent error */ }
  };

  const fetchStudentDirectory = async () => {
    try {
      const res = await api.get('/university/students?status=all');
      setStudentDirectory(Array.isArray(res.data) ? res.data.map(student => ({
        ...student,
        role: 'student',
        details: student.full_name || student.email,
        extra_info: `${student.usn || 'No USN'} - ${student.department || student.branch || student.degree || 'No department'}`
      })) : []);
    } catch (err) {
      showToast(err.response?.data?.detail || 'Unable to load students', 'error');
      setStudentDirectory([]);
    }
  };

  const handleFlag = async (userId) => {
    try {
      await api.put(`/admin/${userId}/flag`);
      const updateList = (list) => list.map(u => u.id === userId ? { ...u, is_flagged: !u.is_flagged } : u);
      setPendingUsers(updateList(pendingUsers));
      setDirectoryUsers(updateList(directoryUsers));
      if (selectedUser && selectedUser.id === userId) {
        setSelectedUser(prev => ({ ...prev, is_flagged: !prev.is_flagged }));
      }
      showToast('User flag status updated', 'success');
    } catch (err) {
      showToast('Error flagging user', 'error');
    }
  };

  const handleReject = async (userId) => {
    setConfirmModal({ show: true, id: userId, type: 'user' });
  };

  const confirmDelete = async () => {
    const { id, type, contentType, contentId } = confirmModal;
    setConfirmModal({ show: false, id: null, type: 'user', contentType: null, contentId: null });

    if (type === 'content') {
      try {
        await api.delete(`/admin/moderation/content/${contentType}/${contentId}`);
        showToast(`Reported ${contentType} removed successfully`, 'success');
        fetchModerationLogs();
      } catch (err) {
        showToast(`Failed to remove ${contentType}`, 'error');
      }
      return;
    }

    if (type === 'log') {
      try {
        await api.delete(`/admin/moderation/logs/${id}`);
        showToast("Log deleted successfully", 'success');
        fetchModerationLogs();
      } catch (err) {
        showToast("Error deleting log", 'error');
      }
      return;
    }

    if (type === 'createdUser') {
      try {
        await api.delete(`/admin/created-users/${id}`);
        showToast('User deleted successfully', 'success');
        fetchCreatedUsers();
      } catch (err) {
        showToast(err.response?.data?.detail || 'Failed to delete user', 'error');
      }
      return;
    }

    // Default: Delete User
    try {
      await api.delete(`/admin/${id}/reject`);
      activeTab === 'pending' ? fetchPendingUsers() : fetchDirectory();
      setSelectedUser(null);
      showToast('User deleted successfully', 'success');
    } catch (err) {
      // console.error(err);
      showToast(err.response?.data?.detail || "Error deleting user", 'error');
    }
  };

  const handleApprove = async (userId) => {
    const userCat = categorization[userId] || {};
    const user = pendingUsers.find(u => u.id === userId);

    if (user.role === 'pop' && (!userCat.domain || !userCat.years)) {
      showToast("Please select a Domain and Years of Experience before approving.", 'error');
      return;
    }

    try {
      await api.put(`/admin/${userId}/verify`, {
        domain: userCat.domain || "General",
        years_of_experience: parseInt(userCat.years) || 15
      });
      let lmsSynced = false;
      // --- AUTOMATIC LMS ONBOARDING ON APPROVAL ---
      if (user.role === 'pop') {
        try {
          const lmsPayload = {
            name: user.details,
            email: user.email,
            phone: user.phone_number || "9876543210",
            department_id: "cd23fbb8-d130-4d75-b29b-c3c2d2f2d9a9",
            roles: ["course-instructor", "course-coordinator"]
          };

          console.log("ON-APPROVAL-ONBOARD: Syncing with EdVergenceX...");
          const LMS_URL = `${LMS_BASE_URL}/external/edventurex/tenants/${DEFAULT_TENANT_ID}/pops`;
          await axios.post(LMS_URL, lmsPayload, {
            headers: {
              Authorization: `Bearer ${LMS_JWT_TOKEN}`
            }
          });
          console.log("ON-APPROVAL-ONBOARD: Success");
          lmsSynced = true;
        } catch (lmsErr) {
          console.error("ON-APPROVAL-ONBOARD: Failed to sync with LMS", lmsErr);
        }
      }

      if (user.role === 'pop') {
        if (lmsSynced) {
          showToast("User Approved and Synced to LMS!", 'success');
        } else {
          showToast("User Approved, but LMS Sync Failed.", 'warning');
        }
      } else {
        showToast("User Approved and Categorized!", 'success');
      }

      fetchPendingUsers();
      fetchDirectory();
    } catch (err) {
      showToast("Error approving user", 'error');
    }
  };

  const fetchFeedback = async () => {
    // Keep Target University dropdowns populated even if the mount-time fetch failed
    fetchUniversitiesList();
    try {
      const res = await api.get('/feedback/admin/all');
      setFeedbackList(res.data || []);
      
      const lmsRes = await api.get('/admin/lms/feedbacks');
      setLmsFeedbacks(lmsRes.data || []);

      // Universities/courses with batch assignments (even without submissions)
      // so the feedback filters aren't limited to universities that already
      // have feedback rows.
      try {
        const optsRes = await api.get('/admin/lms/feedback/options');
        setLmsFeedbackOptions({
          universities: optsRes.data?.universities || [],
          courses: optsRes.data?.courses || []
        });
      } catch (e) { /* keep feedback-derived options on failure */ }

      const pfRes = await api.get('/admin/lms/platform-feedback/forms');
      setPlatformForms(pfRes.data || []);
      
      const cfRes = await api.get('/admin/lms/course-feedback/forms');
      setCourseForms(cfRes.data || []);
    } catch (err) {
      // console.error("Error fetching feedback:", err);
    }
  };

  // Universities/courses offered for feedback filtering: assignment-derived
  // options (all assigned) UNION those already present in submissions.
  const lmsUniversityOptions = [...new Set([
    ...(lmsFeedbackOptions.universities || []),
    ...lmsFeedbacks.map(f => f.university_name)
  ])].filter(Boolean).sort();

  const lmsCourseOptions = (() => {
    const titleById = Object.fromEntries(
      (lmsFeedbackOptions.courses || []).map(c => [c.course_id, c.title])
    );
    const ids = [...new Set([
      ...lmsFeedbacks.map(f => f.course_id),
      ...(lmsFeedbackOptions.courses || []).map(c => c.course_id)
    ])].filter(Boolean);
    return ids.map(cid => {
      const feedback = lmsFeedbacks.find(f => f.course_id === cid);
      return { id: cid, label: feedback?.course_name || titleById[cid] || cid };
    });
  })();

  const handleDownloadRawLmsReport = async () => {
    const hasFeedbackContent = (obj) => {
      if (!obj) return false;
      if (typeof obj === 'string') {
        try {
          const parsed = JSON.parse(obj);
          return parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0;
        } catch (_) {
          return false;
        }
      }
      return typeof obj === 'object' && Object.keys(obj).length > 0;
    };

    const courseFeedbacksOnly = lmsFeedbacks.filter(f => {
      const isPlatformOnly = f.form_id && String(f.form_id).startsWith('platform_feedback');
      if (isPlatformOnly && !hasFeedbackContent(f.module_feedback)) return false;
      return true;
    });

    const filtered = courseFeedbacksOnly.filter(f => 
      (lmsSelectedCourse === 'All' || f.course_id === lmsSelectedCourse || f.form_id === lmsSelectedCourse) &&
      (lmsSelectedUniversity === 'All' || f.university_name === lmsSelectedUniversity)
    );
    if (!filtered || filtered.length === 0) {
      showToast(lmsSelectedUniversity !== 'All' 
        ? `No LMS raw feedback data found for ${lmsSelectedUniversity}.`
        : 'No LMS raw feedback data found for the selected filter.', 
        'info'
      );
      return;
    }
    setDownloadingRawLms(true);
    try {
      const courseLabel = lmsSelectedCourse !== 'All' 
        ? (lmsCourseOptions.find(c => c.id === lmsSelectedCourse)?.label || lmsSelectedCourse)
        : null;

      await downloadRawFeedbackPdf({
        feedbacks: filtered,
        reportType: 'lms',
        universityName: lmsSelectedUniversity,
        courseName: courseLabel,
        courseForms,
        platformForms,
        lmsSchema
      });
      showToast('LMS Raw Feedback Report downloaded successfully.');
    } catch (err) {
      console.error('Error generating raw LMS feedback PDF:', err);
      showToast('Failed to generate PDF report. Please try again.', 'error');
    } finally {
      setDownloadingRawLms(false);
    }
  };

  const handleDownloadRawLmsExcel = async () => {
    const hasFeedbackContent = (obj) => {
      if (!obj) return false;
      if (typeof obj === 'string') {
        try {
          const parsed = JSON.parse(obj);
          return parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0;
        } catch (_) {
          return false;
        }
      }
      return typeof obj === 'object' && Object.keys(obj).length > 0;
    };

    const courseFeedbacksOnly = lmsFeedbacks.filter(f => {
      const isPlatformOnly = f.form_id && String(f.form_id).startsWith('platform_feedback');
      if (isPlatformOnly && !hasFeedbackContent(f.module_feedback)) return false;
      return true;
    });

    const filtered = courseFeedbacksOnly.filter(f => 
      (lmsSelectedCourse === 'All' || f.course_id === lmsSelectedCourse || f.form_id === lmsSelectedCourse) &&
      (lmsSelectedUniversity === 'All' || f.university_name === lmsSelectedUniversity)
    );
    if (!filtered || filtered.length === 0) {
      showToast(lmsSelectedUniversity !== 'All' 
        ? `No LMS raw feedback data found for ${lmsSelectedUniversity}.`
        : 'No LMS raw feedback data found for the selected filter.', 
        'info'
      );
      return;
    }
    setDownloadingRawLmsExcel(true);
    try {
      const courseLabel = lmsSelectedCourse !== 'All' 
        ? (lmsCourseOptions.find(c => c.id === lmsSelectedCourse)?.label || lmsSelectedCourse)
        : null;

      await downloadRawFeedbackExcel({
        feedbacks: filtered,
        reportType: 'lms',
        universityName: lmsSelectedUniversity,
        courseName: courseLabel,
        courseForms,
        platformForms,
        lmsSchema
      });
      showToast('LMS Raw Feedback Excel sheet downloaded successfully.');
    } catch (err) {
      console.error('Error generating raw LMS feedback Excel:', err);
      showToast('Failed to generate Excel report. Please try again.', 'error');
    } finally {
      setDownloadingRawLmsExcel(false);
    }
  };

  const handleDownloadFeedbackForm = (form, formType) => {
    try {
      const doc = new jsPDF({ unit: 'pt', format: 'a4' });
      const PAGE_MARGIN = 40;
      let y = PAGE_MARGIN;
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text(form.title || 'Feedback Form', pageWidth / 2, y, { align: 'center' });
      y += 30;

      doc.setFontSize(12);
      doc.setTextColor(100, 100, 100);
      doc.text(`Type: ${formType === 'course' ? 'Course Feedback' : 'Platform Feedback'}`, PAGE_MARGIN, y);
      y += 20;

      const targets = Array.isArray(form.target_universities) ? form.target_universities.join(', ') : (form.target_universities || 'All Universities');
      doc.text(`Target Universities: ${targets}`, PAGE_MARGIN, y);
      y += 30;

      doc.setTextColor(0, 0, 0);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);

      if (form.questions && form.questions.length > 0) {
        form.questions.forEach((q, index) => {
          if (y > doc.internal.pageSize.getHeight() - 60) {
            doc.addPage();
            y = PAGE_MARGIN;
          }
          const qText = `${index + 1}. ${q.text || 'Untitled Question'}`;
          const lines = doc.splitTextToSize(qText, pageWidth - 2 * PAGE_MARGIN);
          doc.text(lines, PAGE_MARGIN, y);
          y += lines.length * 15;

          if (q.type === 'rating') {
             y += 10;
             doc.setTextColor(150, 150, 150);
             doc.text('(Rating 1 to 5)', PAGE_MARGIN + 15, y);
             doc.setTextColor(0, 0, 0);
             y += 20;
          } else if (q.type === 'text') {
             y += 10;
             doc.setDrawColor(200, 200, 200);
             doc.rect(PAGE_MARGIN + 15, y, pageWidth - 2 * PAGE_MARGIN - 30, 40);
             y += 60;
          } else {
             y += 20;
          }
        });
      } else {
        doc.text('No questions found in this form.', PAGE_MARGIN, y);
      }

      doc.save(`${form.title ? form.title.replace(/\s+/g, '_') : 'feedback_form'}.pdf`);
      showToast('PDF downloaded successfully', 'success');
    } catch (err) {
      console.error(err);
      showToast('Failed to generate PDF', 'error');
    }
  };

  const handleToggleFormStatus = async (form) => {
    if (!Array.isArray(form.target_universities) || form.target_universities.length === 0) {
      showToast("Select at least one target university for this form", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/platform-feedback/forms/${form.id}`, {
        title: form.title,
        is_active: !form.is_active,
        questions: form.questions,
        target_universities: form.target_universities || ['All Universities']
      });
      showToast("Status updated successfully", "success");
      fetchFeedback();
    } catch (err) {
      showToast("Failed to update status", "error");
    }
  };

  // Stable references so the question builder doesn't reset while the admin is
  // editing (the dashboard re-renders on its 60s poll cycle).
  const courseFormEditorSchema = useMemo(() => ({
    module_feedback: editingCourseForm?.questions || []
  }), [editingCourseForm?.id, editingCourseForm?.questions]);

  const platformFormEditorSchema = useMemo(() => ({
    platform_feedback: editingPlatformForm?.questions || []
  }), [editingPlatformForm?.id, editingPlatformForm?.questions]);

  // Publish a draft form — only published forms are sent to students.
  const handlePublishPlatformForm = async (form) => {
    if (!form.questions || form.questions.length === 0) {
      showToast("Add questions to this form before publishing", "error");
      return;
    }
    if (!Array.isArray(form.target_universities) || form.target_universities.length === 0) {
      showToast("Select at least one target university for this form", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/platform-feedback/forms/${form.id}`, {
        title: form.title,
        is_active: true,
        status: 'published',
        questions: form.questions,
        target_universities: form.target_universities || ['All Universities']
      });
      showToast("Form published — assigned universities notified and visible to students", "success");
      fetchFeedback();
    } catch (err) {
      showToast("Failed to publish form", "error");
    }
  };

  const handleAddPlatformForm = async () => {
    if (!newFormTitle.trim()) {
      showToast("Form title cannot be empty", "error");
      return;
    }
    try {
      await api.post('/admin/lms/platform-feedback/forms', {
        title: newFormTitle,
        is_active: false,
        questions: [
          {
            id: `q_${Date.now().toString().slice(-6)}`,
            type: "rating",
            text: "How would you rate your experience with the platform? (1 = poor -> 5 = excellent)"
          }
        ],
        target_universities: newFormTargetUniversities
      });
      showToast("Form saved as draft. Edit it and click Publish to send it to students.", "success");
      setNewFormTitle('');
      setNewFormTargetUniversities(['All Universities']);
      setShowAddFormModal(false);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to create form", "error");
    }
  };

  const handleDeletePlatformForm = (form) => {
    setDeleteFormTarget(form);
  };

  const handleConfirmDeleteForm = async () => {
    if (!deleteFormTarget) return;
    try {
      await api.delete(`/admin/lms/platform-feedback/forms/${deleteFormTarget.id}`);
      showToast("Form deleted successfully", "success");
      setDeleteFormTarget(null);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to delete form", "error");
    }
  };

  const handleSavePlatformFormQuestions = async (newSchemaObj) => {
    if (!editingPlatformForm) return;
    try {
      const questions = newSchemaObj.platform_feedback || [];
      if (questions.length === 0 && (editingPlatformForm.questions || []).length > 0) {
        const confirmed = window.confirm('The editor has no questions. Saving will remove all questions from this form. Continue?');
        if (!confirmed) return;
      }
      await api.put(`/admin/lms/platform-feedback/forms/${editingPlatformForm.id}`, {
        title: editingPlatformForm.title,
        is_active: editingPlatformForm.is_active,
        questions: questions,
        target_universities: editingPlatformForm.target_universities || ['All Universities']
      });
      showToast("Questions saved successfully", "success");
      setEditingPlatformForm(null);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to save questions", "error");
    }
  };

  const handleEditFormTitle = (form) => {
    fetchUniversitiesList();
    setRenameFormTarget(form);
    setRenameFormTitle(form.title);
    setRenameFormTargetUniversities(form.target_universities || ['All Universities']);
  };

  const handleSaveRenameForm = async () => {
    if (!renameFormTarget) return;
    if (!renameFormTitle.trim()) {
      showToast("Form title cannot be empty", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/platform-feedback/forms/${renameFormTarget.id}`, {
        title: renameFormTitle,
        is_active: renameFormTarget.is_active,
        questions: renameFormTarget.questions,
        target_universities: renameFormTargetUniversities
      });
      showToast("Title updated successfully", "success");
      setRenameFormTarget(null);
      setRenameFormTitle('');
      fetchFeedback();
    } catch (err) {
      showToast("Failed to update title", "error");
    }
  };

  const handleSaveLmsSchema = async (newSchemaObj) => {
    try {
      const parsed = newSchemaObj && typeof newSchemaObj === 'object' 
        ? newSchemaObj 
        : JSON.parse(lmsSchemaEditor);
      await api.put('/admin/lms/feedback/schema', { schema_json: parsed });
      setLmsSchema(parsed);
      setLmsSchemaEditor(JSON.stringify(parsed, null, 2));
      showToast("Schema saved successfully", 'success');
    } catch (e) {
      showToast("Invalid JSON schema", 'error');
    }
  };

  const handleToggleCourseFormStatus = async (form) => {
    if (!Array.isArray(form.target_universities) || form.target_universities.length === 0) {
      showToast("Select at least one target university for this form", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/course-feedback/forms/${form.id}`, {
        title: form.title,
        is_active: !form.is_active,
        questions: form.questions,
        target_universities: form.target_universities || ['All Universities']
      });
      showToast("Course form status updated", "success");
      fetchFeedback();
    } catch (err) {
      showToast("Failed to update status", "error");
    }
  };

  // Publish a draft form — only published forms are sent to students.
  const handlePublishCourseForm = async (form) => {
    if (!form.questions || form.questions.length === 0) {
      showToast("Add questions to this form before publishing", "error");
      return;
    }
    if (!Array.isArray(form.target_universities) || form.target_universities.length === 0) {
      showToast("Select at least one target university for this form", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/course-feedback/forms/${form.id}`, {
        title: form.title,
        is_active: true,
        status: 'published',
        questions: form.questions,
        target_universities: form.target_universities || ['All Universities']
      });
      showToast("Form published — assigned universities notified and visible to students", "success");
      fetchFeedback();
    } catch (err) {
      showToast("Failed to publish form", "error");
    }
  };

  const handleAddCourseForm = async () => {
    if (!newCourseFormTitle.trim()) {
      showToast("Form title cannot be empty", "error");
      return;
    }
    try {
      await api.post('/admin/lms/course-feedback/forms', {
        title: newCourseFormTitle,
        is_active: false,
        questions: [
          {
            id: `q_${Date.now().toString().slice(-6)}`,
            type: "rating",
            text: "How would you rate your learning experience in this course? (1 = poor -> 5 = excellent)"
          }
        ],
        target_universities: newCourseTargetUniversities
      });
      showToast("Form saved as draft. Edit it and click Publish to send it to students.", "success");
      setNewCourseFormTitle('');
      setNewCourseTargetUniversities(['All Universities']);
      setShowAddCourseFormModal(false);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to create course form", "error");
    }
  };

  const handleDeleteCourseForm = (form) => setDeleteCourseFormTarget(form);
  const handleConfirmDeleteCourseForm = async () => {
    if (!deleteCourseFormTarget) return;
    try {
      await api.delete(`/admin/lms/course-feedback/forms/${deleteCourseFormTarget.id}`);
      showToast("Course form deleted", "success");
      setDeleteCourseFormTarget(null);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to delete form", "error");
    }
  };

  const handleSaveCourseFormQuestions = async (newSchemaObj) => {
    if (!editingCourseForm) return;
    try {
      const questions = newSchemaObj.module_feedback || newSchemaObj.course_feedback || [];
      if (questions.length === 0 && (editingCourseForm.questions || []).length > 0) {
        const confirmed = window.confirm('The editor has no questions. Saving will remove all questions from this form. Continue?');
        if (!confirmed) return;
      }
      await api.put(`/admin/lms/course-feedback/forms/${editingCourseForm.id}`, {
        title: editingCourseForm.title,
        is_active: editingCourseForm.is_active,
        questions: questions,
        target_universities: editingCourseForm.target_universities || ['All Universities']
      });
      showToast("Course questions saved", "success");
      setEditingCourseForm(null);
      fetchFeedback();
    } catch (err) {
      showToast("Failed to save questions", "error");
    }
  };

  const handleEditCourseFormTitle = (form) => {
    fetchUniversitiesList();
    setRenameCourseFormTarget(form);
    setRenameCourseFormTitle(form.title);
    setRenameCourseTargetUniversities(form.target_universities || ['All Universities']);
  };

  const handleSaveRenameCourseForm = async () => {
    if (!renameCourseFormTarget) return;
    if (!renameCourseFormTitle.trim()) {
      showToast("Form title cannot be empty", "error");
      return;
    }
    try {
      await api.put(`/admin/lms/course-feedback/forms/${renameCourseFormTarget.id}`, {
        title: renameCourseFormTitle,
        is_active: renameCourseFormTarget.is_active,
        questions: renameCourseFormTarget.questions,
        target_universities: renameCourseTargetUniversities
      });
      showToast("Course form updated", "success");
      setRenameCourseFormTarget(null);
      setRenameCourseFormTitle('');
      fetchFeedback();
    } catch (err) {
      showToast("Failed to update course form", "error");
    }
  };

  const fetchModerationLogs = async () => {
    try {
      const [logsRes, reportsRes] = await Promise.all([
        api.get('/admin/moderation/logs'),
        api.get('/admin/moderation/reports')
      ]);
      setModerationLogs(logsRes.data || []);
      setContentReports(reportsRes.data || []);
    } catch (err) {
      // console.error("Error fetching moderation logs:", err);
    }
  };

  const handleUpdateReportStatus = async (reportId, newStatus) => {
    try {
      await api.put(`/admin/moderation/reports/${reportId}/status?status=${newStatus}`);
      showToast(`Report status updated to ${newStatus}`, 'success');
      fetchModerationLogs();
    } catch (err) {
      showToast('Failed to update report status', 'error');
    }
  };

  const handleDeleteReport = async (reportId) => {
    try {
      await api.delete(`/admin/moderation/reports/${reportId}`);
      showToast('Report deleted', 'success');
      fetchModerationLogs();
    } catch (err) {
      showToast('Failed to delete report', 'error');
    }
  };

  const handleDeleteReportedContent = (contentType, contentId) => {
    setConfirmModal({ show: true, id: null, type: 'content', contentType, contentId });
  };

  const fetchAiAnalytics = async () => {
    try {
      const res = await api.get('/admin/ai-analytics', { params: { _t: Date.now() } });
      setAiAnalytics(res.data);
    } catch (err) {
      console.error("Error fetching AI analytics:", err);
    }
  };

  const handleResetAiTokens = async (studentId) => {
    try {
      const res = await api.put(`/admin/ai-analytics/${studentId}/tokens/reset`);
      showToast(res.data?.message || 'Tokens reset successfully', 'success');
      await fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to reset tokens', 'error');
    }
  };

  const handleAddAiTokens = async () => {
    const { studentId } = showAddTokensModal;
    const tokens = parseInt(addonTokensValue);
    if (!tokens || tokens <= 0) {
      showToast("Please enter a valid number of tokens.", "error");
      return;
    }
    try {
      await api.put(`/admin/ai-analytics/${studentId}/tokens/add`, { addon_tokens: tokens });
      showToast(`Added ${tokens} tokens successfully`, 'success');
      setShowAddTokensModal({ show: false, studentId: null, currentTokens: 0, extraTokens: 0, targetName: '' });
      setAddonTokensValue("");
      fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to add tokens', 'error');
    }
  };

  const handleSetAiTokenLimit = async () => {
    const { targetId } = showTokenLimitModal;
    if (!clearTokenLimit) {
      const limit = parseInt(tokenLimitValue, 10);
      if (!tokenLimitValue.trim() || isNaN(limit) || limit < 0) {
        showToast("Please enter a valid non-negative token limit.", "error");
        return;
      }
      if (limit === 0) {
        showToast("A limit of 0 blocks ALL AI usage for this target. Use 'Clear override' instead if you want it to inherit.", "warning");
      }
      try {
        await api.put(`/admin/ai-analytics/${targetId}/tokens/limit`, { ai_token_limit: limit });
        showToast(`Token limit set to ${limit.toLocaleString()} successfully`, 'success');
      } catch (err) {
        showToast(err.response?.data?.detail || 'Failed to set token limit', 'error');
      }
    } else {
      try {
        await api.put(`/admin/ai-analytics/${targetId}/tokens/limit`, { ai_token_limit: null });
        showToast('Token limit override cleared — inherits next level up', 'success');
      } catch (err) {
        showToast(err.response?.data?.detail || 'Failed to clear token limit', 'error');
      }
    }
    setShowTokenLimitModal({ show: false, targetId: null, targetName: '', currentLimit: null });
    setTokenLimitValue("");
    setClearTokenLimit(false);
    fetchAiAnalytics();
  };

  const handleResetAiMinutes = async (targetId) => {
    try {
      const res = await api.put(`/admin/ai-analytics/${targetId}/minutes/reset`);
      showToast(res.data?.message || 'Minutes reset successfully', 'success');
      await fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to reset minutes', 'error');
    }
  };

  const handleAddAiMinutes = async () => {
    const { targetId } = showAddMinutesModal;
    const minutes = parseInt(addonMinutesValue, 10);
    if (!minutes || minutes <= 0) {
      showToast('Please enter a valid number of minutes.', 'error');
      return;
    }
    try {
      await api.put(`/admin/ai-analytics/${targetId}/minutes/add`, { addon_minutes: minutes });
      showToast(`Added ${minutes} minutes successfully`, 'success');
      setShowAddMinutesModal({ show: false, targetId: null, targetName: '', currentExtra: 0, isUniversity: false });
      setAddonMinutesValue("");
      fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to add minutes', 'error');
    }
  };

  const handleSetAiMinutesLimit = async () => {
    const { targetId } = showMinutesModal;
    if (!clearMinutesLimit) {
      const limit = parseInt(minutesLimitValue, 10);
      if (!minutesLimitValue.trim() || isNaN(limit) || limit < 0) {
        showToast('Please enter a valid non-negative minute limit.', 'error');
        return;
      }
      if (limit === 0) {
        showToast("A limit of 0 blocks ALL AI Agent usage for this target. Use 'Clear override' instead if you want it to inherit.", 'warning');
      }
      try {
        await api.put(`/admin/ai-analytics/${targetId}/minutes/limit`, { ai_agent_minutes_limit: limit });
        showToast(`Minute limit set to ${limit.toLocaleString()} successfully`, 'success');
      } catch (err) {
        showToast(err.response?.data?.detail || 'Failed to set minute limit', 'error');
      }
    } else {
      try {
        await api.put(`/admin/ai-analytics/${targetId}/minutes/limit`, { ai_agent_minutes_limit: null });
        showToast('Minute limit override cleared — inherits next level up', 'success');
      } catch (err) {
        showToast(err.response?.data?.detail || 'Failed to clear minute limit', 'error');
      }
    }
    setShowMinutesModal({ show: false, targetId: null, targetName: '', currentLimit: null, isUniversity: false });
    setMinutesLimitValue("");
    setClearMinutesLimit(false);
    fetchAiAnalytics();
  };

  const handleBulkResetAiUsage = async (studentIds) => {
    showToast(`Resetting AI usage for ${studentIds.length} students...`, 'info');
    try {
      await api.put(`/admin/ai-analytics/bulk-reset`, { student_ids: studentIds });
      showToast(`Usage reset successfully for ${studentIds.length} students`, 'success');
      fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to bulk reset usage', 'error');
    }
  };

  const handleBulkResetAiTokens = async (studentIds) => {
    showToast(`Resetting AI tokens for ${studentIds.length} students...`, 'info');
    try {
      const res = await api.put(`/admin/ai-analytics/bulk-reset-tokens`, { student_ids: studentIds });
      const resetCount = res.data?.reset_count || 0;
      showToast(`Tokens reset successfully for ${resetCount} students`, 'success');
      await fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to bulk reset tokens', 'error');
    }
  };

  const handleBulkResetAiTokensForBatch = async (institution, batch) => {
    showToast(`Resetting AI tokens for batch ${batch}...`, 'info');
    try {
      const res = await api.put(`/admin/ai-analytics/batch/reset-tokens`, { institution, batch });
      const resetCount = res.data?.reset_count ?? 0;
      if (resetCount === 0) {
        showToast(`No students matched for batch "${batch}". Please verify the batch name.`, 'warning');
      } else {
        showToast(res.data?.message || `Tokens reset successfully for ${resetCount} students`, 'success');
      }
      await fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to reset batch tokens', 'error');
    }
  };

  const handleBulkResetAiUsageForBatch = async (institution, batch) => {
    showToast(`Resetting AI usage for batch ${batch}...`, 'info');
    try {
      const res = await api.put(`/admin/ai-analytics/batch/reset-usage`, { institution, batch });
      const resetCount = res.data?.reset_count ?? 0;
      if (resetCount === 0) {
        showToast(`No students matched for batch "${batch}". Please verify the batch name.`, 'warning');
      } else {
        showToast(res.data?.message || `Usage reset successfully for ${resetCount} students`, 'success');
      }
      await fetchAiAnalytics();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Failed to reset batch usage', 'error');
    }
  };

  const handleReviewLog = async (logId) => {
    try {
      await api.put(`/admin/moderation/logs/${logId}/review`);
      showToast("Log marked as reviewed", 'success');
      fetchModerationLogs();
    } catch (err) {
      showToast("Error updating log", 'error');
    }
  };

  const handleDeleteLog = (logId) => {
    setConfirmModal({ show: true, id: logId, type: 'log' });
  };


  // --- RENDERERS ---

  const renderPopTable = (users) => {
    const sortedUsers = [...users].sort((a, b) => {
      if (!popSortConfig.key) return 0;
      if (popSortConfig.key === 'experience') {
        const valA = parseInt(a.years_of_experience) || 0;
        const valB = parseInt(b.years_of_experience) || 0;
        return popSortConfig.direction === 'asc' ? valA - valB : valB - valA;
      }
      return 0;
    });

    const requestSort = (key) => {
      let direction = 'asc';
      if (popSortConfig.key === key && popSortConfig.direction === 'asc') {
        direction = 'desc';
      }
      setPopSortConfig({ key, direction });
    };

    return (
      <div className="admin-data-table-container glass-card" style={{ overflowX: 'auto', background: 'var(--graphite)', borderRadius: '12px', border: '1px solid var(--admin-border)', padding: '0' }}>
        <table className="admin-data-table" style={{ margin: '0' }}>
          <thead>
            <tr>
              <th style={{ padding: '1.25rem 1.5rem' }}>Professor Details</th>
              <th style={{ padding: '1.25rem 1rem' }}>Contact</th>
              <th 
                style={{ padding: '1.25rem 1rem', cursor: 'pointer', userSelect: 'none' }}
                onClick={() => requestSort('experience')}
              >
                Experience {popSortConfig.key === 'experience' ? (popSortConfig.direction === 'asc' ? '↑' : '↓') : '↕'}
              </th>
              <th style={{ padding: '1.25rem 1rem' }}>Expertise</th>
              <th style={{ padding: '1.25rem 1rem' }}>Status</th>
              <th style={{ padding: '1.25rem 1.5rem' }}></th>
            </tr>
          </thead>
          <tbody>
            {sortedUsers.map(user => (
              <tr 
                key={user.id} 
                className={user.is_flagged ? 'admin-flagged-row' : ''}
                style={{ cursor: 'pointer', transition: 'background 0.2s', borderBottom: '1px solid rgba(245, 247, 250, 0.06)' }}
                onClick={() => navigate(`/admin/professor/${user.id}`)}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(25, 211, 255, 0.05)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <td style={{ padding: '1.25rem 1.5rem' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <span className="admin-badge admin-badge-purple">POP</span>
                    {user.is_flagged && <Flag size={14} className="text-red-500" />}
                  </div>
                  <div className="font-semibold" style={{ fontSize: '1.05rem', color: 'var(--admin-text-main)' }}>
                    {user.details || user.full_name}
                  </div>
                </td>
                <td style={{ padding: '1.25rem 1rem', color: 'var(--admin-text-muted)', fontSize: '0.9rem' }}>
                  {user.email}
                </td>
                <td style={{ padding: '1.25rem 1rem' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--admin-text-main)', fontSize: '0.9rem', fontWeight: '500' }}>
                      <Briefcase size={16} style={{ color: 'var(--admin-text-muted)', minWidth: '16px' }} />
                      <span>{user.years_of_experience} Years</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--admin-text-main)', fontSize: '0.9rem', fontWeight: '500' }}>
                      <FolderOpen size={16} style={{ color: 'var(--admin-text-muted)', minWidth: '16px' }} />
                      <span>{user.domain}</span>
                    </div>
                    {user.extra_info && (
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', color: 'var(--admin-text-muted)', fontSize: '0.85rem' }}>
                        <div style={{ width: '16px', minWidth: '16px' }}></div>
                        <span>{user.extra_info}</span>
                      </div>
                    )}
                  </div>
                </td>
                <td style={{ padding: '1.25rem 1rem' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '0.8rem', color: 'var(--admin-text-muted)' }}>
                    {user.expertise_category && <div><strong style={{ color: 'var(--admin-text-main)' }}>Cat:</strong> {user.expertise_category}</div>}
                    {user.expertise_subcategory && <div><strong style={{ color: 'var(--admin-text-main)' }}>Sub:</strong> {user.expertise_subcategory}</div>}
                    {user.expertise_core && <div><strong style={{ color: 'var(--admin-text-main)' }}>Core:</strong> {user.expertise_core}</div>}
                    {(!user.expertise_category && !user.expertise_subcategory && !user.expertise_core) && <span>-</span>}
                  </div>
                </td>
                <td style={{ padding: '1.25rem 1rem' }}>
                  {(user.vetting_status !== "APPROVED" || user.kyc_status !== "ACCEPTED" || user.coi_status !== "SIGNED") ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.8rem', fontWeight: '600', color: 'var(--admin-warning)' }}>
                        <AlertTriangle size={12} /> Pending
                      </div>
                      <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                        {user.vetting_status !== "APPROVED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>Vetting</span>}
                        {user.kyc_status !== "ACCEPTED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>KYC</span>}
                        {user.coi_status !== "SIGNED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>COI</span>}
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: 'var(--admin-success)', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.85rem', fontWeight: '600' }}>
                      <CheckCircle size={14} /> Approved
                    </div>
                  )}
                  {user.violation_count > 0 && (
                    <div className="admin-violation-badge" style={{ marginTop: '8px' }}>
                      <AlertTriangle size={12} /> Violations: {user.violation_count}
                    </div>
                  )}
                </td>
                <td style={{ padding: '1.25rem 1.5rem', textAlign: 'right' }}>
                  <ChevronRight size={20} color="var(--admin-text-muted)" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const renderPopDrillDown = () => {
    let allPops = directoryUsers.filter(u => u.role === 'pop');

    if (approvalFilter === 'APPROVED') {
      allPops = allPops.filter(u =>
        u.vetting_status === "APPROVED" &&
        u.kyc_status === "ACCEPTED" &&
        u.coi_status === "SIGNED"
      );
    } else if (approvalFilter === 'NOT_APPROVED') {
      allPops = allPops.filter(u =>
        u.vetting_status !== "APPROVED" ||
        u.kyc_status !== "ACCEPTED" ||
        u.coi_status !== "SIGNED"
      );
    } else if (approvalFilter === 'PENDING_VETTING') {
      allPops = allPops.filter(u => u.vetting_status !== "APPROVED");
    } else if (approvalFilter === 'PENDING_KYC') {
      allPops = allPops.filter(u => u.kyc_status !== "ACCEPTED");
    } else if (approvalFilter === 'PENDING_COI') {
      allPops = allPops.filter(u => u.coi_status !== "SIGNED");
    }

    const searchBar = (
      <div className="admin-search-bar" style={{ width: '100%', marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
        <input
          type="text"
          placeholder="Search professors by name or email..."
          value={popSearchTerm}
          onChange={(e) => {
            setPopSearchTerm(e.target.value);
            // Clear drilldowns if user starts typing
            if (e.target.value) {
              setSelectedDomain(null);
              setSelectedYears(null);
            }
          }}
          className="admin-input"
          style={{ width: '100%', flexGrow: 1, padding: '10px 15px', borderRadius: '8px', border: '1px solid var(--admin-border)' }}
        />
        <select
          value={approvalFilter}
          onChange={(e) => setApprovalFilter(e.target.value)}
          className="admin-input"
          style={{ width: '250px', flexShrink: 0, padding: '10px 15px', borderRadius: '8px', border: '1px solid var(--admin-border)', backgroundColor: 'var(--bg-card)' }}
        >
          <option value="ALL">All Professors</option>
          <option value="APPROVED">Fully Approved</option>
          <option value="NOT_APPROVED">Any Pending / Unapproved</option>
          <option value="PENDING_VETTING">Pending Vetting</option>
          <option value="PENDING_KYC">Pending KYC</option>
          <option value="PENDING_COI">Pending COI</option>
        </select>
        <button
          className="admin-btn-primary"
          style={{ padding: '10px 20px', whiteSpace: 'nowrap' }}
          onClick={() => {
            setSelectedDomain('ALL_DIRECT');
            setSelectedYears('ALL_YEARS');
          }}
        >
          View All
        </button>
      </div>
    );

    if (popSearchTerm.trim() || approvalFilter !== 'ALL') {
      const lowerTerm = popSearchTerm.toLowerCase();
      const filteredPops = allPops.filter(u => {
        if (!lowerTerm) return true;
        const name = (u.details || u.full_name || '').toLowerCase();
        const email = (u.email || '').toLowerCase();
        return name.includes(lowerTerm) || email.includes(lowerTerm);
      });
      return (
        <div className="drill-down-container">
          {searchBar}
          <div className="drill-header">
            <h2 className="admin-section-title">Search Results ({filteredPops.length})</h2>
          </div>
          {filteredPops.length === 0 ? (
            <div className="admin-empty-state" style={{ marginTop: '2rem' }}>
              <p>No professors found matching your criteria.</p>
            </div>
          ) : (
            renderPopTable(filteredPops)
          )}
        </div>
      );
    }

    if (!selectedDomain) {
      if (allPops.length === 0) return (
        <div className="admin-empty-state">
          <div className="empty-icon"><Briefcase size={48} /></div>
          <h3>No active professors</h3>
          <p>There are no active professors in the directory yet.</p>
        </div>
      );

      const domains = allPops.reduce((acc, user) => {
        const d = user.domain || "Uncategorized";
        acc[d] = (acc[d] || 0) + 1;
        return acc;
      }, {});

      return (
        <div>
          {searchBar}
          <div className="admin-grid-layout">
            {Object.entries(domains).map(([domain, count]) => (
              <div key={domain} className="admin-card admin-folder-card" onClick={() => setSelectedDomain(domain)}>
                <div className="admin-card-icon-wrapper blue">
                  <FolderOpen size={32} />
                </div>
                <h3>{domain}</h3>
                <p className="admin-subtext">{count} Professors</p>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (selectedDomain && !selectedYears) {
      const domainPops = allPops.filter(u => (u.domain || "Uncategorized") === selectedDomain);

      // Helper for range
      const getRange = (y) => {
        if (y === undefined || y === null) return "Unknown";
        const val = parseInt(y);
        if (isNaN(val)) return "Unknown";

        if (val <= 5) return "0-5 Years";
        if (val <= 10) return "6-10 Years";
        if (val <= 15) return "11-15 Years";
        if (val <= 20) return "16-20 Years";
        if (val <= 25) return "21-25 Years";
        if (val <= 30) return "26-30 Years";
        if (val <= 35) return "31-35 Years";
        if (val <= 40) return "36-40 Years";
        return "40+ Years";
      };

      const yearsDist = domainPops.reduce((acc, user) => {
        const range = getRange(user.years_of_experience);
        acc[range] = (acc[range] || 0) + 1;
        return acc;
      }, {});

      return (
        <div className="drill-down-container">
          <div className="drill-header">
            <button className="admin-back-link" onClick={() => setSelectedDomain(null)}>
              <ChevronRight size={16} style={{ transform: 'rotate(180deg)' }} /> Back to Domains
            </button>
            <h2 className="admin-section-title">Domain: {selectedDomain}</h2>
          </div>
          <div className="admin-grid-layout">
            {Object.entries(yearsDist).sort().map(([range, count]) => (
              <div key={range} className="admin-card admin-folder-card" onClick={() => setSelectedYears(range)}>
                <div className="admin-card-icon-wrapper purple">
                  <Calendar size={32} />
                </div>
                <h3>{range}</h3>
                <p className="admin-subtext">{count} Profiles</p>
              </div>
            ))}
          </div>
        </div>
      );
    }

    if (selectedDomain && selectedYears) {
      // Helper
      const getRange = (y) => {
        if (y === undefined || y === null) return "Unknown";
        const val = parseInt(y);
        if (isNaN(val)) return "Unknown";

        if (val <= 5) return "0-5 Years";
        if (val <= 10) return "6-10 Years";
        if (val <= 15) return "11-15 Years";
        if (val <= 20) return "16-20 Years";
        if (val <= 25) return "21-25 Years";
        if (val <= 30) return "26-30 Years";
        if (val <= 35) return "31-35 Years";
        if (val <= 40) return "36-40 Years";
        return "40+ Years";
      };

      const filteredUsers = allPops.filter(u => {
        if (selectedDomain === 'ALL_DIRECT') return true;
        return (u.domain || "Uncategorized") === selectedDomain && getRange(u.years_of_experience) === selectedYears;
      });
      return (
        <div className="drill-down-container">
          <div className="drill-header">
            <button className="admin-back-link" onClick={() => {
                if (selectedDomain === 'ALL_DIRECT') {
                    setSelectedDomain(null);
                    setSelectedYears(null);
                } else {
                    setSelectedYears(null);
                }
            }}>
              <ChevronRight size={16} style={{ transform: 'rotate(180deg)' }} /> {selectedDomain === 'ALL_DIRECT' ? 'Back' : 'Back to Age Groups'}
            </button>
            <h2 className="admin-section-title">{selectedDomain === 'ALL_DIRECT' ? 'All Professors' : `${selectedDomain} / ${selectedYears}`}</h2>
          </div>
          <div style={{ marginTop: '20px' }}>
            {renderPopTable(filteredUsers)}
          </div>
        </div>
      );
    }
  };

  const renderDirectory = (roleFilter) => {
    const filtered = directoryUsers.filter(u => u.role === roleFilter);
    return renderDirectoryFromUsers(filtered, roleFilter);
  };

  const renderDirectoryFromUsers = (users, roleFilter = 'student') => {
    const filtered = users.filter(u => !roleFilter || u.role === roleFilter);
    if (filtered.length === 0) return (
      <div className="admin-empty-state">
        <div className="empty-icon"><Search size={48} /></div>
        <h3>No records found</h3>
        <p>There are no active {roleFilter}s in the directory.</p>
      </div>
    );

    return (
      <div className="admin-grid-layout admin-list-view">
        {filtered.map(user => renderUserCard(user))}
      </div>
    );
  };

  const renderUserCard = (user) => (
    <div key={user.id}
      className={`admin-card admin-user-row ${user.is_flagged ? 'admin-flagged-card' : ''}`}
      onClick={() => {
        if (user.role === 'pop') navigate(`/admin/professor/${user.id}`);
        else if (user.role === 'university') navigate(`/admin/university/${user.id}`);
        else setSelectedUser(user);
      }}>
      <div className="admin-user-info">
        <div className="admin-user-header">
          <span className={`admin-badge admin-badge-${user.role === 'university' ? 'blue' : user.role === 'pop' ? 'purple' : 'green'}`}>
            {user.role}
          </span>
          {user.role === 'university' && user.tier && (
            <span className="admin-badge admin-badge-gray" style={{ marginLeft: '8px', background: 'var(--border)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
              {user.tier}
            </span>
          )}
        </div>
        <h3 className="admin-user-name">
          {user.is_flagged && <Flag size={14} className="text-red-500 mr-2" />}
          {user.details}
        </h3>
        <p className="admin-user-email">{user.email}</p>
        <p className="admin-user-extra">{user.extra_info}</p>

        {user.role !== 'pop' && (
          <div className="admin-skill-badges">
            {(user.skills || user.raw_expertise)?.split(', ').map(skill => (
              <span key={skill} className="admin-mini-badge">{skill}</span>
            ))}
          </div>
        )}

        {user.role === 'pop' && (
          <>
            <div className="admin-tag-row">
              <span className="admin-mini-tag"><Briefcase size={12} /> {user.years_of_experience} Years</span>
              <span className="admin-mini-tag"><FolderOpen size={12} /> {user.domain}</span>
            </div>
            {(user.expertise_category || user.expertise_subcategory || user.expertise_core) && (
              <div className="admin-tag-row" style={{ marginTop: '8px' }}>
                {user.expertise_category && <span className="admin-mini-tag">Cat: {user.expertise_category}</span>}
                {user.expertise_subcategory && <span className="admin-mini-tag">Sub: {user.expertise_subcategory}</span>}
                {user.expertise_core && <span className="admin-mini-tag">Core: {user.expertise_core}</span>}
              </div>
            )}
            {(user.vetting_status !== "APPROVED" || user.kyc_status !== "ACCEPTED" || user.coi_status !== "SIGNED") && (
              <div className="admin-tag-row" style={{ marginTop: '8px', color: 'var(--admin-warning)', fontSize: '0.8rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <AlertTriangle size={12} />
                <span style={{ marginRight: '4px' }}>Pending:</span>
                {user.vetting_status !== "APPROVED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>Vetting</span>}
                {user.kyc_status !== "ACCEPTED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>KYC</span>}
                {user.coi_status !== "SIGNED" && <span className="admin-mini-badge" style={{ borderColor: 'var(--admin-warning)', color: 'var(--admin-warning)' }}>COI</span>}
              </div>
            )}
          </>
        )}

        {user.violation_count > 0 && (
          <div className="admin-violation-badge">
            <AlertTriangle size={12} /> Violations: {user.violation_count}
          </div>
        )}
      </div>
      <div className="admin-arrow-icon">
        <ChevronRight size={20} />
      </div>
    </div>
  );

  const renderRawFeedback = (feedbackObj, schemaSection, isModal = false) => {
    if (!feedbackObj || !schemaSection) return JSON.stringify(feedbackObj);
    return (
      <div style={{ maxHeight: isModal ? '60vh' : '150px', overflowY: 'auto', fontSize: isModal ? '0.95rem' : '0.85rem', display: 'flex', flexDirection: 'column', gap: isModal ? '16px' : '8px', paddingRight: '12px' }}>
        {schemaSection.map(q => {
          const answer = feedbackObj[q.id];
          if (answer !== undefined && answer !== "") {
            return (
              <div key={q.id}>
                <div style={{ fontWeight: 600, color: 'var(--text-main)', marginBottom: '4px', lineHeight: '1.4' }}>{q.text}</div>
                <div style={{ color: 'var(--text-muted)' }}>{answer}</div>
              </div>
            );
          }
          return null;
        })}
      </div>
    );
  };

  const renderFeedback = () => {
    return (
      <div className="admin-data-table-container glass-card">
        <div className="accounts-tabs" style={{ marginBottom: '20px' }}>
          <button className={`admin-pill-tab ${feedbackTab === 'lms' ? 'active' : ''}`} onClick={() => setFeedbackTab('lms')}>
            LMS Course Feedbacks
          </button>
          <button className={`admin-pill-tab ${feedbackTab === 'platform' ? 'active' : ''}`} onClick={() => setFeedbackTab('platform')}>
            Platform Feedbacks
          </button>
          <button className={`admin-pill-tab ${feedbackTab === 'course_feedback_forms' ? 'active' : ''}`} onClick={() => setFeedbackTab('course_feedback_forms')}>
            <Settings size={14} style={{ marginRight: '6px' }} /> Course Feedback Forms
          </button>
          <button className={`admin-pill-tab ${feedbackTab === 'platform_forms' ? 'active' : ''}`} onClick={() => setFeedbackTab('platform_forms')}>
            <MessageSquare size={14} style={{ marginRight: '6px' }} /> Platform Feedback Forms
          </button>
        </div>

        {feedbackTab === 'lms' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 className="chart-title" style={{ margin: 0 }}>LMS Course Feedbacks</h3>
              <div style={{ display: 'flex', background: 'var(--bg-main)', borderRadius: '8px', padding: '4px', border: '1px solid var(--border)' }}>
                <button 
                  onClick={() => setLmsViewMode('analytics')}
                  style={{ padding: '6px 16px', background: lmsViewMode === 'analytics' ? 'var(--primary)' : 'transparent', color: lmsViewMode === 'analytics' ? '#fff' : 'var(--text-main)', border: 'none', borderRadius: '6px', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}
                >
                  Analytics View
                </button>
                <button 
                  onClick={() => setLmsViewMode('raw')}
                  style={{ padding: '6px 16px', background: lmsViewMode === 'raw' ? 'var(--primary)' : 'transparent', color: lmsViewMode === 'raw' ? '#fff' : 'var(--text-main)', border: 'none', borderRadius: '6px', fontSize: '0.85rem', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s' }}
                >
                  Raw Data
                </button>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '20px', background: 'var(--bg-main)', padding: '12px 16px', borderRadius: '8px', border: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>University:</span>
                <select 
                  value={lmsSelectedUniversity} 
                  onChange={e => setLmsSelectedUniversity(e.target.value)}
                  style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg-main)', color: 'var(--text-main)', fontSize: '0.85rem', minWidth: '120px' }}
                >
                  <option value="All">All Universities</option>
                  {lmsUniversityOptions.map(u => (
                    <option key={u} value={u}>{u}</option>
                  ))}
                </select>
              </div>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>Course / Form:</span>
                <select 
                  value={lmsSelectedCourse} 
                  onChange={e => setLmsSelectedCourse(e.target.value)}
                  style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid var(--border)', background: 'var(--bg-main)', color: 'var(--text-main)', fontSize: '0.85rem', minWidth: '120px' }}
                >
                  <option value="All">All Feedbacks</option>
                  {lmsCourseOptions.map(c => (
                    <option key={c.id} value={c.id}>{c.label}</option>
                  ))}
                </select>
              </div>

              {lmsViewMode === 'raw' && (
                <RawFeedbackDownloadDropdown
                  onDownloadPdf={handleDownloadRawLmsReport}
                  onDownloadExcel={handleDownloadRawLmsExcel}
                  isDownloadingPdf={downloadingRawLms}
                  isDownloadingExcel={downloadingRawLmsExcel}
                  universityName={lmsSelectedUniversity}
                  disabled={
                    (lmsFeedbacks.filter(f => 
                      (!f.form_id || !String(f.form_id).startsWith('platform_feedback') || (f.module_feedback && Object.keys(f.module_feedback).length > 0)) &&
                      (lmsSelectedCourse === 'All' || f.course_id === lmsSelectedCourse || f.form_id === lmsSelectedCourse) &&
                      (lmsSelectedUniversity === 'All' || f.university_name === lmsSelectedUniversity)
                    )).length === 0
                  }
                />
              )}
            </div>

            {lmsViewMode === 'analytics' ? (
              <LMSFeedbackAnalytics 
                courseId={lmsSelectedCourse} 
                courseName={lmsSelectedCourse !== 'All' ? (lmsCourseOptions.find(c => c.id === lmsSelectedCourse)?.label || lmsSelectedCourse) : null}
                universityName={lmsSelectedUniversity} 
                displayType="lms" 
              />
            ) : (
              <>
                {(lmsFeedbacks.filter(f => 
                  (!f.form_id || !String(f.form_id).startsWith('platform_feedback') || (f.module_feedback && Object.keys(f.module_feedback).length > 0)) &&
                  (lmsSelectedCourse === 'All' || f.course_id === lmsSelectedCourse || f.form_id === lmsSelectedCourse) &&
                  (lmsSelectedUniversity === 'All' || f.university_name === lmsSelectedUniversity)
                )).length === 0 ? (
                  <div className="admin-empty-state">
                    <div className="empty-icon"><MessageSquare size={48} /></div>
                    <h3>No feedback submitted yet</h3>
                  </div>
                ) : (
                  <table className="admin-data-table">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Student</th>
                        <th>University</th>
                        <th>Course / Form</th>
                        <th>Batch</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(lmsFeedbacks.filter(f => 
                        (!f.form_id || !String(f.form_id).startsWith('platform_feedback') || (f.module_feedback && Object.keys(f.module_feedback).length > 0)) &&
                        (lmsSelectedCourse === 'All' || f.course_id === lmsSelectedCourse || f.form_id === lmsSelectedCourse) &&
                        (lmsSelectedUniversity === 'All' || f.university_name === lmsSelectedUniversity)
                      )).map(item => (
                        <tr key={item.id}>
                          <td>{new Date(item.created_at).toLocaleDateString('en-GB')}</td>
                          <td>
                            <div style={{ fontWeight: 600, color: 'var(--text-main)' }}>{item.student_name}</div>
                            {(item.usn || item.student_email) && (
                              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '2px' }}>
                                {item.usn && <span style={{ marginRight: '6px', fontFamily: 'monospace' }}>{item.usn}</span>}
                                {item.student_email && <span>{item.student_email}</span>}
                              </div>
                            )}
                          </td>
                          <td>{item.university_name || 'Unknown'}</td>
                          <td>
                            {item.course_name || item.course_id}
                            {item.form_title && (
                              <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: '2px' }}>
                                Form: {item.form_title}
                              </div>
                            )}
                          </td>
                          <td>{item.batch_name || 'Unknown Batch'}</td>
                          <td>
                            <button 
                              onClick={() => setSelectedLmsFeedback(item)} 
                              style={{ padding: '6px 16px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '6px', color: 'var(--text-main)', cursor: 'pointer', fontWeight: 600 }}
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {/* Feedback Details Modal */}
                {selectedLmsFeedback && (
                  <div className="modal-overlay" onClick={() => setSelectedLmsFeedback(null)}>
                    <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px', width: '90%' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                        <h2 style={{ margin: 0, fontSize: '1.4rem', color: 'var(--text-main)' }}>Feedback Details - {selectedLmsFeedback.student_name}</h2>
                        <button 
                          onClick={() => setSelectedLmsFeedback(null)}
                          style={{ background: 'transparent', border: '1px solid var(--border)', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', color: 'var(--text-main)' }}
                        >
                          Close
                        </button>
                      </div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '32px' }}>
                        <div style={{ background: 'var(--bg-card)', padding: '20px', borderRadius: '12px', border: '1px solid var(--border)' }}>
                          <h3 style={{ fontSize: '1.1rem', color: 'var(--primary)', marginBottom: '16px', borderBottom: '2px solid var(--bg-main)', paddingBottom: '12px' }}>Module Feedback</h3>
                          {renderRawFeedback(selectedLmsFeedback.module_feedback, ((courseForms.find(cf => cf.id === (selectedLmsFeedback.form_id || selectedLmsFeedback.course_id))?.questions) || courseForms[0]?.questions || lmsSchema?.module_feedback), true)}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {feedbackTab === 'platform' && (
          <PlatformFeedbackTab 
            lmsFeedbacks={lmsFeedbacks} 
            universities={lmsUniversityOptions}
            platformForms={platformForms} 
            lmsSchema={lmsSchema} 
            renderRawFeedback={renderRawFeedback}
            showToast={showToast}
          />
        )}


        {feedbackTab === 'platform_forms' && (
          <div style={{ marginTop: '20px' }}>
            {editingPlatformForm ? (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h3 className="chart-title" style={{ margin: 0 }}>Edit Questions: {editingPlatformForm.title}</h3>
                  <button 
                    onClick={() => setEditingPlatformForm(null)}
                    style={{ padding: '8px 16px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '8px', color: 'var(--text-main)', cursor: 'pointer', fontWeight: 600 }}
                  >
                    ← Back to Forms List
                  </button>
                </div>
                <LMSQuestionBuilder 
                  initialSchema={platformFormEditorSchema} 
                  onSave={handleSavePlatformFormQuestions} 
                  mode="platform"
                />
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h3 className="chart-title" style={{ margin: 0 }}>Platform Feedback Forms</h3>
                  <button
                    onClick={() => { fetchUniversitiesList(); setShowAddFormModal(true); }}
                    style={{
                      padding: '10px 20px',
                      background: 'var(--primary)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(14, 165, 233, 0.3)',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    + Add New Form
                  </button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                  {platformForms.map(form => (
                    <div
                      key={form.id}
                      style={{
                        background: 'var(--bg-card)',
                        border: '1px solid var(--border)',
                        borderRadius: '12px',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.02)',
                        position: 'relative'
                      }}
                    >
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                          <h4 style={{ margin: 0, fontSize: '1.15rem', color: 'var(--text-main)', fontWeight: 700 }}>
                            {form.title}
                          </h4>
                          <span
                            style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: 700,
                              background: form.status === 'draft' ? 'rgba(245, 158, 11, 0.12)' : (form.is_active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)'),
                              color: form.status === 'draft' ? '#f59e0b' : (form.is_active ? '#10b981' : '#ef4444')
                            }}
                          >
                            {form.status === 'draft' ? 'Draft' : (form.is_active ? 'Published' : 'Disabled')}
                          </span>
                        </div>

                        <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                          Questions count: <strong>{form.questions?.length || 0}</strong>
                        </p>
                        <p style={{ margin: '0 0 16px 0', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                          Target: <strong>{Array.isArray(form.target_universities) ? (form.target_universities.length > 0 ? form.target_universities.join(', ') : 'No universities selected') : (form.target_universities || 'All Universities')}</strong>
                        </p>
                      </div>

                      <div style={{ borderTop: '1px solid var(--border)', paddingTop: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {form.status === 'draft' && (
                          <button
                            onClick={() => handlePublishPlatformForm(form)}
                            style={{
                              padding: '6px 12px',
                              background: '#10b981',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              fontSize: '0.8rem',
                              fontWeight: 600,
                              cursor: 'pointer'
                            }}
                          >
                            Publish
                          </button>
                        )}
                        <button
                          onClick={() => setEditingPlatformForm(form)}
                          style={{
                            padding: '6px 12px',
                            background: 'var(--primary)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Edit Questions
                        </button>
                        <button
                          onClick={() => handleEditFormTitle(form)}
                          style={{
                            padding: '6px 12px',
                            background: 'var(--bg-main)',
                            border: '1px solid var(--border)',
                            color: 'var(--text-main)',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Rename
                        </button>
                        {form.status !== 'draft' && (
                          <button
                            onClick={() => handleToggleFormStatus(form)}
                            style={{
                              padding: '6px 12px',
                              background: form.is_active ? '#fee2e2' : '#d1fae5',
                              border: 'none',
                              color: form.is_active ? '#ef4444' : '#10b981',
                              borderRadius: '6px',
                              fontSize: '0.8rem',
                              fontWeight: 600,
                              cursor: 'pointer'
                            }}
                          >
                            {form.is_active ? 'Disable' : 'Enable'}
                          </button>
                        )}

                        <button
                          onClick={() => handleDeletePlatformForm(form)}
                          style={{
                            padding: '6px 12px',
                            background: '#fef2f2',
                            border: '1px solid #fca5a5',
                            color: '#ef4444',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {platformForms.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                    No platform feedback forms created yet. Click "+ Add New Form" to get started.
                  </div>
                )}
              </div>
            )}
          </div>
        )}

{feedbackTab === 'course_feedback_forms' && (
          <div style={{ marginTop: '20px' }}>
            {editingCourseForm ? (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h3 className="chart-title" style={{ margin: 0 }}>Edit Questions: {editingCourseForm.title}</h3>
                  <button 
                    onClick={() => setEditingCourseForm(null)}
                    style={{ padding: '8px 16px', background: 'var(--bg-main)', border: '1px solid var(--border)', borderRadius: '8px', color: 'var(--text-main)', cursor: 'pointer', fontWeight: 600 }}
                  >
                    ← Back to Forms List
                  </button>
                </div>
                <LMSQuestionBuilder 
                  initialSchema={courseFormEditorSchema} 
                  onSave={handleSaveCourseFormQuestions} 
                  mode="course"
                />
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <h3 className="chart-title" style={{ margin: 0 }}>Course Feedback Forms</h3>
                  <button
                    onClick={() => { fetchUniversitiesList(); setShowAddCourseFormModal(true); }}
                    style={{
                      padding: '10px 20px',
                      background: 'var(--primary)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(14, 165, 233, 0.3)',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    + Add New Form
                  </button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                  {courseForms.map(form => (
                    <div
                      key={form.id}
                      style={{
                        background: 'var(--bg-card)',
                        border: '1px solid var(--border)',
                        borderRadius: '12px',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        boxShadow: '0 4px 10px rgba(0,0,0,0.02)',
                        position: 'relative'
                      }}
                    >
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                          <h4 style={{ margin: 0, fontSize: '1.15rem', color: 'var(--text-main)', fontWeight: 700 }}>
                            {form.title}
                          </h4>
                          <span
                            style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: 700,
                              background: form.status === 'draft' ? 'rgba(245, 158, 11, 0.12)' : (form.is_active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)'),
                              color: form.status === 'draft' ? '#f59e0b' : (form.is_active ? '#10b981' : '#ef4444')
                            }}
                          >
                            {form.status === 'draft' ? 'Draft' : (form.is_active ? 'Published' : 'Disabled')}
                          </span>
                        </div>

                        <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                          Questions count: <strong>{form.questions?.length || 0}</strong>
                        </p>
                        <p style={{ margin: '0 0 16px 0', fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                          Target: <strong>{Array.isArray(form.target_universities) ? (form.target_universities.length > 0 ? form.target_universities.join(', ') : 'No universities selected') : (form.target_universities || 'All Universities')}</strong>
                        </p>
                      </div>

                      <div style={{ borderTop: '1px solid var(--border)', paddingTop: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {form.status === 'draft' && (
                          <button
                            onClick={() => handlePublishCourseForm(form)}
                            style={{
                              padding: '6px 12px',
                              background: '#10b981',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              fontSize: '0.8rem',
                              fontWeight: 600,
                              cursor: 'pointer'
                            }}
                          >
                            Publish
                          </button>
                        )}
                        <button
                          onClick={() => setEditingCourseForm(form)}
                          style={{
                            padding: '6px 12px',
                            background: 'var(--primary)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Edit Questions
                        </button>
                        <button
                          onClick={() => handleEditCourseFormTitle(form)}
                          style={{
                            padding: '6px 12px',
                            background: 'var(--bg-main)',
                            border: '1px solid var(--border)',
                            color: 'var(--text-main)',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Rename
                        </button>
                        {form.status !== 'draft' && (
                          <button
                            onClick={() => handleToggleCourseFormStatus(form)}
                            style={{
                              padding: '6px 12px',
                              background: form.is_active ? '#fee2e2' : '#d1fae5',
                              border: 'none',
                              color: form.is_active ? '#ef4444' : '#10b981',
                              borderRadius: '6px',
                              fontSize: '0.8rem',
                              fontWeight: 600,
                              cursor: 'pointer'
                            }}
                          >
                            {form.is_active ? 'Disable' : 'Enable'}
                          </button>
                        )}

                        <button
                          onClick={() => handleDeleteCourseForm(form)}
                          style={{
                            padding: '6px 12px',
                            background: '#fef2f2',
                            border: '1px solid #fca5a5',
                            color: '#ef4444',
                            borderRadius: '6px',
                            fontSize: '0.8rem',
                            fontWeight: 600,
                            cursor: 'pointer'
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {courseForms.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '40px', background: 'var(--bg-card)', borderRadius: '12px', border: '1px solid var(--border)', color: 'var(--text-muted)' }}>
                    No course feedback forms created yet. Click "+ Add New Form" to get started.
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Add Platform Feedback Form Modal */}
        {showAddFormModal && (
          <div className="modal-overlay" onClick={() => setShowAddFormModal(false)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Create Platform Feedback Form</h3>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Form Title</label>
                <input
                  type="text"
                  placeholder="e.g. Feedback 1, AI Tooling Survey"
                  value={newFormTitle}
                  onChange={e => setNewFormTitle(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-main)',
                    color: 'var(--text-main)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Target University</label>
                <MultiSelectDropdown options={universitiesList.map(u => u.institution_name)} selectedValues={newFormTargetUniversities} onChange={setNewFormTargetUniversities} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setShowAddFormModal(false)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddPlatformForm}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--primary)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Create Form
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Rename Form Modal */}
        {renameFormTarget && (
          <div className="modal-overlay" onClick={() => setRenameFormTarget(null)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Rename Platform Feedback Form</h3>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>New Form Title</label>
                <input
                  type="text"
                  placeholder="Enter title..."
                  value={renameFormTitle}
                  onChange={e => setRenameFormTitle(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-main)',
                    color: 'var(--text-main)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Target University</label>
                <MultiSelectDropdown options={universitiesList.map(u => u.institution_name)} selectedValues={renameFormTargetUniversities} onChange={setRenameFormTargetUniversities} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setRenameFormTarget(null)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveRenameForm}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--primary)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Rename Form
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Form Confirmation Modal */}
        {deleteFormTarget && (
          <div className="modal-overlay" onClick={() => setDeleteFormTarget(null)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Delete Feedback Form</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '24px' }}>
                Are you sure you want to delete <strong>{deleteFormTarget.title}</strong>? All responses submitted for this form will remain in the database, but the form configuration will be permanently deleted.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setDeleteFormTarget(null)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmDeleteForm}
                  style={{
                    padding: '8px 16px',
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Course Feedback Form Modal */}
        {showAddCourseFormModal && (
          <div className="modal-overlay" onClick={() => setShowAddCourseFormModal(false)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Create Course Feedback Form</h3>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Form Title</label>
                <input
                  type="text"
                  placeholder="e.g. Feedback 1, AI Tooling Survey"
                  value={newCourseFormTitle}
                  onChange={e => setNewCourseFormTitle(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-main)',
                    color: 'var(--text-main)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Target University</label>
                <MultiSelectDropdown options={universitiesList.map(u => u.institution_name)} selectedValues={newCourseTargetUniversities} onChange={setNewCourseTargetUniversities} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setShowAddCourseFormModal(false)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddCourseForm}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--primary)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Create Form
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Rename Course Form Modal */}
        {renameCourseFormTarget && (
          <div className="modal-overlay" onClick={() => setRenameCourseFormTarget(null)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Rename Course Feedback Form</h3>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>New Form Title</label>
                <input
                  type="text"
                  placeholder="Enter title..."
                  value={renameCourseFormTitle}
                  onChange={e => setRenameCourseFormTitle(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    background: 'var(--bg-main)',
                    color: 'var(--text-main)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>Target University</label>
                <MultiSelectDropdown options={universitiesList.map(u => u.institution_name)} selectedValues={renameCourseTargetUniversities} onChange={setRenameCourseTargetUniversities} />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setRenameCourseFormTarget(null)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSaveRenameCourseForm}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--primary)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Rename Form
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Course Form Confirmation Modal */}
        {deleteCourseFormTarget && (
          <div className="modal-overlay" onClick={() => setDeleteCourseFormTarget(null)}>
            <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '450px' }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '1.25rem', color: 'var(--text-main)' }}>Delete Feedback Form</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '24px' }}>
                Are you sure you want to delete <strong>{deleteCourseFormTarget.title}</strong>? All responses submitted for this form will remain in the database, but the form configuration will be permanently deleted.
              </p>
              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setDeleteCourseFormTarget(null)}
                  style={{
                    padding: '8px 16px',
                    background: 'var(--bg-main)',
                    border: '1px solid var(--border)',
                    color: 'var(--text-main)',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmDeleteCourseForm}
                  style={{
                    padding: '8px 16px',
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                >
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderModerationLogs = () => {
    const pendingReportsCount = contentReports.filter(r => r.status === 'PENDING').length;
    const unreviewedLogsCount = moderationLogs.filter(l => !l.is_reviewed).length;

    return (
      <div className="admin-data-table-container glass-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
          <h3 className="chart-title" style={{ margin: 0 }}>Content Moderation & Policy Enforcement</h3>
          
          <div className="admin-filter-tabs" style={{ display: 'flex', gap: '8px' }}>
            <button
              className={`admin-tab-btn ${moderationSubTab === 'user_reports' ? 'active' : ''}`}
              onClick={() => setModerationSubTab('user_reports')}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid var(--border)',
                background: moderationSubTab === 'user_reports' ? '#2563eb' : 'transparent',
                color: moderationSubTab === 'user_reports' ? '#ffffff' : 'var(--text-primary)',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <Flag size={16} /> User Reports
              {pendingReportsCount > 0 && (
                <span style={{ background: '#ef4444', color: '#fff', fontSize: '11px', padding: '2px 6px', borderRadius: '10px' }}>
                  {pendingReportsCount}
                </span>
              )}
            </button>

            <button
              className={`admin-tab-btn ${moderationSubTab === 'auto_logs' ? 'active' : ''}`}
              onClick={() => setModerationSubTab('auto_logs')}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid var(--border)',
                background: moderationSubTab === 'auto_logs' ? '#2563eb' : 'transparent',
                color: moderationSubTab === 'auto_logs' ? '#ffffff' : 'var(--text-primary)',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <AlertCircle size={16} /> Auto-Filter Violations
              {unreviewedLogsCount > 0 && (
                <span style={{ background: '#f59e0b', color: '#fff', fontSize: '11px', padding: '2px 6px', borderRadius: '10px' }}>
                  {unreviewedLogsCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {moderationSubTab === 'user_reports' && (
          contentReports.length === 0 ? (
            <div className="admin-empty-state">
              <div className="empty-icon"><Flag size={48} /></div>
              <h3>No user reports submitted yet</h3>
            </div>
          ) : (
            <table className="admin-data-table">
              <thead>
                <tr>
                  <th>Submitted At</th>
                  <th>Reporter</th>
                  <th>Content Author</th>
                  <th>Type & Snippet</th>
                  <th>Reason</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {contentReports.map(report => (
                  <tr key={report.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{new Date(report.created_at).toLocaleString('en-GB')}</td>
                    <td>
                      <div className="font-semibold">{report.reporter_name}</div>
                      <div className="text-xs text-slate-500">{report.reporter_email}</div>
                    </td>
                    <td>
                      <div className="font-semibold">{report.author_name}</div>
                      <div className="text-xs text-slate-500">{report.author_email}</div>
                    </td>
                    <td className="comment-cell">
                      <span className="admin-badge admin-badge-gray" style={{ marginBottom: '4px', display: 'inline-block' }}>
                        {report.content_type.toUpperCase()} #{report.content_id}
                      </span>
                      <div style={{ maxHeight: '80px', overflowY: 'auto', fontStyle: 'italic', fontSize: '13px' }}>
                        "{report.content_snippet || 'No preview available'}"
                      </div>
                    </td>
                    <td>
                      <span className="admin-badge admin-badge-danger" style={{ fontWeight: '600' }}>
                        {report.reason}
                      </span>
                      {report.custom_reason && (
                        <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '4px', fontStyle: 'italic' }}>
                          Description: {report.custom_reason}
                        </div>
                      )}
                    </td>
                    <td>
                      <span className={`admin-badge ${
                        report.status === 'ACTION_TAKEN' ? 'admin-badge-danger' :
                        report.status === 'REVIEWED' ? 'admin-badge-success' :
                        report.status === 'DISMISSED' ? 'admin-badge-gray' : 'admin-badge-warning'
                      }`}>
                        {report.status}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                        {report.status === 'PENDING' && (
                          <>
                            <button
                              onClick={() => handleUpdateReportStatus(report.id, 'REVIEWED')}
                              title="Mark as Reviewed"
                              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #bfdbfe', background: '#eff6ff', color: '#2563eb', cursor: 'pointer', flexShrink: 0 }}
                            >
                              <CheckCircle size={15} />
                            </button>
                            <button
                              onClick={() => handleUpdateReportStatus(report.id, 'DISMISSED')}
                              title="Dismiss Report"
                              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', cursor: 'pointer', flexShrink: 0 }}
                            >
                              <XCircle size={15} />
                            </button>
                          </>
                        )}
                        {report.status !== 'ACTION_TAKEN' && (
                          <button
                            onClick={() => handleDeleteReportedContent(report.content_type, report.content_id)}
                            title="Delete offensive content"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #fecaca', background: '#fff1f2', color: '#dc2626', cursor: 'pointer', flexShrink: 0 }}
                          >
                            <Ban size={15} />
                          </button>
                        )}
                        <button
                          onClick={() => handleDeleteReport(report.id)}
                          title="Remove report log"
                          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #e2e8f0', background: 'transparent', color: '#94a3b8', cursor: 'pointer', flexShrink: 0 }}
                        >
                          <Trash2 size={13} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}

        {moderationSubTab === 'auto_logs' && (
          moderationLogs.length === 0 ? (
            <div className="admin-empty-state">
              <div className="empty-icon"><Flag size={48} /></div>
              <h3>No moderation violations logged</h3>
            </div>
          ) : (
            <table className="admin-data-table">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>User Details</th>
                  <th>Blocked Content</th>
                  <th>Violations</th>
                  <th>Severity</th>
                  <th>Recommendation</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {moderationLogs.map(log => (
                  <tr key={log.id}>
                    <td style={{ whiteSpace: 'nowrap' }}>{new Date(log.timestamp).toLocaleString('en-GB')}</td>
                    <td>
                      <div className="font-semibold">{log.user_email}</div>
                      <div className="text-xs text-red-500">Total Points: {log.user_total_points}</div>
                    </td>
                    <td className="comment-cell">
                      <div style={{ maxHeight: '100px', overflowY: 'auto', fontStyle: 'italic', fontSize: '13px' }}>
                        "{log.content}"
                      </div>
                    </td>
                    <td>
                      <div className="admin-skill-badges">
                        {log.found_words?.map(w => (
                          <span key={w} className="admin-mini-badge" style={{ background: '#fee2e2', color: '#991b1b', border: '1px solid #fecaca' }}>{w}</span>
                        ))}
                      </div>
                    </td>
                    <td>
                      <span className={`admin-badge ${log.severity >= 5 ? 'admin-badge-danger' : log.severity >= 3 ? 'admin-badge-warning' : 'admin-badge-gray'}`}>
                        {log.severity === 5 ? 'Severe (5pt)' : log.severity === 3 ? 'Moderate (3pt)' : 'Minor (1pt)'}
                      </span>
                    </td>
                    <td>
                      <span className={`admin-badge ${log.recommendation?.includes('Removal') ? 'admin-badge-danger' : log.recommendation?.includes('Suspension') ? 'admin-badge-warning' : 'admin-badge-blue'}`}>
                        {log.recommendation || 'Warning'}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        {log.is_reviewed ? (
                          <span className="text-green-600 flex items-center gap-1 text-sm" style={{ marginRight: 'auto' }}>
                            <CheckCircle size={16} /> Reviewed
                          </span>
                        ) : (
                          <button
                            onClick={() => handleReviewLog(log.id)}
                            className="admin-mini-badge badge-blue"
                            style={{ border: '1px solid #bfdbfe', cursor: 'pointer', marginRight: 'auto' }}
                            title="Mark as Reviewed"
                          >
                            <CheckCircle size={14} /> Review
                          </button>
                        )}
                        <button
                          onClick={() => handleDeleteLog(log.id)}
                          className="admin-mini-badge"
                          style={{ background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca', cursor: 'pointer', padding: '4px' }}
                          title="Delete Log"
                        >
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </div>
    );
  };


  const renderAiAnalytics = () => {
    if (!aiAnalytics) return (
      <div className="admin-empty-state">
        <div className="empty-icon"><Cpu size={48} /></div>
        <h3>Loading AI Analytics...</h3>
      </div>
    );

    const filteredStudents = aiAnalytics.student_usage.filter(s => {
      const matchesSearch = s.name.toLowerCase().includes(aiSearch.toLowerCase()) ||
        (s.institution && s.institution.toLowerCase().includes(aiSearch.toLowerCase()));
      return matchesSearch;
    });

    const filteredUniversities = (aiAnalytics.university_usage || []).filter(u => {
      const matchesSearch = u.name.toLowerCase().includes(aiSearch.toLowerCase());
      return matchesSearch;
    });

    const studentsByInstitution = filteredStudents.reduce((acc, student) => {
      const inst = student.institution || 'Unknown Institution';
      if (!acc[inst]) acc[inst] = [];
      acc[inst].push(student);
      return acc;
    }, {});

    return (
      <div className="admin-reports-dashboard">
        <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
          <button className={aiActiveTab === 'minutes' ? 'admin-pill-tab active' : 'admin-pill-tab'} onClick={() => setAiActiveTab('minutes')}>Minutes of usage</button>
          <button className={aiActiveTab === 'tokens' ? 'admin-pill-tab active' : 'admin-pill-tab'} onClick={() => setAiActiveTab('tokens')}>Tokens</button>
          <button className={aiActiveTab === 'settings' ? 'admin-pill-tab active' : 'admin-pill-tab'} onClick={() => setAiActiveTab('settings')}>Settings</button>
          <button className={aiActiveTab === 'costing' ? 'admin-pill-tab active' : 'admin-pill-tab'} onClick={() => setAiActiveTab('costing')}>Costing</button>
        </div>

        {aiActiveTab === 'costing' ? (
          <div className="fade-in">
            <AiCosting />
          </div>
        ) : aiActiveTab === 'settings' ? (
          <div className="fade-in">
              <div className="section-header" style={{ marginBottom: '24px' }}>
                <div>
                  <h2>System Settings</h2>
                  <p>Configure global platform parameters and limits.</p>
                </div>
              </div>
              <div style={{ background: 'var(--surface)', padding: '32px', borderRadius: '12px', border: '1px solid var(--border)' }}>
                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '8px', color: 'var(--text-color)' }}>
                    OpenRouter AI Token Limit (per student)
                  </label>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <input 
                      type="number" 
                      value={systemSettings.ai_token_limit || ''}
                      onChange={(e) => setSystemSettings({...systemSettings, ai_token_limit: e.target.value})}
                      placeholder="e.g. 0"
                      style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-color)', fontSize: '1rem', width: '200px' }}
                    />
                    <button 
                      className="admin-btn-primary"
                      onClick={() => handleSaveSetting('ai_token_limit', systemSettings.ai_token_limit)}
                      disabled={isSavingSettings}
                    >
                      {isSavingSettings ? 'Saving...' : 'Save Limit'}
                    </button>
                  </div>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginTop: '8px' }}>
                    Global default for students without a custom limit (set per-student or per-university in AI Analytics → Tokens).
                  </p>
                </div>
                
                <div style={{ marginBottom: '24px', paddingTop: '24px', borderTop: '1px solid var(--border)' }}>
                  <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '8px', color: 'var(--text-color)' }}>
                    Institution AI Token Limit (per university)
                  </label>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <input 
                      type="number" 
                      value={systemSettings.institution_ai_token_limit || ''}
                      onChange={(e) => setSystemSettings({...systemSettings, institution_ai_token_limit: e.target.value})}
                      placeholder="e.g. 0"
                      style={{ padding: '10px 16px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-color)', fontSize: '1rem', width: '200px' }}
                    />
                    <button 
                      className="admin-btn-primary"
                      onClick={() => handleSaveSetting('institution_ai_token_limit', systemSettings.institution_ai_token_limit)}
                      disabled={isSavingSettings}
                    >
                      {isSavingSettings ? 'Saving...' : 'Save Limit'}
                    </button>
                  </div>
                  <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginTop: '8px' }}>
                    Global default for universities without a custom limit (set per-university in AI Analytics → Tokens).
                  </p>
                </div>
              </div>
            </div>
        ) : (
          <>
            <div className="reports-kpi-grid" style={{ gridTemplateColumns: aiActiveTab === 'tokens' ? 'repeat(3, minmax(200px, 1fr))' : 'repeat(1, minmax(250px, 300px))', gap: '1.5rem', marginBottom: '2rem' }}>
              <div className="kpi-card">
                <div className="kpi-icon"><Cpu /></div>
                <div className="kpi-info">
                  <h4>{aiActiveTab === 'tokens' ? 'Total Tokens Used' : 'Total AI Agent Usage'}</h4>
                  <span className="kpi-value">
                    {(() => {
                      if (aiActiveTab === 'tokens') {
                        const studentTokens = aiAnalytics.student_usage.reduce((sum, s) => sum + (s.tokens_used || 0) + (s.historical_tokens_used || 0), 0);
                        const uniTokens = aiAnalytics.university_usage ? aiAnalytics.university_usage.reduce((sum, u) => sum + (u.tokens_used || 0) + (u.historical_tokens_used || 0), 0) : 0;
                        const totalTokens = studentTokens + uniTokens;
                        return totalTokens.toLocaleString();
                      } else {
                        const totalSeconds = aiAnalytics.student_usage.reduce((sum, s) => sum + (s.daily_usage_count || 0) + (s.historical_usage || 0), 0);
                        return `${Math.floor(totalSeconds / 60)}m ${totalSeconds % 60}s`;
                      }
                    })()}
                  </span>
                </div>
              </div>
              
              {aiActiveTab === 'tokens' && (
                <>
                  <div className="kpi-card">
                    <div className="kpi-icon" style={{ background: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6' }}><Cpu /></div>
                    <div className="kpi-info">
                      <h4>Student Tokens</h4>
                      <span className="kpi-value">
                        {(() => {
                          const studentTokens = aiAnalytics.student_usage.reduce((sum, s) => sum + (s.tokens_used || 0) + (s.historical_tokens_used || 0), 0);
                          return studentTokens.toLocaleString();
                        })()}
                      </span>
                    </div>
                  </div>
                  
                  <div className="kpi-card">
                    <div className="kpi-icon" style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}><Cpu /></div>
                    <div className="kpi-info">
                      <h4>University Tokens</h4>
                      <span className="kpi-value">
                        {(() => {
                          const uniTokens = aiAnalytics.university_usage ? aiAnalytics.university_usage.reduce((sum, u) => sum + (u.tokens_used || 0) + (u.historical_tokens_used || 0), 0) : 0;
                          return uniTokens.toLocaleString();
                        })()}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>

        <div className="admin-data-table-container glass-card" style={{ marginTop: '2rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <h3 className="chart-title" style={{ marginBottom: 0 }}>
                {aiActiveTab === 'tokens'
                  ? (aiTokenViewTab === 'students' ? 'Student Token Usage' : 'University Token Usage')
                  : (aiMinutesViewTab === 'students' ? 'Student AI Usage' : 'University Minute Allocation')}
              </h3>
              {(aiActiveTab === 'tokens' || aiActiveTab === 'minutes') && (() => {
                const isTokenTab = aiActiveTab === 'tokens';
                const activeView = isTokenTab ? aiTokenViewTab : aiMinutesViewTab;
                const setView = isTokenTab ? setAiTokenViewTab : setAiMinutesViewTab;
                return (
                  <div style={{ display: 'flex', background: 'var(--surface-hover)', borderRadius: '20px', padding: '4px' }}>
                    <button
                      onClick={() => setView('students')}
                      style={{ background: activeView === 'students' ? 'var(--primary)' : 'transparent', color: activeView === 'students' ? '#fff' : 'var(--text-muted)', border: 'none', padding: '6px 16px', borderRadius: '16px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s' }}
                    >Students</button>
                    <button
                      onClick={() => setView('universities')}
                      style={{ background: activeView === 'universities' ? 'var(--primary)' : 'transparent', color: activeView === 'universities' ? '#fff' : 'var(--text-muted)', border: 'none', padding: '6px 16px', borderRadius: '16px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s' }}
                    >Universities</button>
                  </div>
                );
              })()}
            </div>
            <div style={{ position: 'relative' }}>
              <Search size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--admin-text-muted)' }} />
              <input
                type="text"
                className="admin-textarea"
                style={{ padding: '8px 12px 8px 36px', height: 'auto', width: '250px', borderRadius: '20px' }}
                placeholder="Search students..."
                value={aiSearch}
                onChange={(e) => setAiSearch(e.target.value)}
              />
            </div>
          </div>

          {aiActiveTab === 'minutes' && aiMinutesViewTab === 'universities' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {aiSearch.trim().length > 0 && (
                <div style={{ marginBottom: '1rem', color: 'var(--admin-text-muted)' }}>
                  Showing search results for "{aiSearch}"
                </div>
              )}
              {filteredUniversities.length > 0 ? filteredUniversities.map(uni => {
                const usedSeconds = uni.minutes_used || 0;
                const limitMinutes = uni.minutes_limit ?? 60;
                const poolSeconds = limitMinutes * 60;
                const pctUsed = poolSeconds > 0 ? Math.min(100, Math.round((usedSeconds / poolSeconds) * 100)) : 0;
                const exhausted = poolSeconds > 0 && usedSeconds >= poolSeconds;
                const uniTargetId = `uni_${uni.university_id}`;
                return (
                  <div
                    key={uni.university_id}
                    style={{
                      padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.02)', transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.06)'; e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.4)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.02)'; e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.transform = 'translateY(0)'; }}
                  >
                    <div style={{ flex: '1' }}>
                      <div className="font-semibold" style={{ fontSize: '1.15rem', color: 'var(--admin-text)', marginBottom: '6px' }}>
                        {uni.name}
                      </div>
                      <div style={{ maxWidth: '320px' }}>
                        <div style={{ height: '6px', borderRadius: '999px', background: 'var(--admin-bg-alt)', overflow: 'hidden' }}>
                          <div style={{ width: `${pctUsed}%`, height: '100%', background: exhausted ? 'var(--admin-danger)' : 'var(--admin-primary)', transition: 'width 0.3s ease' }} />
                        </div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '6px' }}>
                          {pctUsed}% of allocated minutes used
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '2.5rem', alignItems: 'center' }}>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Minutes Used</div>
                        <div style={{ fontWeight: '600', color: 'var(--admin-primary)', marginTop: '4px', fontSize: '1.05rem' }}>
                          {Math.floor(usedSeconds / 60)}m {usedSeconds % 60}s
                          <span style={{ color: 'var(--admin-text-muted)', fontWeight: '400', fontSize: '0.85em' }}> / {limitMinutes}m</span>
                        </div>
                        {(uni.historical_minutes_used || 0) > 0 && (
                          <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                            Historical: {Math.floor((uni.historical_minutes_used || 0) / 60)}m {(uni.historical_minutes_used || 0) % 60}s
                          </div>
                        )}
                        {(uni.extra_minutes || 0) > 0 && (
                          <div style={{ fontSize: '0.75rem', color: 'var(--admin-primary)', marginTop: '4px', fontWeight: '500' }}>
                            +{uni.extra_minutes} Extra Minutes
                          </div>
                        )}
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                          Limit: {uni.ai_agent_minutes_limit != null ? `${uni.ai_agent_minutes_limit.toLocaleString()} min` : 'Default (global)'}
                          {uni.ai_agent_minutes_limit === 0 && (
                            <div style={{ fontSize: '0.75rem', color: 'var(--admin-danger)', fontWeight: 600, marginTop: '2px' }}>
                              0 = all AI Agent usage blocked
                            </div>
                          )}
                        </div>
                      </div>

                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          className="admin-mini-badge"
                          style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                          onClick={() => handleResetAiMinutes(uniTargetId)}
                          title="Reset minutes used by this university's students"
                        >
                          Reset
                        </button>
                        <button
                          className="admin-mini-badge"
                          style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                          onClick={() => {
                            setAddonMinutesValue("");
                            setShowAddMinutesModal({ show: true, targetId: uniTargetId, targetName: uni.name, currentExtra: uni.extra_minutes || 0, isUniversity: true });
                          }}
                          title="Allocate extra minutes"
                        >
                          + Add
                        </button>
                        <button
                          className="admin-mini-badge"
                          style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', border: '1px solid rgba(139, 92, 246, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                          onClick={() => {
                            setMinutesLimitValue(uni.ai_agent_minutes_limit != null ? String(uni.ai_agent_minutes_limit) : '');
                            setClearMinutesLimit(false);
                            setShowMinutesModal({ show: true, targetId: uniTargetId, targetName: uni.name, currentLimit: uni.ai_agent_minutes_limit, isUniversity: true });
                          }}
                          title="Set University-wise Minute Limit"
                        >
                          Limit
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }) : (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--admin-text-muted)' }}>
                  No universities found matching your search.
                </div>
              )}
            </div>
          ) : aiActiveTab === 'tokens' && aiTokenViewTab === 'universities' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              {aiSearch.trim().length > 0 && (
                <div style={{ marginBottom: '1rem', color: 'var(--admin-text-muted)' }}>
                  Showing search results for "{aiSearch}"
                </div>
              )}
              {filteredUniversities.length > 0 ? filteredUniversities.map(uni => (
                <div 
                  key={uni.university_id} 
                  style={{ 
                    padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.02)', transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.06)'; e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.4)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.02)'; e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.transform = 'translateY(0)'; }}
                >
                  <div style={{ flex: '1' }}>
                    <div className="font-semibold" style={{ fontSize: '1.15rem', color: 'var(--admin-text)', marginBottom: '6px' }}>
                      {uni.name}
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', gap: '2.5rem', alignItems: 'center' }}>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Current Usage</div>
                      <div style={{ fontWeight: '600', color: 'var(--admin-primary)', marginTop: '4px', fontSize: '1.05rem' }}>
                        {(uni.tokens_used || 0).toLocaleString()}
                      </div>
                      {uni.historical_tokens_used > 0 && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                          Historical: {(uni.historical_tokens_used || 0).toLocaleString()} tokens
                        </div>
                      )}
                      {uni.extra_tokens > 0 && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-primary)', marginTop: '4px', fontWeight: '500' }}>
                          +{uni.extra_tokens.toLocaleString()} Extra Tokens
                        </div>
                      )}
                      <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                        Limit: {uni.ai_token_limit != null ? uni.ai_token_limit.toLocaleString() : 'Default (global)'}
                        {uni.ai_token_limit === 0 && (
                          <div style={{ fontSize: '0.75rem', color: 'var(--admin-danger)', fontWeight: 600, marginTop: '2px' }}>
                            0 = all AI usage blocked
                          </div>
                        )}
                      </div>
                    </div>
                    
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        className="admin-mini-badge"
                        style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                        onClick={() => handleResetAiTokens(`uni_${uni.university_id}`)}
                        title="Reset Tokens"
                      >
                        Reset
                      </button>
                      <button
                        className="admin-mini-badge"
                        style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                        onClick={() => setShowAddTokensModal({ show: true, studentId: `uni_${uni.university_id}`, currentTokens: uni.tokens_used, extraTokens: uni.extra_tokens || 0, targetName: uni.name })}
                        title="Add Tokens"
                      >
                        + Add
                      </button>
                      <button
                        className="admin-mini-badge"
                        style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', border: '1px solid rgba(139, 92, 246, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                        onClick={() => {
                          setTokenLimitValue(uni.ai_token_limit != null ? String(uni.ai_token_limit) : '');
                          setClearTokenLimit(false);
                          setShowTokenLimitModal({ show: true, targetId: `uni_${uni.university_id}`, targetName: uni.name, currentLimit: uni.ai_token_limit });
                        }}
                        title="Set University-wise Token Limit"
                      >
                        Limit
                      </button>
                    </div>
                  </div>
                </div>
              )) : (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--admin-text-muted)' }}>
                  No universities found matching your search.
                </div>
              )}
            </div>
          ) : aiSearch.trim().length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ marginBottom: '1rem', color: 'var(--admin-text-muted)' }}>
                Showing search results for "{aiSearch}"
              </div>
              {filteredStudents.length > 0 ? filteredStudents.map(student => (
                <div 
                  key={student.student_id} 
                  style={{ 
                    padding: '1.25rem 1.5rem', 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    background: '#ffffff', 
                    border: '1px solid #e2e8f0', 
                    borderRadius: '12px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.02)',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.06)';
                    e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.4)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.02)';
                    e.currentTarget.style.borderColor = '#e2e8f0';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  <div style={{ flex: '1' }}>
                    <div className="font-semibold" style={{ fontSize: '1.15rem', color: 'var(--admin-text)', marginBottom: '6px' }}>
                      {student.name} <span style={{ fontSize: '0.9rem', color: 'var(--admin-text-muted)', fontWeight: 'normal', marginLeft: '8px' }}>({student.institution})</span>
                    </div>
                    <div style={{ fontSize: '0.85rem', color: 'var(--admin-text-muted)' }}>
                      Last Used: {student.last_usage ? `${String(new Date(student.last_usage).getDate()).padStart(2, '0')} ${String(new Date(student.last_usage).getMonth() + 1).padStart(2, '0')} ${new Date(student.last_usage).getFullYear()}` : 'N/A'}
                      {student.batch && <span style={{ marginLeft: '12px', paddingLeft: '12px', borderLeft: '1px solid var(--admin-border)' }}>Batch: {student.batch}</span>}
                    </div>
                  </div>
                  
                  <div style={{ display: 'flex', gap: '2.5rem', alignItems: 'center' }}>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Current Usage</div>
                      <div style={{ fontWeight: '600', color: 'var(--admin-primary)', marginTop: '4px', fontSize: '1.05rem' }}>
                        {aiActiveTab === 'tokens' 
                          ? `${(student.tokens_used || 0).toLocaleString()} `
                          : `${Math.floor((student.daily_usage_count || 0) / 60)}m ${(student.daily_usage_count || 0) % 60}s `
                        }
                        {aiActiveTab === 'minutes' && <span style={{color: 'var(--admin-text-muted)', fontWeight: '400', fontSize: '0.85em'}}>/ {student.minutes_limit ?? 60}m</span>}
                      </div>
                      {aiActiveTab === 'minutes' && student.historical_usage > 0 && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                          Historical: {`${Math.floor((student.historical_usage || 0) / 60)}m ${(student.historical_usage || 0) % 60}s`}
                        </div>
                      )}
                      {aiActiveTab === 'tokens' && student.historical_tokens_used > 0 && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                          Historical: {(student.historical_tokens_used || 0).toLocaleString()} tokens
                        </div>
                      )}
                      {aiActiveTab === 'tokens' && student.extra_tokens > 0 && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-primary)', marginTop: '4px', fontWeight: '500' }}>
                          +{student.extra_tokens.toLocaleString()} Extra Tokens
                        </div>
                      )}
                      {aiActiveTab === 'tokens' && (
                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                          Limit: {student.ai_token_limit != null ? student.ai_token_limit.toLocaleString() : 'Default (uni/global)'}
                                      {student.ai_token_limit === 0 && (
                                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-danger)', fontWeight: 600, marginTop: '2px' }}>
                                          0 = all AI usage blocked
                                        </div>
                                      )}
                        </div>
                      )}
                    </div>
                    
                    {aiActiveTab === 'tokens' ? (
                      <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                        <button
                          className="admin-btn-outline-primary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                          onClick={() => handleResetAiTokens(student.student_id)}
                          title="Reset Token Usage to 0"
                        >
                          Reset
                        </button>
                        <button
                          className="admin-btn-secondary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content', background: 'var(--admin-bg-alt)', color: 'var(--admin-text)' }}
                          onClick={() => setShowAddTokensModal({ show: true, studentId: student.student_id, currentTokens: student.tokens_used, extraTokens: student.extra_tokens || 0, targetName: student.name })}
                          title="Add Extra Token Allowance"
                        >
                          + Add
                        </button>
                        <button
                          className="admin-btn-secondary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content', background: 'rgba(139, 92, 246, 0.08)', color: '#8b5cf6' }}
                          onClick={() => {
                            setTokenLimitValue(student.ai_token_limit != null ? String(student.ai_token_limit) : '');
                            setClearTokenLimit(false);
                            setShowTokenLimitModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentLimit: student.ai_token_limit });
                          }}
                          title="Set Student-wise Token Limit"
                        >
                          Limit
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
                        <button
                          className="admin-btn-outline-primary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                          onClick={() => handleResetAiMinutes(student.student_id)}
                          title="Reset Usage Time"
                        >
                          Reset
                        </button>
                        <button
                          className="admin-btn-secondary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content', background: 'var(--admin-bg-alt)', color: 'var(--admin-text)' }}
                          onClick={() => {
                            setAddonMinutesValue("");
                            setShowAddMinutesModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentExtra: student.extra_minutes || 0, isUniversity: false });
                          }}
                          title="Allocate extra AI Agent minutes"
                        >
                          + Add
                        </button>
                        <button
                          className="admin-btn-secondary"
                          style={{ cursor: 'pointer', padding: '6px 16px', borderRadius: '8px', fontSize: '0.85rem', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content', background: 'rgba(139, 92, 246, 0.08)', color: '#8b5cf6' }}
                          onClick={() => {
                            setMinutesLimitValue(student.ai_agent_minutes_limit != null ? String(student.ai_agent_minutes_limit) : '');
                            setClearMinutesLimit(false);
                            setShowMinutesModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentLimit: student.ai_agent_minutes_limit, isUniversity: false });
                          }}
                          title="Set Student-wise Minute Limit"
                        >
                          Limit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )) : (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--admin-text-muted)' }}>No students match your search.</div>
              )}
            </div>
          ) : selectedInstitution ? (
            <div>
              <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem' }}>
                {!selectedBatch ? (
                  <button 
                    onClick={() => setSelectedInstitution(null)} 
                    className="admin-btn-secondary"
                    style={{ padding: '8px 16px', background: 'var(--admin-bg-alt)', color: 'var(--admin-text)', border: '1px solid var(--admin-border)', borderRadius: '6px', cursor: 'pointer' }}
                  >
                    &larr; Back to Universities
                  </button>
                ) : (
                  <button 
                    onClick={() => setSelectedBatch(null)} 
                    className="admin-btn-secondary"
                    style={{ padding: '8px 16px', background: 'var(--admin-bg-alt)', color: 'var(--admin-text)', border: '1px solid var(--admin-border)', borderRadius: '6px', cursor: 'pointer' }}
                  >
                    &larr; Back to Batches
                  </button>
                )}
              </div>
              <h4 style={{ marginBottom: '1rem', color: 'var(--admin-primary)', fontSize: '1.2rem', fontWeight: '600' }}>
                {selectedInstitution} {selectedBatch ? `> ${selectedBatch}` : ''}
              </h4>
              {(() => {
                const studentsInUni = studentsByInstitution[selectedInstitution] || [];
                const studentsByBatch = studentsInUni.reduce((acc, student) => {
                  const batch = student.batch || 'Unknown Batch';
                  if (!acc[batch]) acc[batch] = [];
                  acc[batch].push(student);
                  return acc;
                }, {});

                if (selectedBatch) {
                  // Level 3: Show Students for the Selected Batch
                  const students = studentsByBatch[selectedBatch] || [];
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                      {students.map(student => (
                        <div 
                          key={student.student_id} 
                          style={{ 
                            padding: '1.25rem 1.5rem', 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            background: '#ffffff', 
                            border: '1px solid #e2e8f0', 
                            borderRadius: '12px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.02)',
                            transition: 'all 0.2s ease',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.06)';
                            e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.4)';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.02)';
                            e.currentTarget.style.borderColor = '#e2e8f0';
                            e.currentTarget.style.transform = 'translateY(0)';
                          }}
                        >
                          <div style={{ flex: '1' }}>
                            <div className="font-semibold" style={{ fontSize: '1.15rem', color: 'var(--admin-text)', marginBottom: '6px' }}>{student.name}</div>
                            <div style={{ fontSize: '0.85rem', color: 'var(--admin-text-muted)' }}>
                              Last Used: {student.last_usage ? `${String(new Date(student.last_usage).getDate()).padStart(2, '0')} ${String(new Date(student.last_usage).getMonth() + 1).padStart(2, '0')} ${new Date(student.last_usage).getFullYear()}` : 'N/A'}
                            </div>
                          </div>
                          
                          <div style={{ display: 'flex', gap: '2.5rem', alignItems: 'center' }}>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Current Usage</div>
                              <div style={{ fontWeight: '600', color: 'var(--admin-primary)', marginTop: '4px', fontSize: '1.05rem' }}>
                                  {aiActiveTab === 'tokens'
                                    ? `${(student.tokens_used || 0).toLocaleString()} `
                                    : `${Math.floor((student.daily_usage_count || 0) / 60)}m ${(student.daily_usage_count || 0) % 60}s `
                                  }
                                  {aiActiveTab === 'minutes' && <span style={{color: 'var(--admin-text-muted)', fontWeight: '400', fontSize: '0.85em'}}>/ {student.minutes_limit ?? 60}m</span>}
                                </div>
                                {aiActiveTab === 'minutes' && student.historical_usage > 0 && (
                                  <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                                    Historical: {`${Math.floor((student.historical_usage || 0) / 60)}m ${(student.historical_usage || 0) % 60}s`}
                                  </div>
                                )}
                                {aiActiveTab === 'tokens' && student.historical_tokens_used > 0 && (
                                  <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                                    Historical: {(student.historical_tokens_used || 0).toLocaleString()} tokens
                                  </div>
                                )}
                                {aiActiveTab === 'tokens' && student.extra_tokens > 0 && (
                                  <div style={{ fontSize: '0.75rem', color: 'var(--admin-primary)', marginTop: '4px', fontWeight: '500' }}>
                                    +{student.extra_tokens.toLocaleString()} Extra Tokens
                                  </div>
                                )}
                                {aiActiveTab === 'tokens' && (
                                  <div style={{ fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '4px' }}>
                                    Limit: {student.ai_token_limit != null ? student.ai_token_limit.toLocaleString() : 'Default (uni/global)'}
                                      {student.ai_token_limit === 0 && (
                                        <div style={{ fontSize: '0.75rem', color: 'var(--admin-danger)', fontWeight: 600, marginTop: '2px' }}>
                                          0 = all AI usage blocked
                                        </div>
                                      )}
                                  </div>
                                )}
                            </div>
                            
                            {aiActiveTab === 'tokens' ? (
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => handleResetAiTokens(student.student_id)}
                                  title="Reset Tokens"
                                >
                                  Reset
                                </button>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => setShowAddTokensModal({ show: true, studentId: student.student_id, currentTokens: student.tokens_used, extraTokens: student.extra_tokens || 0, targetName: student.name })}
                                  title="Add Tokens"
                                >
                                  + Add
                                </button>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', border: '1px solid rgba(139, 92, 246, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => {
                                    setTokenLimitValue(student.ai_token_limit != null ? String(student.ai_token_limit) : '');
                                    setClearTokenLimit(false);
                                    setShowTokenLimitModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentLimit: student.ai_token_limit });
                                  }}
                                  title="Set Student-wise Token Limit"
                                >
                                  Limit
                                </button>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => handleResetAiMinutes(student.student_id)}
                                  onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(25, 211, 255, 0.2)'; }}
                                  onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(25, 211, 255, 0.1)'; }}
                                  title="Reset Usage Time"
                                >
                                  Reset
                                </button>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(25, 211, 255, 0.1)', color: 'var(--admin-primary)', border: '1px solid rgba(25, 211, 255, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => {
                                    setAddonMinutesValue("");
                                    setShowAddMinutesModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentExtra: student.extra_minutes || 0, isUniversity: false });
                                  }}
                                  title="Allocate extra AI Agent minutes"
                                >
                                  + Add
                                </button>
                                <button
                                  className="admin-mini-badge"
                                  style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6', border: '1px solid rgba(139, 92, 246, 0.3)', cursor: 'pointer', padding: '8px 16px', borderRadius: '8px', fontWeight: '500', transition: 'all 0.2s', height: 'fit-content' }}
                                  onClick={() => {
                                    setMinutesLimitValue(student.ai_agent_minutes_limit != null ? String(student.ai_agent_minutes_limit) : '');
                                    setClearMinutesLimit(false);
                                    setShowMinutesModal({ show: true, targetId: String(student.student_id), targetName: student.name, currentLimit: student.ai_agent_minutes_limit, isUniversity: false });
                                  }}
                                  title="Set Student-wise Minute Limit"
                                >
                                  Limit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                } else {
                  // Level 2: Show Batch Cards
                  return (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
                      {Object.keys(studentsByBatch).sort().map(batch => (
                        <div 
                          key={batch} 
                          style={{ 
                            padding: '1.5rem', 
                            cursor: 'pointer', 
                            transition: 'all 0.3s ease', 
                            border: '1px solid var(--admin-border)', 
                            background: 'linear-gradient(145deg, #ffffff, #f9fafb)',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                            borderRadius: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            gap: '1rem'
                          }}
                          onClick={() => setSelectedBatch(batch)}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-4px)';
                            e.currentTarget.style.boxShadow = '0 12px 20px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -5px rgba(0, 0, 0, 0.04)';
                            e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.3)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)';
                            e.currentTarget.style.borderColor = 'var(--admin-border)';
                          }}
                        >
                          <div style={{
                            backgroundColor: 'rgba(25, 211, 255, 0.05)',
                            color: 'var(--admin-primary)',
                            padding: '16px',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '0.5rem'
                          }}>
                            <Users size={32} />
                          </div>
                          <h4 style={{ color: 'var(--admin-text)', fontSize: '1.15rem', fontWeight: '700', margin: '0' }}>{batch}</h4>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', width: '100%', alignItems: 'center' }}>
                            <span style={{ 
                              background: 'var(--admin-primary)', 
                              color: '#fff', 
                              padding: '6px 16px', 
                              borderRadius: '20px', 
                              fontSize: '0.9rem', 
                              fontWeight: '600',
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}>
                              <Users size={14} /> {studentsByBatch[batch].length} Student{studentsByBatch[batch].length !== 1 ? 's' : ''}
                            </span>
                            <button 
                              onClick={(e) => { 
                                e.stopPropagation(); 
                                if (aiActiveTab === 'tokens') {
                                  handleBulkResetAiTokensForBatch(selectedInstitution, batch);
                                } else {
                                  handleBulkResetAiUsageForBatch(selectedInstitution, batch);
                                }
                              }}
                              className="admin-btn-outline-primary"
                              style={{ width: '80%', padding: '6px', fontSize: '0.85rem', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s', marginTop: '0.25rem' }}
                            >
                              Reset All
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                }
              })()}
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem' }}>
              {Object.keys(studentsByInstitution).length > 0 ? (
                Object.keys(studentsByInstitution).map(inst => (
                  <div 
                    key={inst} 
                    style={{ 
                      padding: '1.5rem', 
                      cursor: 'pointer', 
                      transition: 'all 0.3s ease', 
                      border: '1px solid var(--admin-border)', 
                      background: 'linear-gradient(145deg, #ffffff, #f9fafb)',
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                      borderRadius: '16px',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '1.25rem'
                    }}
                    onClick={() => setSelectedInstitution(inst)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 12px 20px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -5px rgba(0, 0, 0, 0.04)';
                      e.currentTarget.style.borderColor = 'rgba(25, 211, 255, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)';
                      e.currentTarget.style.borderColor = 'var(--admin-border)';
                    }}
                  >
                    <div style={{
                      backgroundColor: 'rgba(25, 211, 255, 0.1)',
                      color: 'var(--admin-primary)',
                      padding: '12px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Building2 size={24} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ color: 'var(--admin-text)', fontSize: '1.15rem', fontWeight: '700', marginBottom: '0.5rem', lineHeight: '1.3' }}>{inst}</h4>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '0.5rem' }}>
                        <span style={{ 
                          background: 'var(--admin-bg)', 
                          color: 'var(--admin-text-muted)', 
                          padding: '4px 12px', 
                          borderRadius: '20px', 
                          fontSize: '0.85rem', 
                          fontWeight: '600',
                          border: '1px solid var(--admin-border)'
                        }}>
                          {studentsByInstitution[inst].length} Student{studentsByInstitution[inst].length !== 1 ? 's' : ''}
                        </span>
                        <button 
                          onClick={(e) => { 
                            e.stopPropagation(); 
                            const ids = studentsByInstitution[inst].map(s => s.student_id);
                            if (aiActiveTab === 'tokens') {
                              handleBulkResetAiTokens(ids);
                            } else {
                              handleBulkResetAiUsage(ids);
                            }
                          }}
                          className="admin-btn-outline-primary"
                          style={{ padding: '4px 12px', fontSize: '0.8rem', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s' }}
                        >
                          Reset All
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--admin-text-muted)', gridColumn: '1 / -1' }}>No universities found.</div>
              )}
            </div>
          )}
        </div>
        </>
        )}
      </div>
    );
  };

  const renderDashboardOverview = () => {
    if (loadingOverview || !dashboardOverview) {
      return (
        <div className="exec-dashboard-container" style={{ padding: '4rem', textAlign: 'center' }}>
          <RefreshCw size={36} className="text-blue-400" style={{ animation: 'spin 1s linear infinite', margin: '0 auto 1rem' }} />
          <h3 style={{ color: 'var(--admin-text-main)' }}>Loading Executive Command Center...</h3>
          <p style={{ color: 'var(--admin-text-muted)' }}>Aggregating real-time ecosystem statistics directly from your database.</p>
        </div>
      );
    }

    const { metrics, vetting, recent_registrations, taxonomy } = dashboardOverview;
    const totalFunnel = (vetting?.pending || 0) + (vetting?.under_review || 0) + (vetting?.scheduled || 0) + (vetting?.approved || 0) || 1;

    return (
      <div className="exec-dashboard-container">
        {/* Top Header & Actions Row */}
        <div className="exec-header-actions">
          <div className="exec-header-title">
            <h2>Ecosystem Command Center</h2>
            <span>LIVE DATABASE SYNC</span>
          </div>
          <div className="exec-quick-btn-group">
            <button
              className={`exec-refresh-btn ${loadingOverview ? 'spin' : ''}`}
              onClick={fetchDashboardOverview}
              title="Refresh Live Data"
            >
              <RefreshCw size={16} />
              <span>Refresh Metrics</span>
            </button>
            <button
              className="exec-refresh-btn"
              style={{ background: 'rgba(25, 211, 255, 0.12)', borderColor: 'var(--admin-primary)', color: 'var(--admin-primary)' }}
              onClick={() => setActiveTab('uni')}
            >
              <Building2 size={16} />
              <span>Universities ({metrics?.universities || 0})</span>
            </button>
            <button
              className="exec-refresh-btn"
              style={{ background: 'rgba(167, 139, 250, 0.12)', borderColor: '#a78bfa', color: '#a78bfa' }}
              onClick={() => setActiveTab('pop')}
            >
              <Briefcase size={16} />
              <span>Professors ({metrics?.professors || 0})</span>
            </button>
          </div>
        </div>

        {/* 4 KPI Overview Cards */}
        <div className="exec-kpi-grid">
          {/* Card 1: Total Ecosystem Users */}
          <div className="exec-kpi-card">
            <div className="exec-kpi-top">
              <div className="exec-kpi-icon-box">
                <Users size={24} />
              </div>
              <span className="exec-kpi-badge blue">Real-Time Scale</span>
            </div>
            <div>
              <CardInfoTooltip title="Total Platform Users" content="Aggregate count of all registered Universities, Professors, and Students on the platform." />
              <div className="exec-kpi-label">Total Platform Users</div>
              <div className="exec-kpi-value">{(metrics?.total_users || 0).toLocaleString()}</div>
            </div>
            <div className="exec-kpi-footer">
              <span>{metrics?.universities || 0} Unis</span>
              <span>{metrics?.professors || 0} Experts</span>
              <span>{metrics?.students || 0} Students</span>
            </div>
          </div>

          {/* Card 2: Pending Vetting / Action Items */}
          <div className="exec-kpi-card warning">
            <div className="exec-kpi-top">
              <div className="exec-kpi-icon-box">
                <Clock size={24} />
              </div>
              <span className="exec-kpi-badge yellow">Needs Attention</span>
            </div>
            <div>
              <CardInfoTooltip title="Pending Approvals" content="Number of users currently waiting for admin vetting and activation." />
              <div className="exec-kpi-label">Pending Approvals</div>
              <div className="exec-kpi-value">{(metrics?.pending_users || 0).toLocaleString()}</div>
            </div>
            <div className="exec-kpi-footer">
              <span>{vetting?.pending || 0} Vetting Apps</span>
              <button
                onClick={() => setActiveTab('pending')}
                style={{ background: 'none', border: 'none', color: '#ffd166', cursor: 'pointer', fontWeight: '700', padding: 0 }}
              >
                Review Now &rarr;
              </button>
            </div>
          </div>

          {/* Card 3: Total Students */}
          <div className="exec-kpi-card purple">
            <div className="exec-kpi-top">
              <div className="exec-kpi-icon-box">
                <GraduationCap size={24} />
              </div>
              <span className="exec-kpi-badge" style={{ background: 'rgba(167, 139, 250, 0.15)', color: '#a78bfa' }}>Student Network</span>
            </div>
            <div>
              <CardInfoTooltip title="Total Students" content="Total count of all registered students fetched dynamically from the database." />
              <div className="exec-kpi-label">Total Students</div>
              <div className="exec-kpi-value">{(metrics?.students || 0).toLocaleString()}</div>
            </div>
            <div className="exec-kpi-footer">
              <span>Live Database Sync</span>
            </div>
          </div>

          {/* Card 4: Currently Active Users */}
          <div 
            className="exec-kpi-card" 
            style={{ borderLeft: '4px solid #22d98f', position: 'relative', overflow: 'visible' }}
            onMouseEnter={() => setShowActiveUsersCard(true)}
            onMouseLeave={() => setShowActiveUsersCard(false)}
          >
            <div className="exec-kpi-top">
              <div className="exec-kpi-icon-box" style={{ background: 'rgba(34, 217, 143, 0.15)', color: '#22d98f' }}>
                <Users size={24} />
              </div>
              <span className="exec-kpi-badge" style={{ background: 'rgba(34, 217, 143, 0.15)', color: '#22d98f' }}>Live Heartbeat</span>
            </div>
            <div>
              <CardInfoTooltip title="Currently Active Users" content="Real-time count of users who have been active on the platform in the last 5 minutes." />
              <div className="exec-kpi-label">Currently Active Users</div>
              <div className="exec-kpi-value" style={{ color: '#22d98f' }}>{(metrics?.currently_active_users || 0).toLocaleString()}</div>
            </div>
            <div className="exec-kpi-footer">
              <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#22d98f' }}></div> 
                Online Now
              </span>
            </div>

            {/* Hover Breakdown Card */}
            {showActiveUsersCard && metrics?.currently_active_breakdown && Object.keys(metrics.currently_active_breakdown).length > 0 && (
              <div style={{
                position: 'absolute',
                bottom: 'calc(100% + 12px)',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                border: '1px solid rgba(34, 217, 143, 0.4)',
                borderRadius: '12px',
                padding: '16px',
                boxShadow: '0 20px 25px -5px rgba(34, 217, 143, 0.15), 0 8px 10px -6px rgba(34, 217, 143, 0.1)',
                zIndex: 100,
                width: 'max-content',
                minWidth: '220px',
                animation: 'fadeInUp 0.2s ease-out forwards'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.85rem', fontWeight: '800', color: '#059669', marginBottom: '12px', paddingBottom: '10px', borderBottom: '1px solid rgba(34, 217, 143, 0.2)' }}>
                  <Activity size={16} /> Live Breakdown
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {Object.entries(metrics.currently_active_breakdown).sort((a, b) => b[1] - a[1]).map(([role, count]) => {
                    let Icon = Users;
                    if (role === 'System Admin') Icon = ShieldCheck;
                    else if (role === 'PoP') Icon = Briefcase;
                    else if (role === 'University') Icon = Building2;
                    else if (role === 'Student') Icon = GraduationCap;
                    return (
                      <div key={role} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.85rem', color: 'var(--admin-text)' }}>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600' }}>
                          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', background: 'rgba(34, 217, 143, 0.1)', color: '#059669', borderRadius: '6px' }}>
                            <Icon size={13} />
                          </span>
                          {role}
                        </span>
                        <span style={{ background: '#10b981', color: '#fff', padding: '2px 10px', borderRadius: '12px', fontWeight: '800', fontSize: '0.75rem', boxShadow: '0 2px 4px rgba(16, 185, 129, 0.2)' }}>{count}</span>
                      </div>
                    );
                  })}
                </div>
                {/* Arrow */}
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  borderWidth: '7px',
                  borderStyle: 'solid',
                  borderColor: 'rgba(255, 255, 255, 0.95) transparent transparent transparent',
                  filter: 'drop-shadow(0 4px 3px rgba(34, 217, 143, 0.1))'
                }}></div>
              </div>
            )}
          </div>
        </div>

        {/* Middle Section: Student Enrollment Distribution by University Chart (ECharts) */}
        <div className="exec-middle-grid">
          <div className="exec-section-card">
            <div className="exec-section-header">
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <GraduationCap size={20} style={{ color: 'var(--admin-primary)' }} /> 
                Student Enrollment Distribution by University
              </h3>
              <CardInfoTooltip title="Student Distribution" content="Real-time student population breakdown across registered universities dynamically queried from the database." />
              <span style={{ fontSize: '0.8rem', color: 'var(--admin-primary)', background: 'rgba(25, 211, 255, 0.12)', padding: '4px 10px', borderRadius: '6px', fontWeight: '600' }}>
                Live DB Sync
              </span>
            </div>

            {(!dashboardOverview?.students_by_university || dashboardOverview.students_by_university.length === 0) ? (
              <div style={{ color: 'var(--admin-text-muted)', textAlign: 'center', padding: '3rem 0' }}>
                No university student records found in the database.
              </div>
            ) : (
              <div style={{ width: '100%', marginTop: '0.5rem' }}>
                <ReactECharts
                  option={{
                    backgroundColor: 'transparent',
                    tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                        type: 'shadow',
                        shadowStyle: {
                          color: 'rgba(25, 211, 255, 0.08)'
                        }
                      },
                      backgroundColor: '#0f172a',
                      borderColor: '#19D3FF',
                      borderWidth: 1.5,
                      padding: [12, 16],
                      borderRadius: 10,
                      extraCssText: 'box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);',
                      textStyle: {
                        color: '#ffffff',
                        fontSize: 13,
                        fontFamily: 'Inter, sans-serif'
                      },
                      formatter: (params) => {
                        if (!params || !params.length) return '';
                        const item = params[0];
                        return `
                          <div style="font-weight: 700; color: #19D3FF; margin-bottom: 6px; font-size: 14px; letter-spacing: -0.2px;">
                            🎓 ${item.name}
                          </div>
                          <div style="display: flex; align-items: center; gap: 8px;">
                            <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: #19D3FF; box-shadow: 0 0 8px #19D3FF;"></span>
                            <span style="color: #94a3b8; font-weight: 500;">Enrolled Students:</span>
                            <strong style="color: #ffffff; font-size: 15px; font-weight: 800;">${item.value}</strong>
                          </div>
                        `;
                      }
                    },
                    grid: {
                      top: '12%',
                      left: '3%',
                      right: '3%',
                      bottom: '5%',
                      containLabel: true
                    },
                    xAxis: {
                      type: 'category',
                      data: dashboardOverview.students_by_university.map(i => i.university),
                      axisLine: {
                        lineStyle: {
                          color: 'rgba(148, 163, 184, 0.25)',
                          width: 1.5
                        }
                      },
                      axisTick: { show: false },
                      axisLabel: {
                        show: false
                      }
                    },
                    yAxis: {
                      type: 'value',
                      minInterval: 1,
                      splitLine: {
                        lineStyle: {
                          color: 'rgba(148, 163, 184, 0.12)',
                          type: 'dashed'
                        }
                      },
                      axisLine: { show: false },
                      axisTick: { show: false },
                      axisLabel: {
                        color: '#94a3b8',
                        fontSize: 12,
                        fontWeight: 600
                      }
                    },
                    series: [
                      {
                        name: 'Students',
                        type: 'bar',
                        barWidth: Math.min(55, Math.max(30, 250 / (dashboardOverview.students_by_university.length || 1))),
                        itemStyle: {
                          borderRadius: [10, 10, 0, 0],
                          color: (params) => {
                            const colorGradients = [
                              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#19D3FF' },
                                { offset: 1, color: '#0284c7' }
                              ]),
                              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#a78bfa' },
                                { offset: 1, color: '#7c3aed' }
                              ]),
                              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#22d98f' },
                                { offset: 1, color: '#059669' }
                              ]),
                              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#ffd166' },
                                { offset: 1, color: '#d97706' }
                              ]),
                              new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#ff4f6b' },
                                { offset: 1, color: '#dc2626' }
                              ])
                            ];
                            return colorGradients[params.dataIndex % colorGradients.length];
                          },
                          shadowBlur: 12,
                          shadowColor: 'rgba(0, 0, 0, 0.2)',
                          shadowOffsetY: 4
                        },
                        label: {
                          show: true,
                          position: 'top',
                          color: '#19D3FF',
                          fontSize: 13,
                          fontWeight: 'bold',
                          formatter: '{c}'
                        },
                        emphasis: {
                          itemStyle: {
                            shadowBlur: 25,
                            shadowColor: 'rgba(25, 211, 255, 0.5)'
                          }
                        },
                        animationDuration: 1200,
                        animationEasing: 'cubicOut',
                        data: dashboardOverview.students_by_university.map(i => i.count)
                      }
                    ]
                  }}
                  style={{ height: '320px', width: '100%' }}
                />
              </div>
            )}
          </div>
        </div>

        {/* Bottom Section: Recent Registrations & Live Activity Feed */}
        <div className="exec-section-card">
          <div className="exec-section-header">
            <h3><TrendingUp size={18} style={{ color: '#06d6a0' }} /> Live Registration Feed</h3>
            <span style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)' }}>Latest Ecosystem Users</span>
          </div>
          <div className="exec-table-wrapper">
            <table className="exec-table">
              <thead>
                <tr>
                  <th>User / Institution</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Joined Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(!recent_registrations || recent_registrations.length === 0) ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', color: 'var(--admin-text-muted)', padding: '2rem' }}>No recent registrations found.</td>
                  </tr>
                ) : (
                  recent_registrations.map(user => (
                    <tr key={user.id}>
                      <td>
                        <div className="exec-user-cell">
                          <div className="exec-user-avatar">
                            {(user.name || user.email || 'U')[0].toUpperCase()}
                          </div>
                          <div className="exec-user-meta">
                            <span className="exec-user-name">{user.name || 'Unnamed User'}</span>
                            <span className="exec-user-email">{user.email}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className={`admin-badge admin-badge-${user.role === 'university' ? 'blue' : user.role === 'pop' ? 'purple' : 'green'}`}>
                          {user.role === 'pop' ? 'Professor of Practice' : user.role === 'university' ? 'University' : user.role?.toUpperCase()}
                        </span>
                      </td>
                      <td>
                        <span style={{
                          color: user.is_active ? '#06d6a0' : '#ffd166',
                          fontWeight: '600',
                          fontSize: '0.82rem',
                          background: user.is_active ? 'rgba(6, 214, 160, 0.12)' : 'rgba(255, 209, 102, 0.12)',
                          padding: '0.25rem 0.65rem',
                          borderRadius: '6px'
                        }}>
                          {user.is_active ? 'ACTIVE' : 'PENDING'}
                        </span>
                      </td>
                      <td style={{ color: 'var(--admin-text-muted)' }}>
                        {user.created_at ? new Date(user.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Recent'}
                      </td>
                      <td>
                        <button
                          className="admin-btn-outline-primary"
                          style={{ padding: '0.35rem 0.8rem', fontSize: '0.8rem' }}
                          onClick={() => setInspectUser(user)}
                        >
                          Inspect
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const handleSendBroadcast = async (e) => {
    e.preventDefault();
    if (broadcastForm.roles.length === 0 && broadcastForm.specific_emails.length === 0) {
      showToast("Please select at least one recipient cohort or specify individual emails.", "error");
      return;
    }
    if (!broadcastForm.subject.trim() || !broadcastForm.message.trim()) {
      showToast("Subject and message are required.", "error");
      return;
    }

    setIsSendingBroadcast(true);
    try {
      // Convert plain text to HTML with <br> for line breaks
      const htmlContent = broadcastForm.message.replace(/\n/g, "<br>");
      const res = await api.post('/admin/bulk-email', {
        target_roles: broadcastForm.roles,
        specific_emails: broadcastForm.specific_emails,
        subject: broadcastForm.subject,
        body_html: htmlContent
      });
      showToast(res.data.message || "Emails queued for sending.", "success");
      setBroadcastForm({ roles: [], specific_emails: [], subject: '', message: '' });
      setBroadcastUserSearchTerm('');
    } catch (err) {
      showToast(err.response?.data?.detail || "Failed to send bulk email.", "error");
    } finally {
      setIsSendingBroadcast(false);
    }
  };

  const handleRoleToggle = (role) => {
    setBroadcastForm(prev => {
      const isSelected = prev.roles.includes(role);
      const newRoles = isSelected 
        ? prev.roles.filter(r => r !== role)
        : [...prev.roles, role];
      return { ...prev, roles: newRoles };
    });
  };

  const renderBroadcastEmails = () => (
    <div className="fade-in">
      <div className="section-header" style={{ marginBottom: '24px' }}>
        <div>
          <h2>Email Broadcast</h2>
          <p>Send bulk announcements and updates to specific user groups.</p>
        </div>
      </div>

      <div style={{ background: 'var(--surface)', padding: '32px', borderRadius: '12px', border: '1px solid var(--border)' }}>
        <form onSubmit={handleSendBroadcast}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '12px', color: 'var(--text-color)' }}>
              Target Audience
            </label>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              {[
                { id: 'student', label: 'Students' },
                { id: 'university', label: 'Universities' },
                { id: 'pop', label: 'Professors of Practice' },
                { id: 'faculty', label: 'Faculty / TPOs' }
              ].map(role => (
                <label 
                  key={role.id}
                  style={{ 
                    display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 16px', 
                    border: `1px solid ${broadcastForm.roles.includes(role.id) ? 'var(--primary)' : 'var(--border)'}`, 
                    borderRadius: '8px', cursor: 'pointer', background: broadcastForm.roles.includes(role.id) ? 'rgba(59, 130, 246, 0.05)' : 'transparent',
                    transition: 'all 0.2s'
                  }}
                >
                  <input 
                    type="checkbox" 
                    checked={broadcastForm.roles.includes(role.id)}
                    onChange={() => handleRoleToggle(role.id)}
                    style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: 'var(--primary)' }}
                  />
                  <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>{role.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '8px', color: 'var(--text-color)' }}>
              Specific Users (Optional)
            </label>
            <input 
              type="text" 
              placeholder="Search by name or email..."
              value={broadcastUserSearchTerm}
              onChange={(e) => setBroadcastUserSearchTerm(e.target.value)}
              style={{ width: '100%', padding: '12px 16px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-color)', fontSize: '0.95rem' }}
            />
            {broadcastUserSearchTerm && (
               <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '8px', marginTop: '8px', maxHeight: '150px', overflowY: 'auto' }}>
                  {allUsers
                     .filter(u => u.name?.toLowerCase().includes(broadcastUserSearchTerm.toLowerCase()) || u.email?.toLowerCase().includes(broadcastUserSearchTerm.toLowerCase()))
                     .slice(0, 5)
                     .map(u => (
                        <div key={u.id} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border)' }} onClick={() => {
                           if (!broadcastForm.specific_emails.includes(u.email)) {
                              setBroadcastForm(prev => ({ ...prev, specific_emails: [...prev.specific_emails, u.email] }));
                           }
                           setBroadcastUserSearchTerm('');
                        }}>
                           <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{u.name}</div>
                           <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{u.email} ({u.role})</div>
                        </div>
                     ))
                  }
                  {allUsers.filter(u => u.name?.toLowerCase().includes(broadcastUserSearchTerm.toLowerCase()) || u.email?.toLowerCase().includes(broadcastUserSearchTerm.toLowerCase())).length === 0 && (
                     <div style={{ padding: '8px 12px', color: 'var(--text-muted)', fontSize: '0.9rem' }}>No users found.</div>
                  )}
               </div>
            )}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
               {broadcastForm.specific_emails.map(email => (
                  <span key={email} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'var(--primary)', color: '#fff', padding: '4px 10px', borderRadius: '16px', fontSize: '0.8rem' }}>
                     {email}
                     <button type="button" onClick={() => setBroadcastForm(prev => ({ ...prev, specific_emails: prev.specific_emails.filter(e => e !== email) }))} style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: '0', display: 'flex', alignItems: 'center' }}>
                        <XCircle size={14} />
                     </button>
                  </span>
               ))}
            </div>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '8px', color: 'var(--text-color)' }}>
              Subject
            </label>
            <input 
              type="text" 
              placeholder="E.g., Platform Update: New Features Available!"
              value={broadcastForm.subject}
              onChange={(e) => setBroadcastForm(prev => ({ ...prev, subject: e.target.value }))}
              style={{ width: '100%', padding: '12px 16px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-color)', fontSize: '0.95rem' }}
              required
            />
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{ display: 'block', fontSize: '0.95rem', fontWeight: '600', marginBottom: '8px', color: 'var(--text-color)' }}>
              Message
            </label>
            <textarea 
              placeholder="Write your message here. Line breaks will be preserved."
              value={broadcastForm.message}
              onChange={(e) => setBroadcastForm(prev => ({ ...prev, message: e.target.value }))}
              style={{ width: '100%', minHeight: '200px', padding: '16px', borderRadius: '8px', border: '1px solid var(--border)', background: 'var(--background)', color: 'var(--text-color)', fontSize: '0.95rem', resize: 'vertical' }}
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={isSendingBroadcast}
            style={{ 
              background: 'var(--primary)', color: '#fff', padding: '12px 32px', borderRadius: '8px', 
              fontSize: '1rem', fontWeight: '600', border: 'none', cursor: isSendingBroadcast ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', gap: '8px', opacity: isSendingBroadcast ? 0.7 : 1
            }}
          >
            {isSendingBroadcast ? 'Queueing Emails...' : (
              <>
                <Send size={18} />
                Send Broadcast
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );

  const renderEmailLogs = () => {
    const LOGS_PER_PAGE = 10;
    const filteredLogs = (emailLogs || []).filter(log => {
      if (!emailLogsSearch) return true;
      const q = emailLogsSearch.toLowerCase();
      const recipient = (log.recipient_email || '').toLowerCase();
      const university = (log.university_name || '').toLowerCase();
      const type = (log.email_type || '').toLowerCase();
      const status = (log.status || '').toLowerCase();
      return recipient.includes(q) || university.includes(q) || type.includes(q) || status.includes(q);
    });

    const totalLogs = filteredLogs.length;
    const totalPages = Math.ceil(totalLogs / LOGS_PER_PAGE) || 1;
    const currentPage = Math.min(Math.max(emailLogsPage, 1), totalPages);
    const startIndex = (currentPage - 1) * LOGS_PER_PAGE;
    const endIndex = Math.min(startIndex + LOGS_PER_PAGE, totalLogs);
    const paginatedLogs = filteredLogs.slice(startIndex, endIndex);

    return (
      <div className="admin-content-card">
        <div className="admin-card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <div>
            <h2>Email Audit Logs</h2>
            <p style={{ margin: '4px 0 0', fontSize: '13px', color: 'var(--admin-text-muted, rgba(245, 247, 250, 0.55))' }}>
              Track all system, transactional, and broadcast emails (10 logs per page).
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', width: '260px' }}>
              <Search size={15} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--admin-text-muted, rgba(245, 247, 250, 0.55))' }} />
              <input
                type="text"
                placeholder="Search recipient, university, type..."
                value={emailLogsSearch}
                onChange={(e) => {
                  setEmailLogsSearch(e.target.value);
                  setEmailLogsPage(1);
                }}
                style={{
                  width: '100%',
                  padding: '8px 12px 8px 34px',
                  borderRadius: '8px',
                  border: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                  background: 'rgba(245, 247, 250, 0.04)',
                  color: 'var(--admin-text-main, #F5F7FA)',
                  fontSize: '13px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            <button className="admin-btn-secondary" onClick={fetchEmailLogs} disabled={loadingEmailLogs} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <RefreshCw size={16} className={loadingEmailLogs ? 'spin' : ''} />
              Refresh
            </button>
          </div>
        </div>

        <div style={{ marginTop: '24px', overflowX: 'auto' }}>
          {loadingEmailLogs ? (
            <div style={{ padding: '40px', textAlign: 'center', color: 'var(--admin-text-muted)' }}>Loading logs...</div>
          ) : filteredLogs.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: 'var(--admin-text-muted)', background: 'rgba(245, 247, 250, 0.03)', borderRadius: '8px' }}>
              {emailLogsSearch ? 'No email logs matched your search.' : 'No email logs found.'}
            </div>
          ) : (
            <>
              <table className="admin-data-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Recipient</th>
                    <th>University Name</th>
                    <th>Type</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedLogs.map(log => (
                    <tr key={log.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{new Date(log.created_at).toLocaleString()}</td>
                      <td style={{ fontWeight: '500' }}>{log.recipient_email}</td>
                      <td>
                        {log.university_name ? (
                          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: 'var(--admin-text-main, #F5F7FA)', fontWeight: '500' }}>
                            <Building2 size={14} style={{ color: 'var(--admin-primary, #19D3FF)', flexShrink: 0 }} />
                            <span>{log.university_name}</span>
                          </span>
                        ) : (
                          <span style={{ color: 'var(--admin-text-muted, rgba(245, 247, 250, 0.4))' }}>—</span>
                        )}
                      </td>
                      <td><span className="admin-mini-badge">{log.email_type}</span></td>
                      <td>
                        <span className={`admin-badge admin-badge-${log.status === 'SUCCESS' || log.status === 'SENT' ? 'green' : 'red'}`}>
                          {log.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination Controls (10 logs per page) */}
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '16px 20px',
                borderTop: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                background: 'rgba(245, 247, 250, 0.02)',
                flexWrap: 'wrap',
                gap: '12px'
              }}>
                <div style={{ fontSize: '13px', color: 'var(--admin-text-muted, rgba(245, 247, 250, 0.55))' }}>
                  Showing <strong style={{ color: 'var(--admin-text-main, #F5F7FA)' }}>{totalLogs === 0 ? 0 : startIndex + 1}</strong> to <strong style={{ color: 'var(--admin-text-main, #F5F7FA)' }}>{endIndex}</strong> of <strong style={{ color: 'var(--admin-text-main, #F5F7FA)' }}>{totalLogs}</strong> email logs
                  {totalPages > 1 && (
                    <span style={{ marginLeft: '8px', color: 'var(--admin-text-muted, rgba(245, 247, 250, 0.55))', fontSize: '12px' }}>
                      (Page {currentPage} of {totalPages})
                    </span>
                  )}
                </div>

                {totalPages > 1 && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <button
                      onClick={() => setEmailLogsPage(prev => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        border: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                        background: currentPage === 1 ? 'transparent' : 'rgba(245, 247, 250, 0.05)',
                        color: currentPage === 1 ? 'var(--admin-text-muted, rgba(245, 247, 250, 0.4))' : 'var(--admin-text-main, #F5F7FA)',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        fontSize: '12px',
                        fontWeight: '600',
                        opacity: currentPage === 1 ? 0.4 : 1,
                        transition: 'all 0.2s ease'
                      }}
                      title="Previous Page"
                    >
                      <ChevronLeft size={14} /> Prev
                    </button>

                    {(() => {
                      const pages = [];
                      const maxButtons = 5;
                      let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
                      let endPage = Math.min(totalPages, startPage + maxButtons - 1);
                      if (endPage - startPage + 1 < maxButtons) {
                        startPage = Math.max(1, endPage - maxButtons + 1);
                      }

                      if (startPage > 1) {
                        pages.push(
                          <button
                            key={1}
                            onClick={() => setEmailLogsPage(1)}
                            style={{
                              minWidth: '32px',
                              height: '32px',
                              padding: '0 6px',
                              borderRadius: '6px',
                              border: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                              background: 'rgba(245, 247, 250, 0.05)',
                              color: 'var(--admin-text-main, #F5F7FA)',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}
                          >
                            1
                          </button>
                        );
                        if (startPage > 2) {
                          pages.push(<span key="start-ellipsis" style={{ color: 'var(--admin-text-muted)', padding: '0 4px', fontSize: '12px' }}>…</span>);
                        }
                      }

                      for (let p = startPage; p <= endPage; p++) {
                        const isActive = p === currentPage;
                        pages.push(
                          <button
                            key={p}
                            onClick={() => setEmailLogsPage(p)}
                            style={{
                              minWidth: '32px',
                              height: '32px',
                              padding: '0 6px',
                              borderRadius: '6px',
                              border: isActive ? '1px solid var(--admin-primary, #19D3FF)' : '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                              background: isActive ? 'var(--admin-primary, #19D3FF)' : 'rgba(245, 247, 250, 0.05)',
                              color: isActive ? '#0B0F14' : 'var(--admin-text-main, #F5F7FA)',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: isActive ? '700' : '600',
                              boxShadow: isActive ? '0 2px 8px rgba(25, 211, 255, 0.35)' : 'none',
                              transition: 'all 0.2s ease'
                            }}
                          >
                            {p}
                          </button>
                        );
                      }

                      if (endPage < totalPages) {
                        if (endPage < totalPages - 1) {
                          pages.push(<span key="end-ellipsis" style={{ color: 'var(--admin-text-muted)', padding: '0 4px', fontSize: '12px' }}>…</span>);
                        }
                        pages.push(
                          <button
                            key={totalPages}
                            onClick={() => setEmailLogsPage(totalPages)}
                            style={{
                              minWidth: '32px',
                              height: '32px',
                              padding: '0 6px',
                              borderRadius: '6px',
                              border: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                              background: 'rgba(245, 247, 250, 0.05)',
                              color: 'var(--admin-text-main, #F5F7FA)',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: '600'
                            }}
                          >
                            {totalPages}
                          </button>
                        );
                      }
                      return pages;
                    })()}

                    <button
                      onClick={() => setEmailLogsPage(prev => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        border: '1px solid var(--admin-border, rgba(245, 247, 250, 0.1))',
                        background: currentPage === totalPages ? 'transparent' : 'rgba(245, 247, 250, 0.05)',
                        color: currentPage === totalPages ? 'var(--admin-text-muted, rgba(245, 247, 250, 0.4))' : 'var(--admin-text-main, #F5F7FA)',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        fontSize: '12px',
                        fontWeight: '600',
                        opacity: currentPage === totalPages ? 0.4 : 1,
                        transition: 'all 0.2s ease'
                      }}
                      title="Next Page"
                    >
                      Next <ChevronRight size={14} />
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
    { id: 'pending', label: 'Approvals', icon: <CheckCircle size={20} />, count: pendingUsers.length },
    { id: 'accounts', label: 'Accounts', icon: <Users size={20} /> },
    { id: 'students', label: 'Students', icon: <Users size={20} /> },
    { id: 'uni', label: 'Universities', icon: <Building2 size={20} /> },
    { id: 'pop', label: 'Professors', icon: <Briefcase size={20} /> },
    { id: 'broadcast', label: 'Broadcast Emails', icon: <Send size={20} /> },
    { id: 'lms', label: 'LMS', icon: <BookOpen size={20} /> },
    { id: 'aianalytics', label: 'AI Analytics', icon: <Cpu size={20} /> },
    { id: 'taxonomy', label: 'Taxonomy', icon: <Layers size={20} /> },
    {
      id: 'moderation',
      label: 'Moderation',
      icon: <Flag size={20} />,
      count: moderationLogs.filter(l => !l.is_reviewed).length
    },
    { id: 'feedback', label: 'Feedback', icon: <MessageSquare size={20} /> },
    { id: 'email_logs', label: 'Email Logs', icon: <Mail size={20} /> },
    { id: 'audit_logs', label: 'Audit Logs', icon: <ClipboardList size={20} /> },
    { id: 'licensing', label: 'Licensing', icon: <ShieldCheck size={20} /> },
    { id: 'institution-features', label: 'Institution Features', icon: <Settings size={20} /> },
    { id: 'feature-usage', label: 'Feature Usage', icon: <Activity size={20} /> },
    { id: 'settings', label: 'Settings', icon: <Settings size={20} /> },
  ];

  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const hasAccess = (tabId) => {
    if (!currentUser || currentUser.role === 'admin' || currentUser.role === 'system_admin') return true;
    if (currentUser.role === 'support') {
      const access = currentUser.admin_dashboard_access || [];
      return access.includes(tabId);
    }
    return false;
  };

  return (
    <div className="admin-dashboard-container">
      {/* Sidebar */}
      <aside className="admin-sidebar">

        <nav className="sidebar-nav">
          {/* 1. Dashboard */}
          {hasAccess('dashboard') && (
            <button
              className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              <LayoutDashboard size={20} /> <span>Dashboard</span>
            </button>
          )}

          {/* 2. Approvals */}
          {hasAccess('pending') && (
            <button
              className={`nav-item ${activeTab === 'pending' ? 'active' : ''}`}
              onClick={() => setActiveTab('pending')}
            >
              <CheckCircle size={20} /> <span>Approvals</span>
              {pendingUsers.length > 0 && <span className="nav-badge">{pendingUsers.length}</span>}
            </button>
          )}

          {/* 3. Accounts */}
          {hasAccess('accounts') && (
            <button
              className={`nav-item ${activeTab === 'accounts' ? 'active' : ''}`}
              onClick={() => setActiveTab('accounts')}
            >
              <Users size={20} /> <span>Accounts</span>
            </button>
          )}

          {/* 4. Universities */}
          {hasAccess('uni') && (
            <button
              className={`nav-item ${activeTab === 'uni' ? 'active' : ''}`}
              onClick={() => setActiveTab('uni')}
            >
              <Building2 size={20} /> <span>Universities</span>
            </button>
          )}

          {/* 5. Professors */}
          {hasAccess('pop') && (
            <button
              className={`nav-item ${activeTab === 'pop' ? 'active' : ''}`}
              onClick={() => setActiveTab('pop')}
            >
              <Briefcase size={20} /> <span>Professors</span>
            </button>
          )}

          {/* 6. Vetting */}
          {hasAccess('vetting') && (
            <Link to="/vetting-page" className="nav-item">
              <ShieldCheck size={20} /> <span>Vetting</span>
            </Link>
          )}

          {/* 7. Compliance */}
          {hasAccess('compliance') && (
            <Link to="/compliance-dashboard" className="nav-item">
              <AlertTriangle size={20} /> <span>Compliance</span>
            </Link>
          )}

          {/* 8. Live Chat */}
          {hasAccess('chat') && (
            <Link to="/chat" className="nav-item">
              <MessageSquare size={20} /> <span>Live Chat</span>
              {unreadChatCount > 0 && <span className="nav-badge">{unreadChatCount}</span>}
            </Link>
          )}

          {/* 9. Broadcast Emails */}
          {hasAccess('broadcast') && (
            <button
              className={`nav-item ${activeTab === 'broadcast' ? 'active' : ''}`}
              onClick={() => setActiveTab('broadcast')}
            >
              <Send size={20} /> <span>Broadcast Emails</span>
            </button>
          )}

          {/* 10. LMS */}
          {hasAccess('lms') && (
            <button
              className={`nav-item ${activeTab === 'lms' ? 'active' : ''}`}
              onClick={() => setActiveTab('lms')}
            >
              <BookOpen size={20} /> <span>LMS</span>
            </button>
          )}

          {/* 11. Licensing */}
          {hasAccess('licensing') && (
            <button
              className={`nav-item ${activeTab === 'licensing' ? 'active' : ''}`}
              onClick={() => setActiveTab('licensing')}
            >
              <ShieldCheck size={20} /> <span>Licensing</span>
            </button>
          )}

          {/* 12. Institution Features (master admin only) */}
          {hasAccess('institution-features') && (
            <button
              className={`nav-item ${activeTab === 'institution-features' ? 'active' : ''}`}
              onClick={() => setActiveTab('institution-features')}
            >
              <Settings size={20} /> <span>Institution Features</span>
            </button>
          )}

          {/* 13. Feature Usage Tracker */}
          {hasAccess('feature-usage') && (
            <button
              className={`nav-item ${activeTab === 'feature-usage' ? 'active' : ''}`}
              onClick={() => setActiveTab('feature-usage')}
            >
              <Activity size={20} /> <span>Feature Usage</span>
            </button>
          )}

          {hasAccess('service-desk') && (
            <button
              className={`nav-item ${activeTab === 'service-desk' ? 'active' : ''}`}
              onClick={() => setActiveTab('service-desk')}
            >
              <Headset size={20} /> <span>Service Desk</span>
              {unreadTicketCount > 0 && <span className="nav-badge">{unreadTicketCount}</span>}
            </button>
          )}



          {/* 16. Feedback */}
          {hasAccess('feedback') && (
            <button
              className={`nav-item ${activeTab === 'feedback' ? 'active' : ''}`}
              onClick={() => setActiveTab('feedback')}
            >
              <MessageSquare size={20} /> <span>Feedback</span>
            </button>
          )}

          {/* Email Logs */}
          {hasAccess('email_logs') && (
            <button
              className={`nav-item ${activeTab === 'email_logs' ? 'active' : ''}`}
              onClick={() => setActiveTab('email_logs')}
            >
              <Mail size={20} /> <span>Email Logs</span>
            </button>
          )}

          {(currentUser.role === 'admin' || currentUser.role === 'system_admin') && (
            <button
              className={`nav-item ${activeTab === 'audit_logs' ? 'active' : ''}`}
              onClick={() => setActiveTab('audit_logs')}
            >
              <ClipboardList size={20} /> <span>Audit Logs</span>
            </button>
          )}

          {/* 11. AI Analytics */}
          {hasAccess('aianalytics') && (
            <button
              className={`nav-item ${activeTab === 'aianalytics' ? 'active' : ''}`}
              onClick={() => setActiveTab('aianalytics')}
            >
              <Cpu size={20} /> <span>AI Analytics</span>
            </button>
          )}

          {/* 12. Taxonomy */}
          {hasAccess('taxonomy') && (
            <button
              className={`nav-item ${activeTab === 'taxonomy' ? 'active' : ''}`}
              onClick={() => setActiveTab('taxonomy')}
            >
              <Layers size={20} /> <span>Taxonomy</span>
            </button>
          )}

          {/* 13. Contact Forms */}
          {hasAccess('messages') && (
            <Link to="/admin/messages" className="nav-item">
              <Mail size={20} /> <span>Contact Forms</span>
            </Link>
          )}

          {/* 14. Moderation */}
          {hasAccess('moderation') && (
            <button
              className={`nav-item ${activeTab === 'moderation' ? 'active' : ''}`}
              onClick={() => setActiveTab('moderation')}
            >
              <Flag size={20} /> <span>Moderation</span>
              {(moderationLogs.filter(l => !l.is_reviewed).length + contentReports.filter(r => r.status === 'PENDING').length) > 0 && (
                <span className="nav-badge">
                  {moderationLogs.filter(l => !l.is_reviewed).length + contentReports.filter(r => r.status === 'PENDING').length}
                </span>
              )}
            </button>
          )}

          {/* 15. Reports 
          <Link to="/admin/reports" className="nav-item">
            <FileText size={20} /> <span>Reports</span>
          </Link>
          */}

          {/* Settings tab removed, now in AI Analytics */}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="admin-main-content">
        <header className="page-header">
          <div className="header-title">
            <h1>{navItems.find(i => i.id === activeTab)?.label || 'Dashboard'}</h1>
            <p>Manage your platform ecosystem</p>
          </div>
          <div className="header-user" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div className="admin-avatar">A</div>
            <span>Administrator</span>
          </div>
        </header>

        <div className="content-scroll-area">
          {activeTab === 'dashboard' && renderDashboardOverview()}
          {activeTab === 'broadcast' && renderBroadcastEmails()}
          {activeTab === 'pending' && (
            <div className="admin-grid-layout admin-list-view">
              {pendingUsers.length === 0 && (
                <div className="admin-empty-state">
                  <div className="empty-icon"><CheckCircle size={48} className="text-green-500" /></div>
                  <h3>All Caught Up!</h3>
                  <p>There are no pending approvals at this time.</p>
                </div>
              )}
              {pendingUsers.map(user => (
                <div key={user.id} className={`admin-card admin-pending-row ${user.is_flagged ? 'admin-flagged-card' : ''}`}>
                  <div className="admin-pending-info">
                    <div className="admin-user-header">
                      <span className={`admin-badge admin-badge-${user.role === 'university' ? 'blue' : 'purple'}`}>
                        {user.role}
                      </span>
                      <span className="admin-user-email">{user.email}</span>
                    </div>

                    <h3 className="admin-user-name">
                      {user.is_flagged && <Flag size={14} className="text-red-500 mr-2" />}
                      {user.details}
                    </h3>

                    {user.role === 'university' && user.contact_person && (
                      <div className="admin-pro-context">
                        <p className="admin-job-info">
                          <Users size={14} /> <strong>Contact:</strong> {user.contact_person}
                        </p>
                        <p className="admin-user-extra">{user.extra_info}</p>
                      </div>
                    )}

                    {user.role === 'pop' && (
                      <div className="admin-pro-context">
                        <p className="admin-job-info">
                          <Briefcase size={14} /> <strong>{user.job_title}</strong> at <strong>{user.company}</strong>
                        </p>

                        <div className="admin-classification-labels">
                          <span className="admin-mini-tag"> Domain: {user.selected_domain || "Not Set"}</span>
                          <span className="admin-mini-tag"> Exp: {user.selected_seniority || 0} Years</span>
                        </div>
                        {(user.expertise_category || user.expertise_subcategory || user.expertise_core) && (
                          <div className="admin-classification-labels" style={{ marginTop: '8px' }}>
                            {user.expertise_category && <span className="admin-mini-tag">Cat: {user.expertise_category}</span>}
                            {user.expertise_subcategory && <span className="admin-mini-tag">Sub: {user.expertise_subcategory}</span>}
                            {user.expertise_core && <span className="admin-mini-tag">Core: {user.expertise_core}</span>}
                          </div>
                        )}
                        <div className="admin-skill-badges">
                          {user.raw_expertise?.split(', ').map(s => <span key={s} className="admin-mini-badge">{s}</span>)}
                        </div>
                      </div>
                    )}

                    <div className="admin-link-row">
                      {user.role === 'pop' && <Link to={`/admin/professor/${user.id}`} className="admin-link-btn highlight">View Full Profile</Link>}
                      {user.linkedin && <a href={/^https?:\/\//i.test(user.linkedin) ? user.linkedin : `https://${user.linkedin}`} target="_blank" rel="noreferrer" className="admin-link-btn">LinkedIn</a>}
                      {user.resume && <a href={user.resume} target="_blank" rel="noreferrer" className="admin-link-btn">Resume</a>}
                    </div>
                  </div>

                  <div className="admin-action-buttons">
                    <button className="admin-btn-primary" onClick={() => handleApprove(user.id)}>
                      <CheckCircle size={16} /> Approve
                    </button>
                    <button
                      className={`admin-btn-warning ${user.is_flagged ? 'active' : ''}`}
                      onClick={() => handleFlag(user.id)}
                    >
                      <Flag size={16} /> {user.is_flagged ? "Unflag" : "Flag"}
                    </button>
                    <button className="admin-btn-danger" onClick={() => handleReject(user.id)}>
                      <XCircle size={16} /> Reject
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'accounts' && (
            <div className="admin-accounts-section">
              <div className="accounts-tabs">
                <button
                  className={accountsTab === 'requests' ? 'admin-pill-tab active' : 'admin-pill-tab'}
                  onClick={() => setAccountsTab('requests')}
                >
                  Requests ({deactivationRequests.length})
                </button>
                <button
                  className={accountsTab === 'all_pop' ? 'admin-pill-tab active' : 'admin-pill-tab'}
                  onClick={() => setAccountsTab('all_pop')}
                >
                  Professors ({allUsers.filter(u => u.role === 'pop').length})
                </button>
                <button
                  className={accountsTab === 'all_uni' ? 'admin-pill-tab active' : 'admin-pill-tab'}
                  onClick={() => setAccountsTab('all_uni')}
                >
                  Universities ({allUsers.filter(u => u.role === 'university').length})
                </button>
                <button
                  className={accountsTab === 'create_user' ? 'admin-pill-tab active' : 'admin-pill-tab'}
                  onClick={() => {
                    setAccountsTab('create_user');
                    fetchCreatedUsers();
                    fetchUniversitiesList();
                  }}
                >
                  + Create User
                </button>

              </div>

              {accountsTab === 'requests' && (
                <div className="admin-grid-layout admin-list-view">
                  {deactivationRequests.length === 0 ? (
                    <div className="admin-empty-state">
                      <div className="empty-icon"><Users size={40} /></div>
                      <h3>No requests</h3>
                      <p>No account deactivation requests pending.</p>
                    </div>
                  ) : (
                    deactivationRequests.map(req => (
                      <div key={req.id} className="admin-card">
                        <div className="admin-user-info">
                          <div className="admin-user-header">
                            <span className={`admin-badge admin-badge-${req.role}`}>
                              {req.role}
                            </span>
                            <span className="admin-user-email">{req.email}</span>
                          </div>
                          <h3>{req.full_name}</h3>
                          <p className="admin-reason-text"><strong>Reason:</strong> {req.reason}</p>
                          <p className="admin-user-extra">Requested: {new Date(req.requested_at).toLocaleDateString()}</p>
                        </div>
                        <div className="admin-action-buttons horizontal">
                          <button className="admin-btn-primary" onClick={() => handleDeactivationDecision(req.id, 'APPROVED')}>
                            Approve
                          </button>
                          <button className="admin-btn-danger" onClick={() => {
                            setRejectModal({ show: true, requestId: req.id });
                            setRejectReason("");
                          }}>
                            Reject
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              )}

              {accountsTab === 'create_user' && (
                <div style={{ padding: '20px 0' }}>
                  {/* Create User Form */}
                  <div style={{
                    background: 'var(--bg-card)',
                    border: '1px solid var(--border)',
                    borderRadius: '12px',
                    padding: '28px',
                    marginBottom: '32px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.03)'
                  }}>
                    <h3 style={{ margin: '0 0 24px 0', fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Users size={22} style={{ color: 'var(--primary)' }} />
                      {editingUserId ? 'Edit User' : 'Create New User'}
                    </h3>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                      {/* Full Name */}
                      <div>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '8px' }}>
                          Full Name *
                        </label>
                        <input
                          type="text"
                          value={newUserForm.full_name}
                          onChange={(e) => setNewUserForm(prev => ({ ...prev, full_name: e.target.value }))}
                          placeholder="Enter full name"
                          style={{
                            width: '100%', padding: '12px 14px', borderRadius: '8px',
                            border: '1px solid var(--border)', fontSize: '0.95rem',
                            background: 'var(--bg-main)', color: 'var(--text-main)',
                            boxSizing: 'border-box'
                          }}
                        />
                      </div>

                      {/* Email */}
                      <div>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '8px' }}>
                          Email (Username) *
                        </label>
                        <input
                          type="email"
                          value={newUserForm.email}
                          onChange={(e) => setNewUserForm(prev => ({ ...prev, email: e.target.value }))}
                          placeholder="user@example.com"
                          style={{
                            width: '100%', padding: '12px 14px', borderRadius: '8px',
                            border: '1px solid var(--border)', fontSize: '0.95rem',
                            background: 'var(--bg-main)', color: 'var(--text-main)',
                            boxSizing: 'border-box'
                          }}
                        />
                      </div>

                      {/* Password */}
                      <div>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '8px' }}>
                          Password *
                        </label>
                        <div style={{ position: 'relative', display: 'flex', gap: '8px' }}>
                          <input
                            type={showPassword ? 'text' : 'password'}
                            value={newUserForm.password}
                            onChange={(e) => setNewUserForm(prev => ({ ...prev, password: e.target.value }))}
                            placeholder="Min 8 characters"
                            style={{
                              flex: 1, padding: '12px 14px', borderRadius: '8px',
                              border: '1px solid var(--border)', fontSize: '0.95rem',
                              background: 'var(--bg-main)', color: 'var(--text-main)',
                              boxSizing: 'border-box'
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              padding: '12px', background: 'var(--bg-main)', border: '1px solid var(--border)',
                              borderRadius: '8px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                              color: 'var(--text-muted)', whiteSpace: 'nowrap'
                            }}
                          >
                            {showPassword ? 'Hide' : 'Show'}
                          </button>
                          <button
                            type="button"
                            onClick={generatePassword}
                            style={{
                              padding: '12px', background: 'var(--primary)', border: 'none',
                              borderRadius: '8px', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 600,
                              color: '#fff', whiteSpace: 'nowrap'
                            }}
                          >
                            Generate
                          </button>
                        </div>
                      </div>

                      {/* Role */}
                      <div>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '8px' }}>
                          Role *
                        </label>
                        <select
                          value={newUserForm.role}
                          onChange={(e) => setNewUserForm(prev => ({ ...prev, role: e.target.value }))}
                          style={{
                            width: '100%', padding: '12px 14px', borderRadius: '8px',
                            border: '1px solid var(--border)', fontSize: '0.95rem',
                            background: 'var(--bg-main)', color: 'var(--text-main)',
                            boxSizing: 'border-box', cursor: 'pointer'
                          }}
                        >
                          <option value="support">Support Team</option>
                          <option value="admin">Sub-Admin</option>
                        </select>
                      </div>

                      {/* Department */}
                      <div>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '8px' }}>
                          Department / Team
                        </label>
                        <input
                          type="text"
                          value={newUserForm.department}
                          onChange={(e) => setNewUserForm(prev => ({ ...prev, department: e.target.value }))}
                          placeholder="e.g. Support, Operations"
                          style={{
                            width: '100%', padding: '12px 14px', borderRadius: '8px',
                            border: '1px solid var(--border)', fontSize: '0.95rem',
                            background: 'var(--bg-main)', color: 'var(--text-main)',
                            boxSizing: 'border-box'
                          }}
                        />
                      </div>
                    </div>

                    {/* University Access Mapping */}
                    <div style={{ marginTop: '24px' }}>
                      <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '12px' }}>
                        <Building2 size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} />
                        University Access (Leave empty for platform-wide access)
                      </label>
                      <div style={{
                        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '10px',
                        background: 'var(--bg-main)', padding: '16px', borderRadius: '10px',
                        border: '1px solid var(--border)', maxHeight: '200px', overflowY: 'auto'
                      }}>
                        {universitiesList.length === 0 ? (
                          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', margin: 0, gridColumn: '1 / -1' }}>
                            No universities found
                          </p>
                        ) : (
                          universitiesList.map(uni => (
                            <label
                              key={uni.id}
                              style={{
                                display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px',
                                background: (newUserForm.university_ids || []).includes(uni.id) ? 'rgba(14, 165, 233, 0.08)' : 'var(--bg-card)',
                                border: (newUserForm.university_ids || []).includes(uni.id) ? '2px solid var(--primary)' : '1px solid var(--border)',
                                borderRadius: '8px', cursor: 'pointer', transition: 'all 0.15s ease',
                                fontSize: '0.85rem', fontWeight: 500, color: 'var(--text-main)'
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={(newUserForm.university_ids || []).includes(uni.id)}
                                onChange={() => toggleUniversity(uni.id)}
                                style={{ width: '16px', height: '16px', accentColor: 'var(--primary)' }}
                              />
                              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {uni.institution_name}
                              </span>
                            </label>
                          ))
                        )}
                      </div>
                    </div>

                    {/* Admin Dashboard Access (Support Role Only) */}
                    {(newUserForm.role === 'support' || newUserForm.role === 'admin') && (
                      <div style={{ marginTop: '24px' }}>
                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)', marginBottom: '12px' }}>
                          <LayoutDashboard size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} />
                          Admin Dashboard Access (Specific Tabs)
                        </label>
                        <div style={{
                          display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '10px',
                          background: 'var(--bg-main)', padding: '16px', borderRadius: '10px',
                          border: '1px solid var(--border)'
                        }}>
                          {[
                            { id: 'dashboard', label: 'Dashboard' },
                            { id: 'pending', label: 'Approvals' },
                            { id: 'accounts', label: 'Accounts' },
                            { id: 'students', label: 'Students' },
                            { id: 'uni', label: 'Universities' },
                            { id: 'pop', label: 'Professors' },
                            { id: 'vetting', label: 'Vetting' },
                            { id: 'compliance', label: 'Compliance' },
                            { id: 'chat', label: 'Live Chat' },
                            { id: 'broadcast', label: 'Broadcast Emails' },
                            { id: 'lms', label: 'LMS' },
                            { id: 'aianalytics', label: 'AI Analytics' },
                            { id: 'taxonomy', label: 'Taxonomy' },
                            { id: 'moderation', label: 'Moderation' },
                            { id: 'feedback', label: 'Feedback' },
                            { id: 'licensing', label: 'Licensing' },
                            { id: 'service-desk', label: 'Service Desk' },
                            { id: 'messages', label: 'Contact Forms' }
                          ].map(tab => (
                            <label
                              key={tab.id}
                              style={{
                                display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 14px',
                                background: (newUserForm.admin_dashboard_access || []).includes(tab.id) ? 'rgba(14, 165, 233, 0.08)' : 'var(--bg-card)',
                                border: (newUserForm.admin_dashboard_access || []).includes(tab.id) ? '2px solid var(--primary)' : '1px solid var(--border)',
                                borderRadius: '8px', cursor: 'pointer', transition: 'all 0.15s ease',
                                fontSize: '0.85rem', fontWeight: 500, color: 'var(--text-main)'
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={(newUserForm.admin_dashboard_access || []).includes(tab.id)}
                                onChange={() => toggleDashboardAccess(tab.id)}
                                style={{ width: '16px', height: '16px', accentColor: 'var(--primary)' }}
                              />
                              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {tab.label}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Submit Button */}
                    <div style={{ marginTop: '24px', display: 'flex', flexDirection: 'column' }}>
                      <button
                        onClick={handleCreateUser}
                        disabled={isCreatingUser}
                        style={{
                          width: '100%', padding: '14px', borderRadius: '10px', fontSize: '1rem', fontWeight: 600,
                          background: 'var(--primary)', color: 'white', border: 'none', cursor: isCreatingUser ? 'not-allowed' : 'pointer',
                          display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px',
                          opacity: isCreatingUser ? 0.7 : 1, transition: 'all 0.2s'
                        }}
                      >
                        {isCreatingUser ? <RefreshCw size={18} className="spin" /> : <CheckCircle size={18} />}
                        {isCreatingUser ? (editingUserId ? 'Saving...' : 'Creating...') : (editingUserId ? 'Save Changes' : 'Create User')}
                      </button>
                      {editingUserId && (
                        <button
                          onClick={cancelEdit}
                          style={{
                            width: '100%', padding: '14px', borderRadius: '10px', fontSize: '1rem', fontWeight: 600,
                            background: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border)', cursor: 'pointer',
                            marginTop: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px',
                          }}
                        >
                          Cancel Edit
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Created Users List */}
                  <div>
                    <h3 style={{ margin: '0 0 16px 0', fontSize: '1.15rem', fontWeight: 700, color: 'var(--text-main)' }}>
                      Created Users ({createdUsers.length})
                    </h3>
                    {createdUsers.length === 0 ? (
                      <div style={{
                        textAlign: 'center', padding: '48px 24px', background: 'var(--bg-card)',
                        border: '1px solid var(--border)', borderRadius: '12px'
                      }}>
                        <Users size={48} style={{ color: 'var(--text-muted)', marginBottom: '12px' }} />
                        <h4 style={{ color: 'var(--text-main)', margin: '0 0 8px 0' }}>No users created yet</h4>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', margin: 0 }}>
                          Create your first sub-admin or support team member above.
                        </p>
                      </div>
                    ) : (
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '16px' }}>
                        {createdUsers.map(user => {
                          const isTargetMainAdmin = user.role === 'system_admin';
                          const isCurrentUserMainAdmin = currentUser?.role === 'system_admin';
                          const canModify = user.id !== currentUser?.id && (
                            isCurrentUserMainAdmin ||
                            (currentUser?.role === 'admin' && !isTargetMainAdmin) ||
                            (currentUser?.role === 'support' && user.role === 'support')
                          );

                          return (
                          <div
                            key={user.id}
                            style={{
                              background: 'var(--bg-card)', border: '1px solid var(--border)',
                              borderRadius: '12px', padding: '20px',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                            }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                              <div>
                                <span style={{
                                  display: 'inline-block', padding: '3px 10px', borderRadius: '12px',
                                  fontSize: '11px', fontWeight: 700, textTransform: 'uppercase',
                                  background: user.role === 'system_admin' ? 'rgba(239, 68, 68, 0.1)' : user.role === 'admin' ? 'rgba(139, 92, 246, 0.1)' : 'rgba(16, 185, 129, 0.1)',
                                  color: user.role === 'system_admin' ? '#ef4444' : user.role === 'admin' ? '#8b5cf6' : '#10b981'
                                }}>
                                  {user.role === 'system_admin' ? 'Main Admin' : user.role === 'admin' ? 'Sub-Admin' : 'Support'}
                                </span>
                                <span style={{
                                  marginLeft: '8px', padding: '3px 10px', borderRadius: '12px',
                                  fontSize: '11px', fontWeight: 700,
                                  background: user.is_active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                                  color: user.is_active ? '#10b981' : '#ef4444'
                                }}>
                                  {user.is_active ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                            </div>
                            <h4 style={{ margin: '0 0 4px 0', fontSize: '1rem', fontWeight: 700, color: 'var(--text-main)' }}>
                              {user.name || 'Unnamed'}
                            </h4>
                            <p style={{ margin: '0 0 4px 0', fontSize: '0.85rem', color: 'var(--text-muted)' }}>
                              {user.email}
                            </p>
                            {user.department && (
                              <p style={{ margin: '0 0 4px 0', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                                Dept: {user.department}
                              </p>
                            )}
                            {user.universities && user.universities.length > 0 && (
                              <div style={{ margin: '8px 0 0 0', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                {user.universities.slice(0, 3).map(uni => (
                                  <span key={uni.id} style={{
                                    padding: '2px 8px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: 600,
                                    background: 'rgba(14, 165, 233, 0.1)', color: 'var(--primary)',
                                    display: 'inline-flex', alignItems: 'center', gap: '4px'
                                  }}>
                                    <Building2 size={10} />
                                    {uni.name.length > 20 ? uni.name.substring(0, 20) + '...' : uni.name}
                                  </span>
                                ))}
                                {user.universities.length > 3 && (
                                  <span style={{
                                    padding: '2px 8px', borderRadius: '10px', fontSize: '0.7rem', fontWeight: 600,
                                    background: 'var(--bg-main)', color: 'var(--text-muted)'
                                  }}>
                                    +{user.universities.length - 3} more
                                  </span>
                                )}
                              </div>
                            )}
                            {user.created_at && (
                              <p style={{ margin: '8px 0 0 0', fontSize: '0.75rem', color: 'var(--text-muted)' }}>
                                Created: {new Date(user.created_at).toLocaleDateString('en-GB')}
                              </p>
                            )}
                            <div style={{ display: 'flex', gap: '8px', marginTop: '14px', borderTop: '1px solid var(--border)', paddingTop: '14px' }}>
                              <button
                                onClick={() => handleEditClick(user)}
                                disabled={!canModify}
                                style={{
                                  flex: 1, padding: '8px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 600,
                                  border: '1px solid var(--border)', cursor: canModify ? 'pointer' : 'not-allowed',
                                  background: 'var(--bg-main)', color: 'var(--text-main)', opacity: canModify ? 1 : 0.5
                                }}
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => handleToggleCreatedUserStatus(user.id)}
                                disabled={!canModify}
                                style={{
                                  flex: 1, padding: '8px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 600,
                                  border: '1px solid var(--border)', cursor: canModify ? 'pointer' : 'not-allowed',
                                  background: user.is_active ? '#fef2f2' : '#d1fae5',
                                  color: user.is_active ? '#ef4444' : '#10b981', opacity: canModify ? 1 : 0.5
                                }}
                              >
                                {user.is_active ? 'Deactivate' : 'Activate'}
                              </button>
                              <button
                                onClick={() => handleDeleteCreatedUser(user.id)}
                                disabled={!canModify}
                                style={{
                                  flex: 1, padding: '8px', borderRadius: '8px', fontSize: '0.8rem', fontWeight: 600,
                                  border: '1px solid #fca5a5', cursor: canModify ? 'pointer' : 'not-allowed',
                                  background: '#fef2f2', color: '#ef4444', opacity: canModify ? 1 : 0.5
                                }}
                              >
                                <Trash2 size={13} style={{ verticalAlign: 'middle', marginRight: '4px' }} />
                                Delete
                              </button>
                            </div>
                          </div>
                        );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {['all_pop', 'all_uni'].includes(accountsTab) && (() => {
                const roleMap = {
                  'all_pop': 'pop',
                  'all_uni': 'university',
                  'all_student': 'student',
                  'all_faculty': 'faculty'
                };
                const currentRole = roleMap[accountsTab];
                const users = allUsers.filter(u => u.role === currentRole);

                if (users.length === 0) {
                  return (
                    <div className="admin-empty-state">
                      <div className="empty-icon"><Users size={40} /></div>
                      <h3>No Users Found</h3>
                      <p>There are no active {currentRole}s registered yet.</p>
                    </div>
                  );
                }

                if (currentRole === 'university') {
                  const activeUnis = users.filter(u => u.status !== 'Deleted');
                  const inactiveUnis = users.filter(u => u.status === 'Deleted');

                  const renderCard = (user, isInactive) => (
                    <div
                      key={user.id}
                      className="admin-card compact"
                      style={{ cursor: 'pointer' }}
                      onClick={() => navigate(`/admin/university/${user.id}`)}
                    >
                      <div className="admin-user-info">
                        <div className="admin-user-header">
                          <span className={`admin-badge admin-badge-${user.role}`}>
                            {user.role}
                          </span>
                          <span className={`status-dot ${!isInactive ? 'green' : 'red'}`}></span>
                          <span className="text-sm">{!isInactive ? 'Active' : 'Inactive'}</span>
                        </div>
                        <h3 className="text-md font-semibold">{user.full_name || 'Unnamed University'}</h3>
                        <p className="text-sm text-gray-500">{user.email}</p>
                      </div>
                      <button
                        className={!isInactive ? 'admin-btn-outline-danger' : 'admin-btn-outline-primary'}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isInactive) {
                            handleReactivateUniversity(user.id);
                          } else {
                            handleDeactivateUniversity(user.id);
                          }
                        }}
                      >
                        {!isInactive ? 'Deactivate' : 'Reactivate'}
                      </button>
                    </div>
                  );

                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', width: '100%' }}>
                      <div>
                        <h3 style={{ marginBottom: '1rem', color: 'var(--admin-text-primary)', fontSize: '1.2rem', fontWeight: 600 }}>Active</h3>
                        {activeUnis.length === 0 ? (
                           <div style={{ color: 'var(--admin-text-muted)' }}>No active universities found.</div>
                        ) : (
                          <div className="admin-grid-layout admin-list-view">
                            {activeUnis.map(user => renderCard(user, false))}
                          </div>
                        )}
                      </div>
                      
                      <div>
                        <h3 style={{ marginBottom: '1rem', color: 'var(--admin-text-primary)', fontSize: '1.2rem', fontWeight: 600 }}>Inactive</h3>
                        {inactiveUnis.length === 0 ? (
                           <div style={{ color: 'var(--admin-text-muted)' }}>No inactive universities found.</div>
                        ) : (
                          <div className="admin-grid-layout admin-list-view">
                            {inactiveUnis.map(user => renderCard(user, true))}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="admin-grid-layout admin-list-view">
                    {users.map(user => (
                      <div
                        key={user.id}
                        className="admin-card compact"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          if (user.role === 'pop') navigate(`/admin/professor/${user.id}`);
                          else setSelectedUser(user);
                        }}
                      >
                        <div className="admin-user-info">
                          <div className="admin-user-header">
                            <span className={`admin-badge admin-badge-${user.role}`}>
                              {user.role}
                            </span>
                            <span className={`status-dot ${user.is_active ? 'green' : 'red'}`}></span>
                            <span className="text-sm">{user.is_active ? 'Active' : 'Inactive'}</span>
                          </div>
                          <h3 className="text-md font-semibold">{user.full_name}</h3>
                          <p className="text-sm text-gray-500">{user.email}</p>
                        </div>
                        <button
                          className={user.is_active ? 'admin-btn-outline-danger' : 'admin-btn-outline-primary'}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent card click when clicking the button
                            handleToggleStatus(user.id);
                          }}
                        >
                          {user.is_active ? 'Deactivate' : 'Activate'}
                        </button>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          )}
          {activeTab === 'students' && renderDirectoryFromUsers(studentDirectory)}

          {activeTab === 'aianalytics' && renderAiAnalytics()}

          {activeTab === 'uni' && renderDirectory('university')}
          {activeTab === 'pop' && renderPopDrillDown()}
          {activeTab === 'taxonomy' && (
            <div style={{ padding: '20px 0' }}>
              <CategoryManagement />
            </div>
          )}
          {activeTab === 'feedback' && renderFeedback()}
          {activeTab === 'email_logs' && renderEmailLogs()}
          {activeTab === 'audit_logs' && <AuditLogsPanel />}
          {activeTab === 'moderation' && renderModerationLogs()}
          {activeTab === 'lms' && <LMSCourseManager />}
          {activeTab === 'licensing' && <LicensingManagement />}
          {activeTab === 'institution-features' && <InstitutionFeaturePanel />}
          {activeTab === 'feature-usage' && <FeatureUsageTracker />}
          {activeTab === 'service-desk' && <AdminServiceDesk />}
        </div>
      </main>

      {/* Detail Modal */}
      {selectedUser && (
        <div className="admin-modal-overlay">
          <div className="admin-modal">
            <button className="admin-close-btn" onClick={() => setSelectedUser(null)}><XCircle size={24} /></button>
            <div className="modal-content-header">
              <h2>{selectedUser.details}</h2>
              <span className={`admin-badge admin-badge-${selectedUser.role}`}>{selectedUser.role}</span>
            </div>

            <div className="modal-body">
              <p><strong>Email:</strong> {selectedUser.email}</p>
              <p><strong>Info:</strong> {selectedUser.extra_info}</p>

              {selectedUser.role === 'university' && (
                <>
                  {selectedUser.tier && <p><strong>Tier:</strong> {selectedUser.tier}</p>}
                  {selectedUser.contact_person && <p><strong>Contact Person:</strong> {selectedUser.contact_person}</p>}
                </>
              )}

              <div className="admin-skill-badges">
                {selectedUser.skills?.split(', ').map(s => <span key={s} className="admin-mini-badge">{s}</span>)}
              </div>

              <div style={{ marginTop: '1rem', padding: '0.75rem', background: 'var(--engine-black)', borderRadius: '8px' }}>
                <p style={{ fontSize: '0.875rem', margin: 0 }}>
                  <strong>Status:</strong>
                  <span style={{
                    marginLeft: '0.5rem',
                    color: selectedUser.is_active ? '#16a34a' : '#dc2626',
                    fontWeight: 600
                  }}>
                    {selectedUser.is_active ? 'Active' : 'Inactive'}
                  </span>
                  {selectedUser.is_flagged && (
                    <span style={{ marginLeft: '0.5rem', color: '#ea580c', fontWeight: 600 }}>• Flagged</span>
                  )}
                </p>
                {selectedUser.violation_count > 0 && (
                  <p style={{ fontSize: '0.875rem', margin: '0.5rem 0 0', color: '#dc2626', fontWeight: 600 }}>
                    <AlertTriangle size={14} style={{ display: 'inline', marginRight: '4px' }} />
                    Moderation Violations: {selectedUser.violation_count}
                  </p>
                )}
              </div>
            </div>

            <div className="modal-actions">
              <button className={`admin-btn-warning ${selectedUser.is_flagged ? 'active' : ''}`} onClick={() => handleFlag(selectedUser.id)}>
                <Flag size={16} /> {selectedUser.is_flagged ? "Remove Flag" : "Flag User"}
              </button>
              <button
                className={selectedUser.is_active ? 'admin-btn-outline-danger' : 'admin-btn-outline-primary'}
                onClick={() => handleToggleStatus(selectedUser.id)}
              >
                {selectedUser.is_active ? 'Deactivate' : 'Activate'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {confirmModal.show && (
        <div className="admin-modal-overlay">
          <div className="admin-modal confirm-box">
            <div className="confirm-icon-wrapper">
              <AlertTriangle size={32} className="text-red-500" />
            </div>
            <h3>
              {confirmModal.type === 'content'
                ? `Remove ${confirmModal.contentType}?`
                : confirmModal.type === 'log'
                ? 'Delete Log?'
                : 'Delete User?'}
            </h3>
            <p>
              {confirmModal.type === 'content'
                ? `This will permanently remove the reported ${confirmModal.contentType} from the platform. This cannot be undone.`
                : confirmModal.type === 'log'
                ? 'This action cannot be undone. The log will be permanently removed.'
                : 'This action cannot be undone. The user will be permanently removed.'}
            </p>

            <div className="modal-actions">
              <button className="admin-btn-secondary" onClick={() => setConfirmModal({ show: false, id: null, type: 'user', contentType: null, contentId: null })}>Cancel</button>
              <button className="admin-btn-danger" onClick={confirmDelete}>Delete Permanently</button>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal (for Deactivation Requests) */}
      {rejectModal.show && (
        <div className="admin-modal-overlay">
          <div className="admin-modal confirm-box">
            <div className="confirm-icon-wrapper">
              <AlertTriangle size={32} className="text-orange-500" />
            </div>
            <h3>Reject Request?</h3>
            <p>Please provide a reason for rejecting this deactivation request.</p>
            <textarea
              className="admin-textarea"
              placeholder="Enter rejection reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              style={{ width: '100%', marginTop: '10px', height: '80px' }}
            />
            <div className="modal-actions">
              <button className="admin-btn-secondary" onClick={() => setRejectModal({ show: false, requestId: null })}>Cancel</button>
              <button
                className="admin-btn-danger"
                onClick={() => {
                  handleDeactivationDecision(rejectModal.requestId, 'REJECTED', rejectReason);
                  setRejectModal({ show: false, requestId: null });
                }}
              >
                Confirm Rejection
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notifications */}
      <div className="toast-container">
        {toasts.map(toast => (
          <div key={toast.id} className={`toast-message ${toast.type}`}>
            {toast.type === 'success' ? <CheckCircle size={18} /> : <AlertTriangle size={18} />}
            <span>{toast.message}</span>
          </div>
        ))}
      </div>
      {showAddTokensModal.show && (
        <div className="admin-modal-overlay" onClick={() => setShowAddTokensModal({ show: false, studentId: null, currentTokens: 0, extraTokens: 0, targetName: '' })}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Add Extra AI Tokens</h2>
              <button className="admin-modal-close" onClick={() => setShowAddTokensModal({ show: false, studentId: null, currentTokens: 0, extraTokens: 0, targetName: '' })}>
                <X size={20} />
              </button>
            </div>
            <div className="admin-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
              <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--admin-text-muted)' }}>
                You are adding extra tokens for <strong style={{ color: 'var(--admin-text-main)' }}>{showAddTokensModal.targetName || 'this user'}</strong>. This effectively increases their limit.
              </p>
              <div style={{ background: 'var(--admin-bg-alt)', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.9rem', color: 'var(--admin-text-muted)', fontWeight: '500' }}>Current Extra Tokens:</span>
                <span style={{ fontSize: '1.05rem', color: 'var(--admin-primary)', fontWeight: '700' }}>{showAddTokensModal.extraTokens.toLocaleString()}</span>
              </div>
              <div className="token-limit-field">
                <label htmlFor="addon-tokens-input" style={{ marginBottom: '8px', fontWeight: '600', color: 'var(--admin-text-main)' }}>
                  Number of Tokens to Add
                </label>
                <input
                  id="addon-tokens-input"
                  type="number"
                  className="admin-input"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', background: 'var(--admin-bg-alt)', color: 'var(--admin-text-main)' }}
                  placeholder="e.g. 1000"
                  value={addonTokensValue}
                  onChange={(e) => setAddonTokensValue(e.target.value)}
                />
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn-secondary" onClick={() => setShowAddTokensModal({ show: false, studentId: null, currentTokens: 0, extraTokens: 0, targetName: '' })}>Cancel</button>
              <button className="admin-btn-primary" onClick={handleAddAiTokens}>Add Tokens</button>
            </div>
          </div>
        </div>
      )}
      {showTokenLimitModal.show && (
        <div className="admin-modal-overlay" onClick={() => setShowTokenLimitModal({ show: false, targetId: null, targetName: '', currentLimit: null })}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Set AI Token Limit</h2>
              <button className="admin-modal-close" onClick={() => setShowTokenLimitModal({ show: false, targetId: null, targetName: '', currentLimit: null })}>
                <X size={20} />
              </button>
            </div>
            <div className="admin-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
              <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--admin-text-muted)' }}>
                Custom token limit for <strong style={{ color: 'var(--admin-text-main)' }}>{showTokenLimitModal.targetName}</strong>.
                {showTokenLimitModal.targetId?.startsWith('uni_')
                  ? ' This university-wise limit applies to the institution\'s pooled usage. Students without their own limit inherit it.'
                  : ' Leave empty (or tick clear) and the student inherits their university\'s limit, falling back to the global default.'}
              </p>
              <div className="token-limit-field">
                <label htmlFor="token-limit-input" style={{ marginBottom: '8px', fontWeight: '600', color: 'var(--admin-text-main)' }}>
                  Token Limit
                </label>
                <input
                  id="token-limit-input"
                  type="number"
                  min="0"
                  className="admin-input"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', background: 'var(--admin-bg-alt)', color: 'var(--admin-text-main)' }}
                  placeholder="e.g. 100000"
                  value={tokenLimitValue}
                  onChange={(e) => setTokenLimitValue(e.target.value)}
                  disabled={clearTokenLimit}
                />
                {showTokenLimitModal.currentLimit != null && (
                  <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', marginTop: '6px' }}>
                    Current override: {showTokenLimitModal.currentLimit.toLocaleString()} tokens
                  </div>
                )}
              </div>
              <label htmlFor="clear-token-limit" className="token-limit-clear-row">
                <input
                  id="clear-token-limit"
                  type="checkbox"
                  checked={clearTokenLimit}
                  onChange={(e) => setClearTokenLimit(e.target.checked)}
                />
                Clear override (inherit next level up)
              </label>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn-secondary" onClick={() => setShowTokenLimitModal({ show: false, targetId: null, targetName: '', currentLimit: null })}>Cancel</button>
              <button className="admin-btn-primary" onClick={handleSetAiTokenLimit}>{clearTokenLimit ? 'Clear Override' : 'Save Limit'}</button>
            </div>
          </div>
        </div>
      )}

      {showMinutesModal.show && (
        <div className="admin-modal-overlay" onClick={() => setShowMinutesModal({ show: false, targetId: null, targetName: '', currentLimit: null, isUniversity: false })}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Set AI Agent Minute Limit</h2>
              <button className="admin-modal-close" onClick={() => setShowMinutesModal({ show: false, targetId: null, targetName: '', currentLimit: null, isUniversity: false })}>
                <X size={20} />
              </button>
            </div>
            <div className="admin-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
              <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--admin-text-muted)' }}>
                Beyond Presence (AI Agent) minute allocation for <strong style={{ color: 'var(--admin-text-main)' }}>{showMinutesModal.targetName}</strong>.
                {showMinutesModal.isUniversity
                  ? ' This university-wise allocation applies to the institution\'s pooled minutes. Students without their own limit inherit it.'
                  : ' Leave empty (or tick clear) and the student inherits their university\'s allocation, falling back to the global default.'}
              </p>
              <div className="token-limit-field">
                <label htmlFor="minutes-limit-input" style={{ marginBottom: '8px', fontWeight: '600', color: 'var(--admin-text-main)' }}>
                  Minute Limit
                </label>
                <input
                  id="minutes-limit-input"
                  type="number"
                  min="0"
                  className="admin-input"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', background: 'var(--admin-bg-alt)', color: 'var(--admin-text-main)' }}
                  placeholder="e.g. 600"
                  value={minutesLimitValue}
                  onChange={(e) => setMinutesLimitValue(e.target.value)}
                  disabled={clearMinutesLimit}
                />
                {showMinutesModal.currentLimit != null && (
                  <div style={{ fontSize: '0.8rem', color: 'var(--admin-text-muted)', marginTop: '6px' }}>
                    Current override: {showMinutesModal.currentLimit.toLocaleString()} minutes
                  </div>
                )}
              </div>
              <label htmlFor="clear-minutes-limit" className="token-limit-clear-row">
                <input
                  id="clear-minutes-limit"
                  type="checkbox"
                  checked={clearMinutesLimit}
                  onChange={(e) => setClearMinutesLimit(e.target.checked)}
                />
                Clear override (inherit next level up)
              </label>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn-secondary" onClick={() => setShowMinutesModal({ show: false, targetId: null, targetName: '', currentLimit: null, isUniversity: false })}>Cancel</button>
              <button className="admin-btn-primary" onClick={handleSetAiMinutesLimit}>{clearMinutesLimit ? 'Clear Override' : 'Save Limit'}</button>
            </div>
          </div>
        </div>
      )}
      {showAddMinutesModal.show && (
        <div className="admin-modal-overlay" onClick={() => setShowAddMinutesModal({ show: false, targetId: null, targetName: '', currentExtra: 0, isUniversity: false })}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Allocate Extra AI Agent Minutes</h2>
              <button className="admin-modal-close" onClick={() => setShowAddMinutesModal({ show: false, targetId: null, targetName: '', currentExtra: 0, isUniversity: false })}>
                <X size={20} />
              </button>
            </div>
            <div className="admin-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '1rem', textAlign: 'left' }}>
              <p style={{ margin: 0, fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--admin-text-muted)' }}>
                You are allocating extra Beyond Presence minutes for <strong style={{ color: 'var(--admin-text-main)' }}>{showAddMinutesModal.targetName || 'this user'}</strong>. This increases the available minute allowance.
              </p>
              <div style={{ background: 'var(--admin-bg-alt)', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '0.9rem', color: 'var(--admin-text-muted)', fontWeight: '500' }}>Current Extra Minutes:</span>
                <span style={{ fontSize: '1.05rem', color: 'var(--admin-primary)', fontWeight: '700' }}>{showAddMinutesModal.currentExtra.toLocaleString()}</span>
              </div>
              <div className="token-limit-field">
                <label htmlFor="addon-minutes-input" style={{ marginBottom: '8px', fontWeight: '600', color: 'var(--admin-text-main)' }}>
                  Number of Minutes to Add
                </label>
                <input
                  id="addon-minutes-input"
                  type="number"
                  min="1"
                  className="admin-input"
                  style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--admin-border)', background: 'var(--admin-bg-alt)', color: 'var(--admin-text-main)' }}
                  placeholder="e.g. 120"
                  value={addonMinutesValue}
                  onChange={(e) => setAddonMinutesValue(e.target.value)}
                />
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn-secondary" onClick={() => setShowAddMinutesModal({ show: false, targetId: null, targetName: '', currentExtra: 0, isUniversity: false })}>Cancel</button>
              <button className="admin-btn-primary" onClick={handleAddAiMinutes}>Add Minutes</button>
            </div>
          </div>
        </div>
      )}

      {inspectUser && (
        <UserInspectDrawer 
          user={inspectUser} 
          onClose={() => setInspectUser(null)} 
          onStatusChange={() => {
            fetchPendingUsers();
            fetchDirectory();
            fetchDashboardOverview(true);
          }} 
        />
      )}
    </div>
  );
};

export default AdminDashboard;
